import * as i0 from '@angular/core';
import { Directive, Input, NgModule, EventEmitter, Component, ChangeDetectionStrategy, Output, Pipe, HostListener, InjectionToken, Injector, Injectable, Inject, ChangeDetectorRef, Optional, ContentChild, forwardRef, ContentChildren, ElementRef, HostBinding, TemplateRef, inject, ViewContainerRef } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, DecimalPipe } from '@angular/common';
import * as i2 from '@angular/cdk/menu';
import { CdkMenuModule, MENU_TRIGGER, CdkMenuTrigger } from '@angular/cdk/menu';
import * as i2$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NgControl, FormControl, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, UntypedFormArray, ControlContainer } from '@angular/forms';
import * as i1$2 from 'rxjs';
import { BehaviorSubject, Subject, combineLatest, fromEvent, of, merge, throwError } from 'rxjs';
import { map, takeUntil, startWith, tap, filter, exhaustMap, take, distinctUntilChanged, switchMap, catchError, concatMap } from 'rxjs/operators';
import { cloneDeep, isEqual, isArray } from 'lodash-es';
import { __decorate, __metadata } from 'tslib';
import { trigger, transition, style, animate, state } from '@angular/animations';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { compareDesc, compareAsc, getDaysInMonth } from 'date-fns';
import * as i17 from 'ngx-mask';
import { initialConfig, provideNgxMask, NgxMaskDirective } from 'ngx-mask';
import { HttpClient } from '@angular/common/http';

var FSWModalSizes;
(function (FSWModalSizes) {
    FSWModalSizes["S"] = "s";
    FSWModalSizes["M"] = "m";
    FSWModalSizes["L"] = "l";
    FSWModalSizes["CUSTOM"] = "custom";
})(FSWModalSizes || (FSWModalSizes = {}));

var FSWModalButtonStyles;
(function (FSWModalButtonStyles) {
    FSWModalButtonStyles["ROW_FULL"] = "row-full";
    FSWModalButtonStyles["COLUMN_FULL"] = "column-full";
    FSWModalButtonStyles["LEFT_BLOCK"] = "left-block";
    FSWModalButtonStyles["RIGHT_BLOCK"] = "right-block";
})(FSWModalButtonStyles || (FSWModalButtonStyles = {}));

var FSWModalButtonDirections;
(function (FSWModalButtonDirections) {
    FSWModalButtonDirections["RTL"] = "rtl";
    FSWModalButtonDirections["LTR"] = "ltr";
})(FSWModalButtonDirections || (FSWModalButtonDirections = {}));

class FSWModalBodyDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalBodyDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWModalBodyDirective, selector: "ng-template[fswModalBody]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalBodyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswModalBody]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWModalFooterDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalFooterDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWModalFooterDirective, selector: "ng-template[fswModalFooter]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswModalFooter]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var FSWAccordionDirections;
(function (FSWAccordionDirections) {
    FSWAccordionDirections["SUFFIX"] = "suffix";
    FSWAccordionDirections["PREFIX"] = "prefix";
})(FSWAccordionDirections || (FSWAccordionDirections = {}));

var FSWAccordionAppearances;
(function (FSWAccordionAppearances) {
    FSWAccordionAppearances["PRIMARY"] = "primary";
    FSWAccordionAppearances["LINK"] = "link";
})(FSWAccordionAppearances || (FSWAccordionAppearances = {}));

var FSWAccordionIcons;
(function (FSWAccordionIcons) {
    FSWAccordionIcons["ARROW"] = "arrow";
    FSWAccordionIcons["PLUS"] = "plus";
})(FSWAccordionIcons || (FSWAccordionIcons = {}));

class FSWAccordionBase {
    constructor() {
        this.direction = FSWAccordionDirections.SUFFIX;
        this.icon = FSWAccordionIcons.ARROW;
        this.appearance = FSWAccordionAppearances.PRIMARY;
        this.title = '';
        this.subtitle = '';
        this.maxHeight = null;
        this.expanded = true;
        this.className = 'fsw-accordion';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWAccordionBase, inputs: { direction: "direction", icon: "icon", appearance: "appearance", title: "title", subtitle: "subtitle", maxHeight: "maxHeight", expanded: "expanded" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionBase, decorators: [{
            type: Directive
        }], propDecorators: { direction: [{
                type: Input
            }], icon: [{
                type: Input
            }], appearance: [{
                type: Input
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], expanded: [{
                type: Input
            }] } });

var FSWIconCountries;
(function (FSWIconCountries) {
    FSWIconCountries["CHINA_CIRCLE_DROP_SHADOW"] = "china-circle-drop-shadow";
    FSWIconCountries["CHINA_CIRCLE_PLAIN"] = "china-circle-plain";
    FSWIconCountries["CHINA_CIRCLE_STROKE"] = "china-circle-stroke";
    FSWIconCountries["CHINA_DROP_SHADOW"] = "china-drop-shadow";
    FSWIconCountries["CHINA_PLAIN"] = "china-plain";
    FSWIconCountries["CHINA_STROKE"] = "china-stroke";
    FSWIconCountries["HONGKONG_CIRCLE_DROP_SHADOW"] = "hongkong-circle-drop-shadow";
    FSWIconCountries["HONGKONG_CIRCLE_PLAIN"] = "hongkong-circle-plain";
    FSWIconCountries["HONGKONG_CIRCLE_STROKE"] = "hongkong-circle-stroke";
    FSWIconCountries["HONGKONG_DROP_SHADOW"] = "hongkong-drop-shadow";
    FSWIconCountries["HONGKONG_PLAIN"] = "hongkong-plain";
    FSWIconCountries["HONGKONG_STROKE"] = "hongkong-stroke";
    FSWIconCountries["INDONESIA_CIRCLE_DROP_SHADOW"] = "indonesia-circle-drop-shadow";
    FSWIconCountries["INDONESIA_CIRCLE_PLAIN"] = "indonesia-circle-plain";
    FSWIconCountries["INDONESIA_CIRCLE_STROKE"] = "indonesia-circle-stroke";
    FSWIconCountries["INDONESIA_DROP_SHADOW"] = "indonesia-drop-shadow";
    FSWIconCountries["INDONESIA_PLAIN"] = "indonesia-plain";
    FSWIconCountries["INDONESIA_STROKE"] = "indonesia-stroke";
    FSWIconCountries["MALAYSIA_CIRCLE_DROP_SHADOW"] = "malaysia-circle-drop-shadow";
    FSWIconCountries["MALAYSIA_CIRCLE_PLAIN"] = "malaysia-circle-plain";
    FSWIconCountries["MALAYSIA_CIRCLE_STROKE"] = "malaysia-circle-stroke";
    FSWIconCountries["MALAYSIA_DROP_SHADOW"] = "malaysia-drop-shadow";
    FSWIconCountries["MALAYSIA_PLAIN"] = "malaysia-plain";
    FSWIconCountries["MALAYSIA_STROKE"] = "malaysia-stroke";
    FSWIconCountries["SINGAPORE_CIRCLE_DROP_SHADOW"] = "singapore-circle-drop-shadow";
    FSWIconCountries["SINGAPORE_CIRCLE_PLAIN"] = "singapore-circle-plain";
    FSWIconCountries["SINGAPORE_CIRCLE_STROKE"] = "singapore-circle-stroke";
    FSWIconCountries["SINGAPORE_DROP_SHADOW"] = "singapore-drop-shadow";
    FSWIconCountries["SINGAPORE_PLAIN"] = "singapore-plain";
    FSWIconCountries["SINGAPORE_STROKE"] = "singapore-stroke";
    FSWIconCountries["THAILAND_CIRCLE_DROP_SHADOW"] = "thailand-circle-drop-shadow";
    FSWIconCountries["THAILAND_CIRCLE_PLAIN"] = "thailand-circle-plain";
    FSWIconCountries["THAILAND_CIRCLE_STROKE"] = "thailand-circle-stroke";
    FSWIconCountries["THAILAND_DROP_SHADOW"] = "thailand-drop-shadow";
    FSWIconCountries["THAILAND_PLAIN"] = "thailand-plain";
    FSWIconCountries["THAILAND_STROKE"] = "thailand-stroke";
    FSWIconCountries["UNITED_KINGDOM_CIRCLE_DROP_SHADOW"] = "united-kingdom-circle-drop-shadow";
    FSWIconCountries["UNITED_KINGDOM_CIRCLE_PLAIN"] = "united-kingdom-circle-plain";
    FSWIconCountries["UNITED_KINGDOM_CIRCLE_STROKE"] = "united-kingdom-circle-stroke";
    FSWIconCountries["UNITED_KINGDOM_DROP_SHADOW"] = "united-kingdom-drop-shadow";
    FSWIconCountries["UNITED_KINGDOM_PLAIN"] = "united-kingdom-plain";
    FSWIconCountries["UNITED_KINGDOM_STROKE"] = "united-kingdom-stroke";
})(FSWIconCountries || (FSWIconCountries = {}));

var FSWIconFinancingProducts;
(function (FSWIconFinancingProducts) {
    FSWIconFinancingProducts["BUSINESS_TERM_FINANCING"] = "business-term-financing";
    FSWIconFinancingProducts["DEALER_FINANCING"] = "dealer-financing";
    FSWIconFinancingProducts["INVOICE_FINANCING"] = "invoice-financing";
    FSWIconFinancingProducts["MICRO_FINANCING"] = "micro-financing";
    FSWIconFinancingProducts["MICRO_CREDIT_LINE"] = "micro-credit-line";
    FSWIconFinancingProducts["PROPERTY_BACKED_SECURED_FINANCING"] = "property-backed-secured-financing";
    FSWIconFinancingProducts["REVOLVING_CREDIT_FACILITY_VIRTUAL_CREDIT"] = "revolving-credit-facility-virtual-credit";
    FSWIconFinancingProducts["SOLUTION_FINANCING"] = "solution-financing";
    FSWIconFinancingProducts["SUPPLY_CHAIN_FINANCING"] = "supply-chain-financing";
})(FSWIconFinancingProducts || (FSWIconFinancingProducts = {}));

var FSWIconCommons;
(function (FSWIconCommons) {
    FSWIconCommons["CHECK_SHORT"] = "check-short";
    FSWIconCommons["ACCOUNT"] = "account";
    FSWIconCommons["ADD"] = "add";
    FSWIconCommons["ADD_CIRCLE"] = "add-circle";
    FSWIconCommons["ANALYTICS"] = "analytics";
    FSWIconCommons["APPS_FILLED"] = "apps-filled";
    FSWIconCommons["APPS_OUTLINE"] = "apps-outline";
    FSWIconCommons["ARROW_DOWN"] = "arrow-down";
    FSWIconCommons["ARROW_DROPDOWN"] = "arrow-dropdown";
    FSWIconCommons["ARROW_LEFT"] = "arrow-left";
    FSWIconCommons["ARROW_RIGHT"] = "arrow-right";
    FSWIconCommons["ARROW_UP"] = "arrow-up";
    FSWIconCommons["ASSIGNMENT"] = "assignment";
    FSWIconCommons["ATTACHMENT"] = "attachment";
    FSWIconCommons["AUTO_INVEST"] = "auto-invest";
    FSWIconCommons["BANK_INVESTOR"] = "bank-investor";
    FSWIconCommons["BUILDING"] = "building";
    FSWIconCommons["CALCULATOR"] = "calculator";
    FSWIconCommons["CALENDAR_ALTERNATIVE"] = "calendar-alternative";
    FSWIconCommons["CALENDAR_INVESTOR"] = "calendar-investor";
    FSWIconCommons["CARD"] = "card";
    FSWIconCommons["CARD_MULTIPLE"] = "card-multiple";
    FSWIconCommons["CHART"] = "chart";
    FSWIconCommons["CHAT"] = "chat";
    FSWIconCommons["CHAT_OUTLINE"] = "chat-outline";
    FSWIconCommons["CLOSE"] = "close";
    FSWIconCommons["CLOSE_CIRCLE"] = "close-circle";
    FSWIconCommons["COPY"] = "copy";
    FSWIconCommons["COPY_FILLED"] = "copy-filled";
    FSWIconCommons["DASHBOARD"] = "dashboard";
    FSWIconCommons["DELETE"] = "delete";
    FSWIconCommons["DELETE_ALTERNATIVE"] = "delete-alternative";
    FSWIconCommons["DOCUMENT"] = "document";
    FSWIconCommons["DOCUMENT_ALTERNATIVE"] = "document-alternative";
    FSWIconCommons["DOWNLOAD"] = "download";
    FSWIconCommons["DOWNLOAD_CIRCLE"] = "download-circle";
    FSWIconCommons["DRAG"] = "drag";
    FSWIconCommons["DRAG_ALTERNATIVE"] = "drag-alternative";
    FSWIconCommons["EDIT"] = "edit";
    FSWIconCommons["EDIT_ALTERNATIVE"] = "edit-alternative";
    FSWIconCommons["ENLARGE"] = "enlarge";
    FSWIconCommons["EXTERNAL_LINK"] = "external-link";
    FSWIconCommons["FAQ_OUTLINE"] = "faq-outline";
    FSWIconCommons["FAVOURITE"] = "favourite";
    FSWIconCommons["FAVOURITE_OUTLINE"] = "favourite-outline";
    FSWIconCommons["FILTER"] = "filter";
    FSWIconCommons["FILTER_BADGE"] = "filter-badge";
    FSWIconCommons["FINGERPRINT"] = "fingerprint";
    FSWIconCommons["FULLSCREEN"] = "fullscreen";
    FSWIconCommons["FUND"] = "fund";
    FSWIconCommons["GRID_ALL"] = "grid-all";
    FSWIconCommons["HISTORY"] = "history";
    FSWIconCommons["HOME"] = "home";
    FSWIconCommons["HOME_INVESTOR"] = "home-investor";
    FSWIconCommons["INFORMATION_CIRCLE"] = "information-circle";
    FSWIconCommons["CHECK_CIRCLE"] = "check-circle";
    FSWIconCommons["WARNING_CIRCLE"] = "warning-circle";
    FSWIconCommons["LIST"] = "list";
    FSWIconCommons["LIVE_CHAT"] = "live-chat";
    FSWIconCommons["LOCK"] = "lock";
    FSWIconCommons["LOCK_OPEN"] = "lock-open";
    FSWIconCommons["LOCK_OUTLINE"] = "lock-outline";
    FSWIconCommons["LOG_OUT"] = "log-out";
    FSWIconCommons["MEGAPHONE_FILLED"] = "megaphone-filled";
    FSWIconCommons["MEGAPHONE_OUTLINE"] = "megaphone-outline";
    FSWIconCommons["MENU"] = "menu";
    FSWIconCommons["MESSAGES"] = "messages";
    FSWIconCommons["MESSAGES_BADGE"] = "messages-badge";
    FSWIconCommons["MINUS"] = "minus";
    FSWIconCommons["MORE"] = "more";
    FSWIconCommons["NOTIFICATION_BADGE_FILLED"] = "notification-badge-filled";
    FSWIconCommons["NOTIFICATION_BADGE_OUTLINE"] = "notification-badge-outline";
    FSWIconCommons["NOTIFICATION_FILLED"] = "notification-filled";
    FSWIconCommons["NOTIFICATION_OUTLINE"] = "notification-outline";
    FSWIconCommons["OVERVIEW"] = "overview";
    FSWIconCommons["PASSWORD_HIDE"] = "password-hide";
    FSWIconCommons["PASSWORD_HIDE_ALTERNATIVE"] = "password-hide-alternative";
    FSWIconCommons["PASSWORD_SHOW"] = "password-show";
    FSWIconCommons["PASSWORD_SHOW_ALTERNATIVE"] = "password-show-alternative";
    FSWIconCommons["PERSON_ADD"] = "person-add";
    FSWIconCommons["PHONE"] = "phone";
    FSWIconCommons["PHONE_ALTERNATIVE"] = "phone-alternative";
    FSWIconCommons["PRIVACY_TIP"] = "privacy-tip";
    FSWIconCommons["PROFILE"] = "profile";
    FSWIconCommons["PROFILE_INVESTOR"] = "profile-investor";
    FSWIconCommons["QUESTION_CIRCLE_FILLED"] = "question-circle-filled";
    FSWIconCommons["QUESTION_CIRCLE_OUTLINE"] = "question-circle-outline";
    FSWIconCommons["RECEIPT"] = "receipt";
    FSWIconCommons["REMOVE"] = "remove";
    FSWIconCommons["REQUEST"] = "request";
    FSWIconCommons["SEARCH"] = "search";
    FSWIconCommons["SETTINGS"] = "settings";
    FSWIconCommons["SETTINGS_OUTLINE"] = "settings-outline";
    FSWIconCommons["SHARE"] = "share";
    FSWIconCommons["SORT_DOWN"] = "sort-down";
    FSWIconCommons["SORT_UP"] = "sort-up";
    FSWIconCommons["SPARK"] = "spark";
    FSWIconCommons["THUMB_UP"] = "thumb-up";
    FSWIconCommons["TIME"] = "time";
    FSWIconCommons["UPLOAD"] = "upload";
    FSWIconCommons["UPLOAD_ALTERNATIVE"] = "upload-alternative";
    FSWIconCommons["USERS"] = "users";
    FSWIconCommons["VERIFIED"] = "verified";
    FSWIconCommons["VERIFIED_FILLED"] = "verified-filled";
    FSWIconCommons["WALLET"] = "wallet";
})(FSWIconCommons || (FSWIconCommons = {}));

var FSWIconSocials;
(function (FSWIconSocials) {
    FSWIconSocials["FACEBOOK"] = "facebook";
    FSWIconSocials["INSTAGRAM"] = "instagram";
    FSWIconSocials["LINKED_IN"] = "linkedin";
    FSWIconSocials["TWITTER"] = "twitter";
})(FSWIconSocials || (FSWIconSocials = {}));

var FSWIconStatuses;
(function (FSWIconStatuses) {
    FSWIconStatuses["CIRCULAR_PROGRESS_COMPLETING"] = "circular-progress-completing";
    FSWIconStatuses["CIRCULAR_PROGRESS_NOT_STARTED"] = "circular-progress-not-started";
    FSWIconStatuses["CIRCULAR_PROGRESS_ONGOING"] = "circular-progress-ongoing";
    FSWIconStatuses["COMPLETED"] = "completed";
    FSWIconStatuses["ERROR"] = "error";
    FSWIconStatuses["ONGOING"] = "ongoing";
    FSWIconStatuses["PERSON_SUCCESS"] = "person-success";
    FSWIconStatuses["STATUS_CIRCLE"] = "status-circle";
    FSWIconStatuses["SUCCESS"] = "success";
    FSWIconStatuses["SUCCESS_CIRCLE"] = "success-circle";
    FSWIconStatuses["SUCCESS_CIRCLE_INVESTOR"] = "success-circle-investor";
    FSWIconStatuses["WARNING_CIRCLE"] = "warning-circle";
})(FSWIconStatuses || (FSWIconStatuses = {}));

var FSWIconFolders;
(function (FSWIconFolders) {
    FSWIconFolders["COMMON"] = "common";
    FSWIconFolders["STATUS"] = "status";
    FSWIconFolders["COUNTRY"] = "country";
    FSWIconFolders["SOCIAL"] = "social";
    FSWIconFolders["FINANCING_PRODUCT"] = "financing-product";
})(FSWIconFolders || (FSWIconFolders = {}));

class FSWIconDirective {
    constructor() {
        this.name = `${FSWIconFolders.COMMON}-${FSWIconCommons.ADD}`;
        this.fontSize = null;
    }
    get path() {
        return `fsw-icon fsw-icon-${this.name}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWIconDirective, selector: "i[fswIcon]", inputs: { name: ["fswIcon", "name"], fontSize: "fontSize" }, host: { properties: { "class": "path", "style.--fsw-icon-font-size": "fontSize" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'i[fswIcon]',
                    host: {
                        '[class]': 'path',
                        '[style.--fsw-icon-font-size]': 'fontSize',
                    },
                }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['fswIcon']
            }], fontSize: [{
                type: Input
            }] } });

class FSWIconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWIconModule, declarations: [FSWIconDirective], exports: [FSWIconDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIconModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWIconDirective],
                    exports: [FSWIconDirective],
                }]
        }] });

class FSWAccordionComponent extends FSWAccordionBase {
    get isPrimary() {
        return this.appearance === FSWAccordionAppearances.PRIMARY;
    }
    constructor(_cdr) {
        super();
        this._cdr = _cdr;
        this.expandedChange = new EventEmitter();
    }
    toggle(value) {
        this.expanded = value;
        this.expandedChange.emit(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAccordionComponent, selector: "fsw-accordion", outputs: { expandedChange: "expandedChange" }, usesInheritance: true, ngImport: i0, template: "<details\n\t#detailsElement\n\tclass=\"{{ className }} {{ className }}--appearance-{{ appearance }} {{ className }}--icon-{{\n\t\ticon\n\t}} {{ className }}--direction-{{ direction }}\"\n\t[open]=\"expanded\"\n\t(toggle)=\"toggle(detailsElement.open)\"\n\t[style.--fsw-accordion-main-max-height]=\"maxHeight || 'unset'\"\n>\n\t<summary>\n\t\t<h6 *ngIf=\"title\">{{ title }}</h6>\n\t\t<small *ngIf=\"subtitle && isPrimary\"></small>\n\t</summary>\n\t<main>\n\t\t<ng-content></ng-content>\n\t</main>\n</details>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-accordion', changeDetection: ChangeDetectionStrategy.OnPush, template: "<details\n\t#detailsElement\n\tclass=\"{{ className }} {{ className }}--appearance-{{ appearance }} {{ className }}--icon-{{\n\t\ticon\n\t}} {{ className }}--direction-{{ direction }}\"\n\t[open]=\"expanded\"\n\t(toggle)=\"toggle(detailsElement.open)\"\n\t[style.--fsw-accordion-main-max-height]=\"maxHeight || 'unset'\"\n>\n\t<summary>\n\t\t<h6 *ngIf=\"title\">{{ title }}</h6>\n\t\t<small *ngIf=\"subtitle && isPrimary\"></small>\n\t</summary>\n\t<main>\n\t\t<ng-content></ng-content>\n\t</main>\n</details>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { expandedChange: [{
                type: Output
            }] } });

class AccordionGroupComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccordionGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AccordionGroupComponent, selector: "fsw-accordion-group", ngImport: i0, template: "<section class=\"fsw-accordion-group\">\n\t<ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccordionGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-accordion-group', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"fsw-accordion-group\">\n\t<ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }] });

const UI$j = [FSWAccordionComponent, AccordionGroupComponent];
class FSWAccordionModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionModule, declarations: [FSWAccordionComponent, AccordionGroupComponent], imports: [FSWIconModule, CommonModule], exports: [FSWAccordionComponent, AccordionGroupComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionModule, imports: [FSWIconModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FSWIconModule, CommonModule],
                    declarations: [UI$j],
                    exports: [UI$j],
                }]
        }] });

var FSWBadgeColors;
(function (FSWBadgeColors) {
    FSWBadgeColors["RED"] = "red";
    FSWBadgeColors["GREEN"] = "green";
    FSWBadgeColors["BLUE"] = "blue";
    FSWBadgeColors["YELLOW"] = "yellow";
    FSWBadgeColors["GRAY"] = "gray";
    FSWBadgeColors["WHITE"] = "white";
})(FSWBadgeColors || (FSWBadgeColors = {}));

class FSWBadgeBase {
    constructor() {
        this.color = FSWBadgeColors.WHITE;
        this.isDot = false;
        this.value = 0;
        this.className = 'fsw-badge';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBadgeBase, inputs: { color: "color", isDot: "isDot", value: "value" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeBase, decorators: [{
            type: Directive
        }], propDecorators: { color: [{
                type: Input
            }], isDot: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class FSWBadgeDirective extends FSWBadgeBase {
    get hostClassName() {
        return `${this.className} ${this.className}--${this.color}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWBadgeDirective, selector: "[fswBadge]", host: { properties: { "class": "hostClassName", "class.is-dot": "isDot" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswBadge]',
                    host: {
                        '[class]': 'hostClassName',
                        '[class.is-dot]': 'isDot',
                    },
                }]
        }] });

class FSWBadgeComponent extends FSWBadgeBase {
    get renderValue() {
        return Number(this.value) > 99 ? '99+' : this.value.toString();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBadgeComponent, selector: "fsw-badge", usesInheritance: true, ngImport: i0, template: "<span fswBadge [isDot]=\"isDot\" [color]=\"color\">\n\t<ng-container *ngIf=\"!isDot\">\n\t\t{{ renderValue }}\n\t</ng-container>\n</span>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWBadgeDirective, selector: "[fswBadge]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span fswBadge [isDot]=\"isDot\" [color]=\"color\">\n\t<ng-container *ngIf=\"!isDot\">\n\t\t{{ renderValue }}\n\t</ng-container>\n</span>\n", styles: [":host{display:contents}\n"] }]
        }] });

const UI$i = [FSWBadgeComponent, FSWBadgeDirective];
class FSWBadgeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeModule, declarations: [FSWBadgeComponent, FSWBadgeDirective], imports: [CommonModule], exports: [FSWBadgeComponent, FSWBadgeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [UI$i],
                    exports: [UI$i],
                }]
        }] });

class FSWBreadcrumbComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        this.clickedItem = new EventEmitter();
        this.items = [];
        this.renderItems = [];
        this.menuItems = [];
        this.className = 'fsw-breadcrumb';
    }
    ngOnChanges() {
        this._setup();
    }
    clickMenuItem(value) {
        this.clickedItem.emit(value);
    }
    _setup() {
        if (!this.items.length)
            return;
        this.renderItems = [];
        this.menuItems = [];
        if (this.items.length > 5) {
            this.renderItems.push(this.items[0]);
            this.renderItems.push({
                key: 'more',
                value: '...',
            });
            this.renderItems = this.renderItems.concat(this.items.slice(this.items.length - 3));
            this.menuItems = this.items.slice(1, this.items.length - 3);
        }
        else {
            this.renderItems = this.items;
        }
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWBreadcrumbComponent, selector: "fsw-breadcrumb", inputs: { items: "items" }, outputs: { clickedItem: "clickedItem" }, usesOnChanges: true, ngImport: i0, template: "<ul class=\"{{ className }}\">\n\t<ng-container *ngFor=\"let item of renderItems; let i = index\">\n\t\t<ng-container *ngIf=\"i !== 0\">\n\t\t\t<li>/</li>\n\t\t</ng-container>\n\t\t<ng-container *ngIf=\"item.key === 'more'; else defaultTemplate\">\n\t\t\t<li [cdkMenuTriggerFor]=\"menu\">...</li>\n\t\t\t<ng-template #menu>\n\t\t\t\t<ul class=\"{{ className }}__menu in-cdk\" cdkMenu>\n\t\t\t\t\t<ng-container *ngFor=\"let menuItem of menuItems\">\n\t\t\t\t\t\t<li class=\"{{ className }}__menu__item\" cdkMenuItem (click)=\"clickMenuItem(menuItem)\">\n\t\t\t\t\t\t\t{{ menuItem.value }}\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ul>\n\t\t\t</ng-template>\n\t\t</ng-container>\n\t\t<ng-template #defaultTemplate>\n\t\t\t<li [class.active]=\"i === renderItems.length - 1\" (click)=\"clickedItem.emit(item)\">\n\t\t\t\t{{ item.value }}\n\t\t\t</li>\n\t\t</ng-template>\n\t</ng-container>\n</ul>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CdkMenu, selector: "[cdkMenu]", outputs: ["closed"], exportAs: ["cdkMenu"] }, { kind: "directive", type: i2.CdkMenuItem, selector: "[cdkMenuItem]", inputs: ["cdkMenuItemDisabled", "cdkMenuitemTypeaheadLabel"], outputs: ["cdkMenuItemTriggered"], exportAs: ["cdkMenuItem"] }, { kind: "directive", type: i2.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"{{ className }}\">\n\t<ng-container *ngFor=\"let item of renderItems; let i = index\">\n\t\t<ng-container *ngIf=\"i !== 0\">\n\t\t\t<li>/</li>\n\t\t</ng-container>\n\t\t<ng-container *ngIf=\"item.key === 'more'; else defaultTemplate\">\n\t\t\t<li [cdkMenuTriggerFor]=\"menu\">...</li>\n\t\t\t<ng-template #menu>\n\t\t\t\t<ul class=\"{{ className }}__menu in-cdk\" cdkMenu>\n\t\t\t\t\t<ng-container *ngFor=\"let menuItem of menuItems\">\n\t\t\t\t\t\t<li class=\"{{ className }}__menu__item\" cdkMenuItem (click)=\"clickMenuItem(menuItem)\">\n\t\t\t\t\t\t\t{{ menuItem.value }}\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</ul>\n\t\t\t</ng-template>\n\t\t</ng-container>\n\t\t<ng-template #defaultTemplate>\n\t\t\t<li [class.active]=\"i === renderItems.length - 1\" (click)=\"clickedItem.emit(item)\">\n\t\t\t\t{{ item.value }}\n\t\t\t</li>\n\t\t</ng-template>\n\t</ng-container>\n</ul>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { clickedItem: [{
                type: Output
            }], items: [{
                type: Input
            }] } });

const UI$h = [FSWBreadcrumbComponent];
class FSWBreadcrumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbModule, declarations: [FSWBreadcrumbComponent], imports: [CommonModule, CdkMenuModule], exports: [FSWBreadcrumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbModule, imports: [CommonModule, CdkMenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, CdkMenuModule],
                    declarations: [UI$h],
                    exports: [UI$h],
                }]
        }] });

var FSWButtonAppearances;
(function (FSWButtonAppearances) {
    FSWButtonAppearances["PRIMARY"] = "primary";
    FSWButtonAppearances["SECONDARY"] = "secondary";
    FSWButtonAppearances["SECONDARY_ELEVATE"] = "secondary-elevate";
    FSWButtonAppearances["LINK"] = "link";
    FSWButtonAppearances["ICON_WITH_BACKGROUND"] = "icon-with-bg";
    FSWButtonAppearances["ICON_NO_BACKGROUND"] = "icon-no-bg";
})(FSWButtonAppearances || (FSWButtonAppearances = {}));

var FSWButtonSizes;
(function (FSWButtonSizes) {
    FSWButtonSizes["S"] = "s";
    FSWButtonSizes["M"] = "m";
    FSWButtonSizes["L"] = "l";
})(FSWButtonSizes || (FSWButtonSizes = {}));

class FSWButtonBase {
    constructor() {
        this.appearance = FSWButtonAppearances.PRIMARY;
        this.size = FSWButtonSizes.M;
        this.disabled = false;
        this.className = 'fsw-btn';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWButtonBase, inputs: { appearance: "appearance", size: "size", disabled: "disabled" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonBase, decorators: [{
            type: Directive
        }], propDecorators: { appearance: [{
                type: Input
            }], size: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class FSWButtonIconSizePipe {
    transform(type, size) {
        if (type === FSWButtonAppearances.ICON_NO_BACKGROUND ||
            type === FSWButtonAppearances.ICON_WITH_BACKGROUND) {
            if (size === FSWButtonSizes.S) {
                return 'h-4';
            }
            else {
                return 'h-6';
            }
        }
        else {
            return 'h-4';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonIconSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonIconSizePipe, name: "fswButtonIconSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonIconSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswButtonIconSize',
                }]
        }] });

var FSWTooltipSizes;
(function (FSWTooltipSizes) {
    FSWTooltipSizes["M"] = "m";
    FSWTooltipSizes["S"] = "s";
})(FSWTooltipSizes || (FSWTooltipSizes = {}));

class FSWTooltipBase {
    constructor() {
        this.size = FSWTooltipSizes.M;
        this.className = 'fsw-tooltip';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTooltipBase, inputs: { size: "size" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipBase, decorators: [{
            type: Directive
        }], propDecorators: { size: [{
                type: Input
            }] } });

class FSWTooltipDirective extends FSWTooltipBase {
    get hostClassName() {
        return `${this.className} ${this.className}--size-${this.size}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTooltipDirective, selector: "[fswTooltip]", host: { properties: { "class": "hostClassName" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswTooltip]',
                    host: {
                        '[class]': 'hostClassName',
                    },
                }]
        }] });

class FSWButtonDirective extends FSWButtonBase {
    get hostClassName() {
        return `${this.className} ${this.className}--${this.appearance} ${this.className}--${this.size}`;
    }
    /**
     * @private
     * Keep this handler to partially support anchor disabling.
     * Unlike button, anchor doesn't have 'disabled' DOM property,
     * so handler will be called anyway. Preventing navigation and bubbling.
     * Disabling is partial due to click handlers precedence. Consider example:
     * <a fswButton [disabled]="true" (click)="clickHandler()">...</a>
     * 'clickHandler' will be called before our host listener below. We can't prevent
     * such handlers call.
     */
    onClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]", host: { listeners: { "click": "onClick($event)" }, properties: { "class": "hostClassName", "disabled": "disabled" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[fswButton], a[fswButton], input[type="button"][fswButton], input[type="submit"][fswButton]',
                    host: {
                        '[class]': 'hostClassName',
                        '[disabled]': 'disabled',
                    },
                }]
        }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class FSWButtonComponent extends FSWButtonBase {
    constructor() {
        super(...arguments);
        this.tooltip = null;
        this.position = [
            {
                originX: 'center',
                originY: 'bottom',
                overlayX: 'center',
                overlayY: 'top',
                offsetY: 6,
            },
            {
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom',
            },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWButtonComponent, selector: "fsw-button", inputs: { tooltip: "tooltip" }, usesInheritance: true, ngImport: i0, template: "<button\n\tfswButton\n\t[appearance]=\"appearance\"\n\t[size]=\"size\"\n\t[disabled]=\"disabled\"\n\t[cdkMenuTriggerFor]=\"tooltipTemplate\"\n\t[cdkMenuPosition]=\"position\"\n\t#cdkMenuTrigger=\"cdkMenuTriggerFor\"\n\t(mouseenter)=\"cdkMenuTrigger.open()\"\n\t(mouseleave)=\"cdkMenuTrigger.close()\"\n>\n\t<ng-content></ng-content>\n</button>\n<ng-template #tooltipTemplate>\n\t<span *ngIf=\"tooltip\" fswTooltip [size]=\"'s'\">{{ tooltip }}</span>\n</ng-template>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWTooltipDirective, selector: "[fswTooltip]" }, { kind: "directive", type: i2.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "directive", type: FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\n\tfswButton\n\t[appearance]=\"appearance\"\n\t[size]=\"size\"\n\t[disabled]=\"disabled\"\n\t[cdkMenuTriggerFor]=\"tooltipTemplate\"\n\t[cdkMenuPosition]=\"position\"\n\t#cdkMenuTrigger=\"cdkMenuTriggerFor\"\n\t(mouseenter)=\"cdkMenuTrigger.open()\"\n\t(mouseleave)=\"cdkMenuTrigger.close()\"\n>\n\t<ng-content></ng-content>\n</button>\n<ng-template #tooltipTemplate>\n\t<span *ngIf=\"tooltip\" fswTooltip [size]=\"'s'\">{{ tooltip }}</span>\n</ng-template>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { tooltip: [{
                type: Input
            }] } });

class FSWTooltipComponent extends FSWTooltipBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWTooltipComponent, selector: "fsw-tooltip", usesInheritance: true, ngImport: i0, template: "<span fswTooltip [size]=\"size\">\n\t<ng-content></ng-content>\n</span>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: FSWTooltipDirective, selector: "[fswTooltip]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span fswTooltip [size]=\"size\">\n\t<ng-content></ng-content>\n</span>\n", styles: [":host{display:contents}\n"] }]
        }] });

const UI$g = [FSWTooltipComponent, FSWTooltipDirective];
class FSWTooltipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipModule, declarations: [FSWTooltipComponent, FSWTooltipDirective], imports: [CommonModule], exports: [FSWTooltipComponent, FSWTooltipDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$g],
                    imports: [CommonModule],
                    exports: [UI$g],
                }]
        }] });

const UI$f = [FSWButtonIconSizePipe, FSWButtonDirective, FSWButtonComponent];
class FSWButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonModule, declarations: [FSWButtonIconSizePipe, FSWButtonDirective, FSWButtonComponent], imports: [FSWIconModule, CommonModule, FSWTooltipModule, CdkMenuModule], exports: [FSWButtonIconSizePipe, FSWButtonDirective, FSWButtonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonModule, imports: [FSWIconModule, CommonModule, FSWTooltipModule, CdkMenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FSWIconModule, CommonModule, FSWTooltipModule, CdkMenuModule],
                    declarations: [UI$f],
                    exports: [UI$f],
                }]
        }] });

var FSWCardImageSizes;
(function (FSWCardImageSizes) {
    FSWCardImageSizes["L"] = "l";
    FSWCardImageSizes["M"] = "m";
    FSWCardImageSizes["S"] = "s";
    FSWCardImageSizes["XS"] = "xs";
})(FSWCardImageSizes || (FSWCardImageSizes = {}));

var FSWCardDirections;
(function (FSWCardDirections) {
    FSWCardDirections["VERTICAL"] = "vertical";
    FSWCardDirections["HORIZONTAL"] = "horizontal";
})(FSWCardDirections || (FSWCardDirections = {}));

class FSWCardComponent {
    constructor() {
        this.direction = FSWCardDirections.VERTICAL;
        this.imageSize = FSWCardImageSizes.M;
        this.title = null;
        this.eyeBrownText = null;
        this.eyeBrownIcon = null;
        this.subtitle = null;
        this.imageUrl = null;
        this.imageAlt = null;
        this.isRadioContent = false;
        this.className = 'fsw-card';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCardComponent, selector: "fsw-card", inputs: { direction: "direction", imageSize: "imageSize", title: "title", eyeBrownText: "eyeBrownText", eyeBrownIcon: "eyeBrownIcon", subtitle: "subtitle", imageUrl: "imageUrl", imageAlt: "imageAlt", isRadioContent: "isRadioContent" }, ngImport: i0, template: "<article\n\tclass=\"{{ className }} {{ className }}--{{ direction }} {{ className }}--image-size-{{\n\t\timageSize\n\t}}\"\n\t[class.is-radio-content]=\"isRadioContent\"\n>\n\t<header *ngIf=\"imageUrl\">\n\t\t<img [src]=\"imageUrl\" [alt]=\"imageAlt || title || eyeBrownText || subtitle\" />\n\t</header>\n\t<main>\n\t\t<label *ngIf=\"eyeBrownText\">\n\t\t\t<i *ngIf=\"eyeBrownIcon\" [fswIcon]=\"eyeBrownIcon\"></i>\n\t\t\t<span>{{ eyeBrownText }}</span>\n\t\t</label>\n\t\t<h6 *ngIf=\"title\">{{ title }}</h6>\n\t\t<p *ngIf=\"subtitle\">{{ subtitle }}</p>\n\t\t<ng-content></ng-content>\n\t</main>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<article\n\tclass=\"{{ className }} {{ className }}--{{ direction }} {{ className }}--image-size-{{\n\t\timageSize\n\t}}\"\n\t[class.is-radio-content]=\"isRadioContent\"\n>\n\t<header *ngIf=\"imageUrl\">\n\t\t<img [src]=\"imageUrl\" [alt]=\"imageAlt || title || eyeBrownText || subtitle\" />\n\t</header>\n\t<main>\n\t\t<label *ngIf=\"eyeBrownText\">\n\t\t\t<i *ngIf=\"eyeBrownIcon\" [fswIcon]=\"eyeBrownIcon\"></i>\n\t\t\t<span>{{ eyeBrownText }}</span>\n\t\t</label>\n\t\t<h6 *ngIf=\"title\">{{ title }}</h6>\n\t\t<p *ngIf=\"subtitle\">{{ subtitle }}</p>\n\t\t<ng-content></ng-content>\n\t</main>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { direction: [{
                type: Input
            }], imageSize: [{
                type: Input
            }], title: [{
                type: Input
            }], eyeBrownText: [{
                type: Input
            }], eyeBrownIcon: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], imageUrl: [{
                type: Input
            }], imageAlt: [{
                type: Input
            }], isRadioContent: [{
                type: Input
            }] } });

const UI$e = [FSWCardComponent];
class FSWCardModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCardModule, declarations: [FSWCardComponent], imports: [CommonModule, FSWIconModule], exports: [FSWCardComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCardModule, imports: [CommonModule, FSWIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$e],
                    imports: [CommonModule, FSWIconModule],
                    exports: [UI$e],
                }]
        }] });

var FSWIndicatorDirections;
(function (FSWIndicatorDirections) {
    FSWIndicatorDirections["VERTICAL"] = "vertical";
    FSWIndicatorDirections["HORIZONTAL"] = "horizontal";
})(FSWIndicatorDirections || (FSWIndicatorDirections = {}));

var FSWIndicatorStatuses;
(function (FSWIndicatorStatuses) {
    FSWIndicatorStatuses["COMPLETED"] = "completed";
    FSWIndicatorStatuses["ERROR"] = "error";
})(FSWIndicatorStatuses || (FSWIndicatorStatuses = {}));

class FSWIndicatorComponent {
    constructor() {
        this.itemClick = new EventEmitter();
        this.completedIndex = -1;
        this.items = null;
        this.direction = FSWIndicatorDirections.HORIZONTAL;
        this.className = 'fsw-indicator';
    }
    getItemStatus(item, index) {
        return index + 1 <= this.completedIndex
            ? item.statusCheckFunction()
            : index + 1 - this.completedIndex === 1
                ? 'in-progress-next'
                : 'in-progress';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWIndicatorComponent, selector: "fsw-indicator", inputs: { completedIndex: "completedIndex", items: "items", direction: "direction" }, outputs: { itemClick: "itemClick" }, ngImport: i0, template: "<ul class=\"{{ className }} {{ className }}--{{ direction }}\" *ngIf=\"items?.length\">\n\t<ng-container *ngFor=\"let item of items; let i = index\">\n\t\t<li\n\t\t\t[id]=\"item.key\"\n\t\t\tclass=\"{{ className }}__item {{ className }}__item--{{ getItemStatus(item, i) }}\"\n\t\t\t(click)=\"itemClick.emit({ item: item, index: i })\"\n\t\t>\n\t\t\t{{ item.label }}\n\t\t</li>\n\t</ng-container>\n</ul>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-indicator', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"{{ className }} {{ className }}--{{ direction }}\" *ngIf=\"items?.length\">\n\t<ng-container *ngFor=\"let item of items; let i = index\">\n\t\t<li\n\t\t\t[id]=\"item.key\"\n\t\t\tclass=\"{{ className }}__item {{ className }}__item--{{ getItemStatus(item, i) }}\"\n\t\t\t(click)=\"itemClick.emit({ item: item, index: i })\"\n\t\t>\n\t\t\t{{ item.label }}\n\t\t</li>\n\t</ng-container>\n</ul>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { itemClick: [{
                type: Output
            }], completedIndex: [{
                type: Input
            }], items: [{
                type: Input
            }], direction: [{
                type: Input
            }] } });

const UI$d = [FSWIndicatorComponent];
class FSWIndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorModule, declarations: [FSWIndicatorComponent], imports: [FSWIconModule, CommonModule], exports: [FSWIndicatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorModule, imports: [FSWIconModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FSWIconModule, CommonModule],
                    declarations: [UI$d],
                    exports: [UI$d],
                }]
        }] });

var FSWLinkColors;
(function (FSWLinkColors) {
    FSWLinkColors["BLUE"] = "blue";
    FSWLinkColors["GRAY"] = "gray";
    FSWLinkColors["YELLOW"] = "yellow";
    FSWLinkColors["RED"] = "red";
    FSWLinkColors["GREEN"] = "green";
    FSWLinkColors["PURPLE"] = "purple";
})(FSWLinkColors || (FSWLinkColors = {}));

class FSWLinkBase {
    constructor() {
        this.color = FSWLinkColors.BLUE;
        this.className = 'fsw-link';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWLinkBase, inputs: { color: "color" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkBase, decorators: [{
            type: Directive
        }], propDecorators: { color: [{
                type: Input
            }] } });

class FSWLinkDirective extends FSWLinkBase {
    get hostClassName() {
        return `${this.className} ${this.className}--color-${this.color}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWLinkDirective, selector: "[fswLink]", host: { properties: { "class": "hostClassName" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswLink]',
                    host: {
                        '[class]': 'hostClassName',
                    },
                }]
        }] });

const UI$c = [FSWLinkDirective];
class FSWLinkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkModule, declarations: [FSWLinkDirective], imports: [CommonModule], exports: [FSWLinkDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [UI$c],
                    exports: [UI$c],
                }]
        }] });

var FSWControlTypes;
(function (FSWControlTypes) {
    FSWControlTypes["INPUT"] = "input";
    FSWControlTypes["SELECT"] = "select";
    FSWControlTypes["RADIO_GROUP"] = "radio-group";
    FSWControlTypes["CHECKBOX"] = "checkbox";
    FSWControlTypes["CHECKBOX_GROUP"] = "checkbox-group";
    FSWControlTypes["SWITCH"] = "switch";
    FSWControlTypes["DATE_TIME_PICKER"] = "date-time-picker";
})(FSWControlTypes || (FSWControlTypes = {}));

class FSWControlBase {
    constructor() {
        this.initialType = null;
        this.value$ = new BehaviorSubject(null);
        this._lengthChange$ = new BehaviorSubject(0);
    }
    get lengthChange$() {
        return this._lengthChange$.asObservable();
    }
    get counterLengthText$() {
        return this.lengthChange$.pipe(map((value) => {
            const maxLength = this.maxLength;
            if (!maxLength || maxLength < 0)
                return '';
            return `${maxLength - value} char left`;
        }));
    }
    get isInputPassword() {
        return false;
    }
    get isInput() {
        return false;
    }
    get maxLength() {
        return null;
    }
    get type() {
        return null;
    }
    togglePassword(value) {
        // FOR OVERRIDING
    }
    setLength(value) {
        this._lengthChange$.next(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWControlBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWControlBase, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWControlBase, decorators: [{
            type: Directive
        }] });

class FSWSelectPrefixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectPrefixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectPrefixDirective, selector: "ng-template[fswSelectPrefix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswSelectPrefix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var FSWSelectItemKind;
(function (FSWSelectItemKind) {
    FSWSelectItemKind["DEFAULT"] = "default";
    FSWSelectItemKind["CUSTOM"] = "custom";
})(FSWSelectItemKind || (FSWSelectItemKind = {}));

var FSWSelectItemIcon;
(function (FSWSelectItemIcon) {
    FSWSelectItemIcon["NONE"] = "none";
    FSWSelectItemIcon["CHECKBOX"] = "checkbox";
    FSWSelectItemIcon["RADIO"] = "radio";
})(FSWSelectItemIcon || (FSWSelectItemIcon = {}));

var FSWSelectItemTextSize;
(function (FSWSelectItemTextSize) {
    FSWSelectItemTextSize["M"] = "m";
    FSWSelectItemTextSize["S"] = "s";
})(FSWSelectItemTextSize || (FSWSelectItemTextSize = {}));

class FSWSelectBase extends FSWControlBase {
    set disabled(value) {
        this._disabled = value;
    }
    get disabled() {
        return this._disabled;
    }
    set readOnly(value) {
        this._readOnly = value;
    }
    get readOnly() {
        return this._readOnly;
    }
    //#endregion Inputs
    get controlType() {
        return FSWControlTypes.SELECT;
    }
    get isReadonly() {
        return this.readOnly;
    }
    get isDisabled() {
        return this.disabled;
    }
    //#endregion Control Setup
    get value() {
        if (this.isMultiple)
            return this._selectedValues ? this._selectedValues[0] : null;
        return this._selectedValues;
    }
    get isPlaceholder() {
        return !this._selectedValues?.length;
    }
    get render() {
        if (this.isPlaceholder) {
            return this.placeHolder;
        }
        return this.renderTemplate
            ? this.renderTemplate(this._selectedItems || [])
            : (this._selectedItems || [])
                .filter((item) => !!item)
                .map((item) => item.text)
                .join(', ');
    }
    constructor(_cdr) {
        super();
        this._cdr = _cdr;
        //#region Inputs
        this.hasError = false;
        this.fixedWidth = true;
        this.offsetY = 4;
        this.isMultiple = false;
        this.closeOnSelected = true;
        this.allowedClear = true;
        this.placeHolder = '';
        this.searchPlaceHolder = '';
        this.positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this.renderTemplate = null;
        this.maxHeight = 'auto';
        this.containerClasses = '';
        this.itemClasses = '';
        this.className = 'fsw-select';
        this.isOpen = false;
        this._disabled = false;
        this._readOnly = false;
        this._selectedValues = null;
        //#region Control Setup
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    writeValue(value) {
        this.value$.next(value);
        this._onChange(value);
        this._onTouched();
        if (this.isMultiple) {
            this._selectedValues = value;
        }
        else {
            this._selectedValues = value != null && value !== '' ? [value] : [];
        }
        this._cdr.markForCheck();
    }
    //#endregion Control Methods
    selectItem(value) {
        if (this.isMultiple) {
            let values = cloneDeep(this._selectedValues || []);
            if (values.includes(value)) {
                values = values.filter((v) => !isEqual(v, value));
            }
            else {
                values.push(value);
            }
            this.writeValue(values);
        }
        else {
            this.writeValue(value);
        }
    }
    clear() {
        this.writeValue(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectBase, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectBase, inputs: { hasError: "hasError", fixedWidth: "fixedWidth", offsetY: "offsetY", disabled: "disabled", readOnly: "readOnly", isMultiple: "isMultiple", closeOnSelected: "closeOnSelected", allowedClear: "allowedClear", placeHolder: "placeHolder", searchPlaceHolder: "searchPlaceHolder", positions: "positions", renderTemplate: "renderTemplate", maxHeight: "maxHeight", containerClasses: "containerClasses", itemClasses: "itemClasses" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { hasError: [{
                type: Input
            }], fixedWidth: [{
                type: Input
            }], offsetY: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], isMultiple: [{
                type: Input
            }], closeOnSelected: [{
                type: Input
            }], allowedClear: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], searchPlaceHolder: [{
                type: Input
            }], positions: [{
                type: Input
            }], renderTemplate: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], containerClasses: [{
                type: Input
            }], itemClasses: [{
                type: Input
            }] } });

class FSWSelectItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.kind = FSWSelectItemKind.DEFAULT;
        this.text = '';
        this.isDisabled = false;
        this.textSize = FSWSelectItemTextSize.M;
        this.showCheckIcon = false;
        this.icon = FSWSelectItemIcon.NONE;
        this.value = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: { kind: "kind", text: "text", isDisabled: "isDisabled", textSize: "textSize", showCheckIcon: "showCheckIcon", icon: "icon", value: "value" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswSelectItem]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { kind: [{
                type: Input
            }], text: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], textSize: [{
                type: Input
            }], showCheckIcon: [{
                type: Input
            }], icon: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class FSWSelectContainerComponent {
    constructor() {
        this.maxHeight = 'auto';
        this.customClasses = '';
        this.className = 'fsw-select__container';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectContainerComponent, selector: "fsw-select-container", inputs: { maxHeight: "maxHeight", customClasses: "customClasses" }, ngImport: i0, template: "<ol class=\"{{ className }} {{ customClasses }}\" [style.maxHeight]=\"maxHeight\">\n  <ng-content></ng-content>\n</ol>\n", styles: [":host{display:contents}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-select-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ol class=\"{{ className }} {{ customClasses }}\" [style.maxHeight]=\"maxHeight\">\n  <ng-content></ng-content>\n</ol>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { maxHeight: [{
                type: Input
            }], customClasses: [{
                type: Input
            }] } });

var FSWRadioSizes;
(function (FSWRadioSizes) {
    FSWRadioSizes["M"] = "m";
    FSWRadioSizes["S"] = "s";
})(FSWRadioSizes || (FSWRadioSizes = {}));

var FSWRadioStyles;
(function (FSWRadioStyles) {
    FSWRadioStyles["BLOCK"] = "block";
    FSWRadioStyles["CARD"] = "card";
})(FSWRadioStyles || (FSWRadioStyles = {}));

var FSWRadioDirections;
(function (FSWRadioDirections) {
    FSWRadioDirections["ROW"] = "row";
    FSWRadioDirections["COLUMN"] = "column";
})(FSWRadioDirections || (FSWRadioDirections = {}));

const FSW_RADIO_GROUP_TOKEN = new InjectionToken('FSW_RADIO_GROUP_TOKEN');

const TRANSITION$1 = `{{duration}}ms ease-in-out`;
const DURATION = { params: { duration: 300 } };
const fadeIn = trigger(`fadeIn`, [
    transition(`:enter`, [
        style({ transform: `translateY(-10px)`, opacity: 0 }),
        animate(TRANSITION$1, style({ transform: `translateY(0)`, opacity: 1 })),
    ], DURATION),
    transition(`:leave`, [
        style({ transform: `translateY(0)`, opacity: 1 }),
        animate(TRANSITION$1, style({ transform: `translateY(-10px)`, opacity: 0 })),
    ], DURATION),
]);

const TRANSITION = `{{duration}}ms ease-in-out`;
const slideIn = trigger(`slideIn`, [
    transition(`:enter`, [
        style({ transform: `translate3d(0,{{start}},0)` }),
        animate(TRANSITION, style({ transform: `translate3d(0,{{end}},0)` })),
    ], { params: { end: 0, start: `100%`, duration: 300 } }),
    transition(`:leave`, [
        style({ transform: `translate3d(0,{{end}},0)` }),
        animate(TRANSITION, style({ transform: `translate3d(0,{{start}},0)` })),
    ], { params: { end: 0, start: `100%`, duration: 300 } }),
]);

const notification = trigger('state', [
    state('void, hidden', style({
        transform: 'scale(0.8)',
        opacity: 0,
    })),
    state('visible', style({
        transform: 'scale(1)',
        opacity: 1,
    })),
    transition('* => visible', animate('150ms cubic-bezier(0, 0, 0.2, 1)')),
    transition('* => void, * => hidden', animate('75ms cubic-bezier(0.4, 0.0, 1, 1)', style({
        opacity: 0,
    }))),
]);

function autoDestroy() {
    return (constructor) => {
        const originNgOnDestroy = constructor.prototype.ngOnDestroy;
        constructor.prototype.complete$ = new Subject();
        constructor.prototype.ngOnDestroy = function () {
            constructor.prototype.complete$.next();
            constructor.prototype.complete$.complete();
            if (originNgOnDestroy) {
                originNgOnDestroy.bind(constructor.prototype);
            }
        };
    };
}
function followDestroy(instance) {
    return (source$) => source$.pipe(takeUntil(instance.complete$));
}

function timeReset(value) {
    value = new Date(value);
    value.setHours(0);
    value.setMinutes(0);
    value.setSeconds(0);
    return value;
}

function randomId() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}

class FSWApplicationService {
    constructor(_document, _injector, _appRef, _resolver) {
        this._document = _document;
        this._injector = _injector;
        this._appRef = _appRef;
        this._resolver = _resolver;
    }
    createComponentRef(component, injector) {
        const factoryResolver = this._resolver.resolveComponentFactory(component);
        const componentRef = factoryResolver.create(injector || this._injector);
        this.attachHostView(componentRef.hostView);
        return componentRef;
    }
    appendTo(element, parent = this._document.body) {
        parent.appendChild(element);
    }
    removeFrom(element, parent = this._document.body) {
        parent.removeChild(element);
    }
    attachHostView(hostView) {
        this._appRef.attachView(hostView);
    }
    detachHostView(hostView) {
        this._appRef.detachView(hostView);
    }
    getHostViewElement(hostView) {
        const embeddedViewRef = hostView;
        return embeddedViewRef.rootNodes[0];
    }
    createInjector(providers, parentInjector) {
        return Injector.create({
            parent: parentInjector || this._injector,
            providers,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationService, deps: [{ token: DOCUMENT }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: i0.ComponentFactoryResolver }]; } });

const FSW_APPLICATION_SERVICE_TOKEN = new InjectionToken('FSW_APPLICATION_SERVICE_TOKEN');

class FSWApplicationServiceModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationServiceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationServiceModule, providers: [
            {
                provide: FSW_APPLICATION_SERVICE_TOKEN,
                useClass: FSWApplicationService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWApplicationServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FSW_APPLICATION_SERVICE_TOKEN,
                            useClass: FSWApplicationService,
                        },
                    ],
                }]
        }] });

class FSWForceArrayPipe {
    transform(value) {
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceArrayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWForceArrayPipe, name: "fswForceArray" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceArrayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswForceArray',
                }]
        }] });

class ForceArrayPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceArrayPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ForceArrayPipeModule, declarations: [FSWForceArrayPipe], exports: [FSWForceArrayPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceArrayPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceArrayPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWForceArrayPipe],
                    exports: [FSWForceArrayPipe],
                }]
        }] });

class FSWForceControlPipe {
    transform(value) {
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceControlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWForceControlPipe, name: "fswForceControl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceControlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswForceControl',
                }]
        }] });

class ForceControlPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceControlPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ForceControlPipeModule, declarations: [FSWForceControlPipe], exports: [FSWForceControlPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceControlPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceControlPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWForceControlPipe],
                    exports: [FSWForceControlPipe],
                }]
        }] });

class FSWForceGroupPipe {
    transform(value) {
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceGroupPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWForceGroupPipe, name: "fswForceGroup" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWForceGroupPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswForceGroup',
                }]
        }] });

class ForceGroupPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceGroupPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ForceGroupPipeModule, declarations: [FSWForceGroupPipe], exports: [FSWForceGroupPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceGroupPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ForceGroupPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWForceGroupPipe],
                    exports: [FSWForceGroupPipe],
                }]
        }] });

class FSWValueChangesPipe {
    constructor(_cdr) {
        this._cdr = _cdr;
        this._latestValue = null;
    }
    transform(control, defaultValue) {
        control.valueChanges
            .pipe(startWith(defaultValue || control.value), tap((value) => {
            this._latestValue = value;
            this._cdr.markForCheck();
        }))
            .subscribe();
        return this._latestValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipe, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipe, name: "fswValueChanges", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswValueChanges',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; } });

class FSWValueChangesPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipeModule, declarations: [FSWValueChangesPipe], exports: [FSWValueChangesPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWValueChangesPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWValueChangesPipe],
                    exports: [FSWValueChangesPipe],
                }]
        }] });

let FSWHasErrorPipe = class FSWHasErrorPipe {
    constructor(_cdr) {
        this._cdr = _cdr;
        this._latestValue = false;
    }
    transform(control) {
        if (!control) {
            return false;
        }
        combineLatest([control.valueChanges, control.statusChanges])
            .pipe(followDestroy(this), tap(() => this._reset(control)))
            .subscribe();
        this._customFunction(control, ['markAsTouched', 'markAsUntouched', 'markAsPristine', 'markAsDirty'], () => this._reset(control));
        return this._latestValue;
    }
    _customFunction(control, funcNames, cb) {
        funcNames.forEach((funcName) => {
            const originalFunction = control[funcName];
            control[funcName] = function (opts = {}) {
                originalFunction.bind(control)(opts);
                cb();
            };
        });
    }
    _reset(control) {
        this._latestValue = (control.dirty || control.touched) && control.invalid;
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipe, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipe, name: "fswHasError", pure: false }); }
};
FSWHasErrorPipe = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef])
], FSWHasErrorPipe);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswHasError',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; } });

class FSWHasErrorPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipeModule, declarations: [FSWHasErrorPipe], exports: [FSWHasErrorPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipeModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWHasErrorPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWHasErrorPipe],
                    exports: [FSWHasErrorPipe],
                }]
        }] });

let FSWRadioBase = class FSWRadioBase {
    constructor(_cdr, _radioGroupComponent) {
        this._cdr = _cdr;
        this._radioGroupComponent = _radioGroupComponent;
        //#region Inputs
        this.id = randomId();
        this.name = randomId();
        this.groupValue = null;
        this.value = null;
        this.label = null;
        this.description = null;
        this.hasError = false;
        this.forceChecked = false;
        this.size = FSWRadioSizes.M;
        this.renderStyle = FSWRadioStyles.BLOCK;
        this.showCheckedIcon = false;
        this.disabled = false;
        this.readOnly = false;
        this.className = 'fsw-radio';
        this.listenToRadioGroupValueChange();
    }
    select() {
        if (!this._radioGroupComponent || this.disabled || this.readOnly)
            return;
        this._radioGroupComponent.writeValue(this.value);
    }
    listenToRadioGroupValueChange() {
        if (!this._radioGroupComponent)
            return;
        this._radioGroupComponent.value$
            .pipe(tap((value) => {
            this.groupValue = value;
            this._cdr.markForCheck();
        }), followDestroy(this))
            .subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioBase, deps: [{ token: i0.ChangeDetectorRef }, { token: FSW_RADIO_GROUP_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioBase, inputs: { id: "id", name: "name", groupValue: "groupValue", value: "value", label: "label", description: "description", hasError: "hasError", forceChecked: "forceChecked", size: "size", renderStyle: "renderStyle", showCheckedIcon: "showCheckedIcon", disabled: "disabled", readOnly: "readOnly" }, ngImport: i0 }); }
};
FSWRadioBase = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef, Object])
], FSWRadioBase);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_RADIO_GROUP_TOKEN]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], groupValue: [{
                type: Input
            }], value: [{
                type: Input
            }], label: [{
                type: Input
            }], description: [{
                type: Input
            }], hasError: [{
                type: Input
            }], forceChecked: [{
                type: Input
            }], size: [{
                type: Input
            }], renderStyle: [{
                type: Input
            }], showCheckedIcon: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }] } });

class FSWRadioGroupBase extends FSWControlBase {
    get hasError() {
        return this._hasError;
    }
    set hasError(value) {
        this._hasError = value;
        this.setupAttributes();
    }
    get isReadonly() {
        return this.readOnly;
    }
    get isDisabled() {
        return this.disabled;
    }
    get value() {
        return this.value$.value;
    }
    get controlType() {
        return FSWControlTypes.RADIO_GROUP;
    }
    //#endregion Control Setup
    constructor() {
        super();
        //#region Inputs
        this.id = randomId();
        this.name = randomId();
        this.disabled = false;
        this.readOnly = false;
        this.direction = FSWRadioDirections.COLUMN;
        this.gap = '20px';
        //#endregion Inputs
        this.listTemplate = null;
        this._hasError = false;
        //#region Control Setup
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
        this.className = 'fsw-radio-group';
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    writeValue(value) {
        if (isEqual(value, this.value)) {
            return;
        }
        this.value$.next(value);
        this._onChange(value);
        this._onTouched();
    }
    //#endregion Control Methods
    setup() {
        if (!this.listTemplate)
            return;
        this.setupAttributes();
    }
    setupAttributes() {
        this.listTemplate?.forEach((item) => {
            item.name = this.name;
            item.disabled = this.isDisabled;
            item.hasError = this.hasError;
            item.readOnly = this.isReadonly;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioGroupBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioGroupBase, inputs: { id: "id", name: "name", disabled: "disabled", readOnly: "readOnly", hasError: "hasError", direction: "direction", gap: "gap" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioGroupBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], hasError: [{
                type: Input
            }], direction: [{
                type: Input
            }], gap: [{
                type: Input
            }] } });

class FSWRadioDescriptionDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioDescriptionDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioDescriptionDirective, selector: "ng-template[fswRadioDescription]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswRadioDescription]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWRadioLabelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioLabelDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioLabelDirective, selector: "ng-template[fswRadioLabel]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswRadioLabel]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWRadioComponent extends FSWRadioBase {
    constructor() {
        super(...arguments);
        this.labelTemplate = null;
        this.descriptionTemplate = null;
    }
    get checked() {
        return this.value == this.groupValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioComponent, selector: "fsw-radio", queries: [{ propertyName: "labelTemplate", first: true, predicate: FSWRadioLabelDirective, descendants: true }, { propertyName: "descriptionTemplate", first: true, predicate: FSWRadioDescriptionDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }} {{ className }}--size-{{ size }}\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"disabled\"\n    [value]=\"value\"\n    [checked]=\"forceChecked || checked\"\n    [name]=\"name\"\n    [class.has-error]=\"hasError\"\n    [readOnly]=\"readOnly\"\n    (change)=\"select()\"\n    type=\"radio\"\n  />\n  <i\n    *ngIf=\"showCheckedIcon && checked\"\n    [fswIcon]=\"'status-success'\"\n    class=\"{{ className }}__check-icon\"\n  ></i>\n  <label [for]=\"id\">\n    <ng-container>\n      <ng-container *ngIf=\"labelTemplate; else defaultLabelTemplate\">\n        <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultLabelTemplate>\n        <span *ngIf=\"label\">{{ label }}</span>\n      </ng-template>\n    </ng-container>\n    <ng-container>\n      <ng-container *ngIf=\"descriptionTemplate; else defaultDescriptionTemplate\">\n        <ng-container *ngTemplateOutlet=\"descriptionTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDescriptionTemplate>\n        <small [attr.aria-labelledby]=\"id\" *ngIf=\"description\">{{ description }}</small>\n      </ng-template>\n    </ng-container>\n  </label>\n</div>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }} {{ className }}--size-{{ size }}\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"disabled\"\n    [value]=\"value\"\n    [checked]=\"forceChecked || checked\"\n    [name]=\"name\"\n    [class.has-error]=\"hasError\"\n    [readOnly]=\"readOnly\"\n    (change)=\"select()\"\n    type=\"radio\"\n  />\n  <i\n    *ngIf=\"showCheckedIcon && checked\"\n    [fswIcon]=\"'status-success'\"\n    class=\"{{ className }}__check-icon\"\n  ></i>\n  <label [for]=\"id\">\n    <ng-container>\n      <ng-container *ngIf=\"labelTemplate; else defaultLabelTemplate\">\n        <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultLabelTemplate>\n        <span *ngIf=\"label\">{{ label }}</span>\n      </ng-template>\n    </ng-container>\n    <ng-container>\n      <ng-container *ngIf=\"descriptionTemplate; else defaultDescriptionTemplate\">\n        <ng-container *ngTemplateOutlet=\"descriptionTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDescriptionTemplate>\n        <small [attr.aria-labelledby]=\"id\" *ngIf=\"description\">{{ description }}</small>\n      </ng-template>\n    </ng-container>\n  </label>\n</div>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { labelTemplate: [{
                type: ContentChild,
                args: [FSWRadioLabelDirective]
            }], descriptionTemplate: [{
                type: ContentChild,
                args: [FSWRadioDescriptionDirective]
            }] } });

const FSW_RADIO_GROUP_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FSWRadioGroupComponent),
    multi: true,
};
class FSWRadioGroupComponent extends FSWRadioGroupBase {
    constructor() {
        super(...arguments);
        this.itemTemplates = null;
    }
    ngAfterViewInit() {
        this.listTemplate = this.itemTemplates ? [...this.itemTemplates] : null;
        this.setup();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRadioGroupComponent, selector: "fsw-radio-group", providers: [
            FSW_RADIO_GROUP_ACCESSOR,
            {
                provide: FSW_RADIO_GROUP_TOKEN,
                useExisting: FSWRadioGroupComponent,
            },
            {
                provide: FSWControlBase,
                useExisting: FSWRadioGroupComponent,
            },
        ], queries: [{ propertyName: "itemTemplates", predicate: FSWRadioComponent }], usesInheritance: true, ngImport: i0, template: "<section\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [style.--fsw-radio-group-gap]=\"gap\"\n  [style.--fsw-radio-group-direction]=\"direction\"\n>\n  <ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-radio-group', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_RADIO_GROUP_ACCESSOR,
                        {
                            provide: FSW_RADIO_GROUP_TOKEN,
                            useExisting: FSWRadioGroupComponent,
                        },
                        {
                            provide: FSWControlBase,
                            useExisting: FSWRadioGroupComponent,
                        },
                    ], template: "<section\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [style.--fsw-radio-group-gap]=\"gap\"\n  [style.--fsw-radio-group-direction]=\"direction\"\n>\n  <ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { itemTemplates: [{
                type: ContentChildren,
                args: [FSWRadioComponent]
            }] } });

const UI$b = [FSWRadioGroupComponent, FSWRadioDescriptionDirective, FSWRadioLabelDirective];
class FSWRadioModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioModule, declarations: [FSWRadioComponent, FSWRadioGroupComponent, FSWRadioDescriptionDirective, FSWRadioLabelDirective], imports: [CommonModule, FSWIconModule], exports: [FSWRadioComponent, FSWRadioGroupComponent, FSWRadioDescriptionDirective, FSWRadioLabelDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioModule, imports: [CommonModule, FSWIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWRadioComponent, UI$b],
                    exports: [FSWRadioComponent, UI$b],
                    imports: [CommonModule, FSWIconModule],
                }]
        }] });

var FSWCheckboxSizes;
(function (FSWCheckboxSizes) {
    FSWCheckboxSizes["M"] = "m";
    FSWCheckboxSizes["S"] = "s";
})(FSWCheckboxSizes || (FSWCheckboxSizes = {}));

var FSWCheckboxStyles;
(function (FSWCheckboxStyles) {
    FSWCheckboxStyles["BLOCK"] = "block";
    FSWCheckboxStyles["CARD"] = "card";
})(FSWCheckboxStyles || (FSWCheckboxStyles = {}));

var FSWCheckboxDirections;
(function (FSWCheckboxDirections) {
    FSWCheckboxDirections["ROW"] = "row";
    FSWCheckboxDirections["COLUMN"] = "column";
})(FSWCheckboxDirections || (FSWCheckboxDirections = {}));

const FSW_CHECKBOX_GROUP_TOKEN = new InjectionToken('FSW_CHECKBOX_GROUP_TOKEN');

class FSWCheckboxBase extends FSWControlBase {
    get controlType() {
        return FSWControlTypes.CHECKBOX;
    }
    get isDisabled() {
        return this.disabled;
    }
    get isReadonly() {
        return this.readOnly;
    }
    //#endregion Control Setup
    constructor(_cdr, _checkboxGroupComponent) {
        super();
        this._cdr = _cdr;
        this._checkboxGroupComponent = _checkboxGroupComponent;
        //#region Inputs
        this.id = randomId();
        this.label = null;
        this.data = null;
        this.description = null;
        this.hasError = false;
        this.forceChecked = null;
        this.size = FSWCheckboxSizes.M;
        this.renderStyle = FSWCheckboxStyles.BLOCK;
        this.disabled = false;
        this.readOnly = false;
        //#region Control Setup
        this.value = false;
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
        this.className = 'fsw-checkbox';
        this.listenToCheckboxGroupValueChange();
    }
    select() {
        if (!this._checkboxGroupComponent) {
            this.listenInputChange();
            return;
        }
        if (this.disabled || this.readOnly)
            return;
        this._checkboxGroupComponent.select(this.data);
    }
    listenToCheckboxGroupValueChange() {
        if (!this._checkboxGroupComponent)
            return;
        this._checkboxGroupComponent.value$
            .pipe(filter(() => !!this.data), tap((value) => {
            this.writeValue(value.includes(this.data));
            this._cdr.markForCheck();
        }), followDestroy(this))
            .subscribe();
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    writeValue(value) {
        if (isEqual(value, this.value)) {
            return;
        }
        this.value = value;
        this.value$.next(value);
        this._onChange(value);
        this._onTouched();
        // this._cdr.markForCheck();
    }
    listenInputChange() {
        if (this.disabled || this.readOnly)
            return;
        this.writeValue(!this.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxBase, deps: [{ token: i0.ChangeDetectorRef }, { token: FSW_CHECKBOX_GROUP_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxBase, inputs: { id: "id", label: "label", data: "data", description: "description", hasError: "hasError", forceChecked: "forceChecked", size: "size", renderStyle: "renderStyle", disabled: "disabled", readOnly: "readOnly" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_CHECKBOX_GROUP_TOKEN]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], data: [{
                type: Input
            }], description: [{
                type: Input
            }], hasError: [{
                type: Input
            }], forceChecked: [{
                type: Input
            }], size: [{
                type: Input
            }], renderStyle: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }] } });

class FSWCheckboxGroupBase extends FSWControlBase {
    get hasError() {
        return this._hasError;
    }
    set hasError(value) {
        this._hasError = value;
        this.setupAttributes();
    }
    get isReadonly() {
        return this.readOnly;
    }
    get isDisabled() {
        return this.disabled;
    }
    get value() {
        return this.value$.value;
    }
    get controlType() {
        return FSWControlTypes.CHECKBOX_GROUP;
    }
    //#endregion Control Setup
    constructor() {
        super();
        //#region Inputs
        this.id = randomId();
        this.name = randomId();
        this.disabled = false;
        this.readOnly = false;
        this.direction = FSWCheckboxDirections.COLUMN;
        this.gap = '20px';
        //#endregion Inputs
        this.listTemplate = null;
        this._hasError = false;
        //#region Control Setup
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
        this.className = 'fsw-checkbox-group';
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    writeValue(value) {
        this.value$.next(value || []);
        this._onChange(value || []);
        this._onTouched();
    }
    select(value) {
        let updatedValue = [...this.value];
        const existed = this.value.some((item) => item === value);
        if (existed) {
            updatedValue = updatedValue.filter((item) => item !== value);
        }
        else {
            value && updatedValue.push(value);
        }
        this.writeValue(updatedValue);
    }
    //#endregion Control Methods
    setup() {
        if (!this.listTemplate)
            return;
        this.setupAttributes();
    }
    setupAttributes() {
        this.listTemplate?.forEach((item) => {
            item.disabled = this.isDisabled;
            item.hasError = this.hasError;
            item.readOnly = this.isReadonly;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxGroupBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxGroupBase, inputs: { id: "id", name: "name", disabled: "disabled", readOnly: "readOnly", hasError: "hasError", direction: "direction", gap: "gap" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxGroupBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], hasError: [{
                type: Input
            }], direction: [{
                type: Input
            }], gap: [{
                type: Input
            }] } });

class FSWCheckboxDescriptionDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxDescriptionDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxDescriptionDirective, selector: "ng-template[fswCheckboxDescription]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswCheckboxDescription]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWCheckboxLabelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxLabelDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxLabelDirective, selector: "ng-template[fswCheckboxLabel]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswCheckboxLabel]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var FSWCheckboxComponent_1;
const FSW_CHECKBOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FSWCheckboxComponent),
    multi: true,
};
let FSWCheckboxComponent = class FSWCheckboxComponent extends FSWCheckboxBase {
    static { FSWCheckboxComponent_1 = this; }
    get finalChecked$() {
        return this.value$.pipe(map((value) => {
            if (this.forceChecked !== null) {
                return this.forceChecked;
            }
            return value;
        }));
    }
    constructor(_cdr, _checkboxGroupComponent) {
        super(_cdr, _checkboxGroupComponent);
        this._cdr = _cdr;
        this._checkboxGroupComponent = _checkboxGroupComponent;
        this.labelTemplate = null;
        this.descriptionTemplate = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: FSW_CHECKBOX_GROUP_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxComponent, selector: "fsw-checkbox", providers: [
            FSW_CHECKBOX_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWCheckboxComponent_1,
            },
        ], queries: [{ propertyName: "labelTemplate", first: true, predicate: FSWCheckboxLabelDirective, descendants: true }, { propertyName: "descriptionTemplate", first: true, predicate: FSWCheckboxDescriptionDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }}\"\n  [class.read-only]=\"isReadonly\"\n  [class.disabled]=\"isDisabled\"\n  [class.has-error]=\"hasError\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"isDisabled\"\n    [readOnly]=\"isReadonly\"\n    [class.has-error]=\"hasError\"\n    [checked]=\"finalChecked$ | async\"\n    type=\"checkbox\"\n    (change)=\"select()\"\n  />\n  <label [for]=\"id\">\n    <ng-container>\n      <ng-container *ngIf=\"labelTemplate; else defaultLabelTemplate\">\n        <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultLabelTemplate>\n        <span *ngIf=\"label\">{{ label }}</span>\n      </ng-template>\n    </ng-container>\n    <ng-container>\n      <ng-container *ngIf=\"descriptionTemplate; else defaultDescriptionTemplate\">\n        <ng-container *ngTemplateOutlet=\"descriptionTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDescriptionTemplate>\n        <small [attr.aria-labelledby]=\"id\" *ngIf=\"description\">{{ description }}</small>\n      </ng-template>\n    </ng-container>\n  </label>\n</div>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
};
FSWCheckboxComponent = FSWCheckboxComponent_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef, Object])
], FSWCheckboxComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_CHECKBOX_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWCheckboxComponent,
                        },
                    ], template: "<div\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }}\"\n  [class.read-only]=\"isReadonly\"\n  [class.disabled]=\"isDisabled\"\n  [class.has-error]=\"hasError\"\n>\n  <input\n    [id]=\"id\"\n    [disabled]=\"isDisabled\"\n    [readOnly]=\"isReadonly\"\n    [class.has-error]=\"hasError\"\n    [checked]=\"finalChecked$ | async\"\n    type=\"checkbox\"\n    (change)=\"select()\"\n  />\n  <label [for]=\"id\">\n    <ng-container>\n      <ng-container *ngIf=\"labelTemplate; else defaultLabelTemplate\">\n        <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultLabelTemplate>\n        <span *ngIf=\"label\">{{ label }}</span>\n      </ng-template>\n    </ng-container>\n    <ng-container>\n      <ng-container *ngIf=\"descriptionTemplate; else defaultDescriptionTemplate\">\n        <ng-container *ngTemplateOutlet=\"descriptionTemplate.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDescriptionTemplate>\n        <small [attr.aria-labelledby]=\"id\" *ngIf=\"description\">{{ description }}</small>\n      </ng-template>\n    </ng-container>\n  </label>\n</div>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_CHECKBOX_GROUP_TOKEN]
                }] }]; }, propDecorators: { labelTemplate: [{
                type: ContentChild,
                args: [FSWCheckboxLabelDirective]
            }], descriptionTemplate: [{
                type: ContentChild,
                args: [FSWCheckboxDescriptionDirective]
            }] } });

const FSW_CHECKBOX_GROUP_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FSWCheckboxGroupComponent),
    multi: true,
};
class FSWCheckboxGroupComponent extends FSWCheckboxGroupBase {
    constructor() {
        super(...arguments);
        this.itemTemplates = null;
    }
    ngAfterViewInit() {
        this.listTemplate = this.itemTemplates ? [...this.itemTemplates] : null;
        this.setup();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWCheckboxGroupComponent, selector: "fsw-checkbox-group", providers: [
            FSW_CHECKBOX_GROUP_ACCESSOR,
            {
                provide: FSW_CHECKBOX_GROUP_TOKEN,
                useExisting: FSWCheckboxGroupComponent,
            },
            {
                provide: FSWControlBase,
                useExisting: FSWCheckboxGroupComponent,
            },
        ], queries: [{ propertyName: "itemTemplates", predicate: FSWCheckboxComponent }], usesInheritance: true, ngImport: i0, template: "<section\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [style.--fsw-checkbox-group-gap]=\"gap\"\n  [style.--fsw-checkbox-group-direction]=\"direction\"\n>\n  <ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-checkbox-group', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_CHECKBOX_GROUP_ACCESSOR,
                        {
                            provide: FSW_CHECKBOX_GROUP_TOKEN,
                            useExisting: FSWCheckboxGroupComponent,
                        },
                        {
                            provide: FSWControlBase,
                            useExisting: FSWCheckboxGroupComponent,
                        },
                    ], template: "<section\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [style.--fsw-checkbox-group-gap]=\"gap\"\n  [style.--fsw-checkbox-group-direction]=\"direction\"\n>\n  <ng-content></ng-content>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { itemTemplates: [{
                type: ContentChildren,
                args: [FSWCheckboxComponent]
            }] } });

const UI$a = [
    FSWCheckboxDescriptionDirective,
    FSWCheckboxLabelDirective,
    FSWCheckboxGroupComponent,
    FSWCheckboxComponent,
];
class FSWCheckboxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxModule, declarations: [FSWCheckboxDescriptionDirective,
            FSWCheckboxLabelDirective,
            FSWCheckboxGroupComponent,
            FSWCheckboxComponent], imports: [CommonModule], exports: [FSWCheckboxDescriptionDirective,
            FSWCheckboxLabelDirective,
            FSWCheckboxGroupComponent,
            FSWCheckboxComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$a],
                    exports: [UI$a],
                    imports: [CommonModule],
                }]
        }] });

class FSWSelectItemComponent {
    constructor() {
        this.clickEvent = new EventEmitter();
        this.customClasses = '';
        this.selected = false;
        this.value = null;
        this.className = 'fsw-select__item';
        this.FSWSelectItemKind = FSWSelectItemKind;
        this.FSWSelectItemIcon = FSWSelectItemIcon;
        this.FSwSelectItemTextSize = FSWSelectItemTextSize;
        this.FSWRadioSizes = FSWRadioSizes;
        this.FSWCheckboxSizes = FSWCheckboxSizes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectItemComponent, selector: "fsw-select-item", inputs: { item: "item", customClasses: "customClasses", selected: "selected", value: "value" }, outputs: { clickEvent: "clickEvent" }, ngImport: i0, template: "<li (click)=\"!item.isDisabled && clickEvent.emit()\" class=\"{{ className }} {{ customClasses }}\">\n  <ng-container [ngSwitch]=\"item.kind\">\n    <ng-container *ngSwitchCase=\"FSWSelectItemKind.CUSTOM\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          item.templateRef;\n          context: {\n            $implicit: selected\n          }\n        \"\n      ></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <article\n        class=\"{{ className }}__template\"\n        [class.disabled]=\"item.isDisabled\"\n        [class.active]=\"selected\"\n      >\n        <main>\n          <ng-container [ngSwitch]=\"item.icon\">\n            <ng-container *ngSwitchCase=\"FSWSelectItemIcon.CHECKBOX\">\n              <fsw-checkbox\n                [forceChecked]=\"selected\"\n                [disabled]=\"item.isDisabled\"\n                [label]=\"item.text\"\n                [size]=\"\n                  item.textSize === FSwSelectItemTextSize.M\n                    ? FSWCheckboxSizes.M\n                    : FSWCheckboxSizes.S\n                \"\n              ></fsw-checkbox>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"FSWSelectItemIcon.RADIO\">\n              <fsw-radio\n                [forceChecked]=\"selected\"\n                [value]=\"item.value\"\n                [groupValue]=\"value\"\n                [disabled]=\"item.isDisabled\"\n                [label]=\"item.text\"\n                [size]=\"\n                  item.textSize === FSwSelectItemTextSize.M ? FSWRadioSizes.M : FSWRadioSizes.S\n                \"\n              ></fsw-radio>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <span class=\"{{ className }}__text {{ className }}__text--{{ item.textSize }}\">{{\n                item.text\n              }}</span>\n            </ng-container>\n          </ng-container>\n        </main>\n        <i\n          class=\"{{ className }}__check\"\n          *ngIf=\"item.showCheckIcon && selected\"\n          [fswIcon]=\"'common-check-short'\"\n        ></i>\n      </article>\n    </ng-container>\n  </ng-container>\n</li>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "component", type: FSWRadioComponent, selector: "fsw-radio" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-select-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<li (click)=\"!item.isDisabled && clickEvent.emit()\" class=\"{{ className }} {{ customClasses }}\">\n  <ng-container [ngSwitch]=\"item.kind\">\n    <ng-container *ngSwitchCase=\"FSWSelectItemKind.CUSTOM\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          item.templateRef;\n          context: {\n            $implicit: selected\n          }\n        \"\n      ></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <article\n        class=\"{{ className }}__template\"\n        [class.disabled]=\"item.isDisabled\"\n        [class.active]=\"selected\"\n      >\n        <main>\n          <ng-container [ngSwitch]=\"item.icon\">\n            <ng-container *ngSwitchCase=\"FSWSelectItemIcon.CHECKBOX\">\n              <fsw-checkbox\n                [forceChecked]=\"selected\"\n                [disabled]=\"item.isDisabled\"\n                [label]=\"item.text\"\n                [size]=\"\n                  item.textSize === FSwSelectItemTextSize.M\n                    ? FSWCheckboxSizes.M\n                    : FSWCheckboxSizes.S\n                \"\n              ></fsw-checkbox>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"FSWSelectItemIcon.RADIO\">\n              <fsw-radio\n                [forceChecked]=\"selected\"\n                [value]=\"item.value\"\n                [groupValue]=\"value\"\n                [disabled]=\"item.isDisabled\"\n                [label]=\"item.text\"\n                [size]=\"\n                  item.textSize === FSwSelectItemTextSize.M ? FSWRadioSizes.M : FSWRadioSizes.S\n                \"\n              ></fsw-radio>\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <span class=\"{{ className }}__text {{ className }}__text--{{ item.textSize }}\">{{\n                item.text\n              }}</span>\n            </ng-container>\n          </ng-container>\n        </main>\n        <i\n          class=\"{{ className }}__check\"\n          *ngIf=\"item.showCheckIcon && selected\"\n          [fswIcon]=\"'common-check-short'\"\n        ></i>\n      </article>\n    </ng-container>\n  </ng-container>\n</li>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { clickEvent: [{
                type: Output
            }], item: [{
                type: Input
            }], customClasses: [{
                type: Input
            }], selected: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

var FSWDropdownEvents;
(function (FSWDropdownEvents) {
    FSWDropdownEvents["CLICK"] = "click";
    FSWDropdownEvents["HOVER"] = "hover";
    FSWDropdownEvents["CONDITIONAL"] = "conditional";
})(FSWDropdownEvents || (FSWDropdownEvents = {}));

let FSWDropdownDirective = class FSWDropdownDirective {
    set conditional(value) {
        this.conditional$.next(value);
    }
    get overlayRef() {
        return this.trigger['overlayRef'];
    }
    set overlayRef(value) {
        this.trigger['overlayRef'] = value;
    }
    get positions() {
        if (this.trigger.menuPosition?.length)
            return this.trigger.menuPosition;
        return [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: this.offsetY,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
                offsetX: this.offsetX,
            },
        ];
    }
    constructor(elementRef, trigger) {
        this.elementRef = elementRef;
        this.trigger = trigger;
        this.fixedWidth = false;
        this.allowBackDropClick = true;
        this.offsetY = 0;
        this.offsetX = 0;
        this.event = FSWDropdownEvents.CLICK;
        this.conditional$ = new BehaviorSubject(false);
    }
    ngOnInit() {
        this.trigger.open = this.open.bind(this);
        this.trigger.close = this.close.bind(this);
        this.trigger.menuPosition = this.positions;
        combineLatest([
            fromEvent(this.elementRef.nativeElement, 'mouseover').pipe(tap((event) => {
                if (this.event !== FSWDropdownEvents.HOVER) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }), filter(() => this.event === FSWDropdownEvents.HOVER), exhaustMap(() => {
                this.open(false);
                return fromEvent(this.elementRef.nativeElement, 'mouseleave').pipe(take(1), tap(() => this.close(true)));
            })),
            fromEvent(this.elementRef.nativeElement, 'click').pipe(tap((event) => {
                if (this.event !== FSWDropdownEvents.CLICK) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }), filter(() => this.event === FSWDropdownEvents.CLICK), tap(() => this.open(this.allowBackDropClick))),
            this.conditional$.pipe(filter(() => this.event === FSWDropdownEvents.CONDITIONAL), tap((value) => {
                value ? this.open(false) : this.close(true);
            })),
        ])
            .pipe(followDestroy(this))
            .subscribe();
    }
    open(allowBackdropClick = true) {
        if (!this.trigger.isOpen() && this.trigger.menuTemplateRef) {
            this.trigger.opened.next();
            this.overlayRef =
                this.overlayRef || this.trigger['_overlay'].create(this.trigger['_getOverlayConfig']());
            this.overlayRef?.attach(this.trigger['getMenuContentPortal']());
            this.syncWidth();
            allowBackdropClick &&
                this.overlayRef
                    ?.outsidePointerEvents()
                    .pipe(filter((e) => e.target != this.elementRef.nativeElement &&
                    !this.elementRef.nativeElement.contains(e.target)), tap((event) => {
                    if (!this.trigger['isElementInsideMenuStack'](event.target)) {
                        this.trigger['menuStack'].closeAll();
                    }
                    else {
                        this.trigger['_closeSiblingTriggers']();
                    }
                    this.close(true);
                }), takeUntil(this.trigger['stopOutsideClicksListener']))
                    .subscribe();
        }
    }
    listenWindowClickEvent() {
        this.overlayRef?.updatePosition();
    }
    listenWindowScrollEvent() {
        this.overlayRef?.updatePosition();
    }
    close(fromEvent = false) {
        if (!fromEvent) {
            return;
        }
        if (this.trigger.isOpen()) {
            this.trigger.closed.next();
            this.overlayRef?.detach();
        }
        this.trigger['_closeSiblingTriggers']();
    }
    syncWidth() {
        if (!this.overlayRef || !this.fixedWidth) {
            return;
        }
        const refRect = this.elementRef.nativeElement.getBoundingClientRect();
        this.overlayRef.updateSize({ width: refRect.width });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownDirective, deps: [{ token: i0.ElementRef }, { token: MENU_TRIGGER }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: { fixedWidth: "fixedWidth", allowBackDropClick: "allowBackDropClick", offsetY: "offsetY", offsetX: "offsetX", event: "event", conditional: "conditional" }, host: { listeners: { "window:click": "listenWindowClickEvent()", "window:scroll": "listenWindowScrollEvent()" } }, exportAs: ["fswDropdown"], ngImport: i0 }); }
};
FSWDropdownDirective = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ElementRef,
        CdkMenuTrigger])
], FSWDropdownDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cdkMenuTriggerFor][fswDropdown]',
                    exportAs: 'fswDropdown',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i2.CdkMenuTrigger, decorators: [{
                    type: Inject,
                    args: [MENU_TRIGGER]
                }] }]; }, propDecorators: { fixedWidth: [{
                type: Input
            }], allowBackDropClick: [{
                type: Input
            }], offsetY: [{
                type: Input
            }], offsetX: [{
                type: Input
            }], event: [{
                type: Input
            }], conditional: [{
                type: Input
            }], listenWindowClickEvent: [{
                type: HostListener,
                args: ['window:click']
            }], listenWindowScrollEvent: [{
                type: HostListener,
                args: ['window:scroll']
            }] } });

class FSWFieldInputPrefixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldInputPrefixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldInputPrefixDirective, selector: "ng-template[fswFieldInputPrefix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldInputPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldInputPrefix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWFieldInputSuffixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldInputSuffixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldInputSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldInputSuffix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var FSWFieldFooterSuffixKind;
(function (FSWFieldFooterSuffixKind) {
    FSWFieldFooterSuffixKind["COUNTER"] = "counter";
    FSWFieldFooterSuffixKind["CUSTOM"] = "custom";
})(FSWFieldFooterSuffixKind || (FSWFieldFooterSuffixKind = {}));

var FSWFieldFooterPrefixKind;
(function (FSWFieldFooterPrefixKind) {
    FSWFieldFooterPrefixKind["CUSTOM"] = "custom";
    FSWFieldFooterPrefixKind["DEFAULT"] = "default";
})(FSWFieldFooterPrefixKind || (FSWFieldFooterPrefixKind = {}));

var FSWFieldHeaderSuffixKind;
(function (FSWFieldHeaderSuffixKind) {
    FSWFieldHeaderSuffixKind["PASSWORD"] = "password";
    FSWFieldHeaderSuffixKind["CUSTOM"] = "custom";
})(FSWFieldHeaderSuffixKind || (FSWFieldHeaderSuffixKind = {}));

var FSWFieldHeaderPrefixKind;
(function (FSWFieldHeaderPrefixKind) {
    FSWFieldHeaderPrefixKind["DEFAULT"] = "default";
    FSWFieldHeaderPrefixKind["CUSTOM"] = "custom";
})(FSWFieldHeaderPrefixKind || (FSWFieldHeaderPrefixKind = {}));

var FSWFieldSizes;
(function (FSWFieldSizes) {
    FSWFieldSizes["M"] = "m";
    FSWFieldSizes["S"] = "s";
})(FSWFieldSizes || (FSWFieldSizes = {}));

class FSWFieldBase {
    constructor() {
        this.size = FSWFieldSizes.M;
        this.errorText = null;
        this.fullWidth = false;
        this.flexWidth = false;
        this.showError = true;
        this.readOnly = false;
        this.disabled = false;
        this.className = 'fsw-field';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldBase, inputs: { size: "size", errorText: "errorText", fullWidth: "fullWidth", flexWidth: "flexWidth", showError: "showError", readOnly: "readOnly", disabled: "disabled" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldBase, decorators: [{
            type: Directive
        }], propDecorators: { size: [{
                type: Input
            }], errorText: [{
                type: Input
            }], fullWidth: [{
                type: Input
            }], flexWidth: [{
                type: Input
            }], showError: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class FSWFieldFooterPrefixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.kind = FSWFieldFooterPrefixKind.DEFAULT;
        this.helperText = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldFooterPrefixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: { kind: "kind", helperText: "helperText" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldFooterPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldFooterPrefix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { kind: [{
                type: Input
            }], helperText: [{
                type: Input
            }] } });

class FSWFieldFooterSuffixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.kind = FSWFieldFooterSuffixKind.CUSTOM;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldFooterSuffixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldFooterSuffixDirective, selector: "ng-template[fswFieldFooterSuffix]", inputs: { kind: "kind" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldFooterSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldFooterSuffix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { kind: [{
                type: Input
            }] } });

class FSWFieldHeaderPrefixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.kind = FSWFieldHeaderPrefixKind.DEFAULT;
        this.label = null;
        this.required = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldHeaderPrefixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: { kind: "kind", label: "label", required: "required" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldHeaderPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldHeaderPrefix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { kind: [{
                type: Input
            }], label: [{
                type: Input
            }], required: [{
                type: Input
            }] } });

class FSWFieldHeaderSuffixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.kind = FSWFieldHeaderSuffixKind.CUSTOM;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldHeaderSuffixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldHeaderSuffixDirective, selector: "ng-template[fswFieldHeaderSuffix]", inputs: { kind: "kind" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldHeaderSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldHeaderSuffix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { kind: [{
                type: Input
            }] } });

class FSWFieldReadonlyDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldReadonlyDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldReadonlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswFieldReadonly]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWFieldPasswordControlComponent {
    constructor() {
        this.showChange = new EventEmitter();
        this.show = false;
        this.className = 'fsw-field__password-control';
    }
    toggle() {
        this.show = !this.show;
        this.showChange.emit(this.show);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldPasswordControlComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldPasswordControlComponent, selector: "fsw-field-password-control", inputs: { show: "show" }, outputs: { showChange: "showChange" }, ngImport: i0, template: "<div class=\"{{ className }}\" (click)=\"toggle()\">\n\t<i [fswIcon]=\"show ? 'common-password-hide' : 'common-password-show'\"></i>\n\t<span>{{ show ? 'Hide' : 'Show' }}</span>\n</div>\n", dependencies: [{ kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldPasswordControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-field-password-control', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"{{ className }}\" (click)=\"toggle()\">\n\t<i [fswIcon]=\"show ? 'common-password-hide' : 'common-password-show'\"></i>\n\t<span>{{ show ? 'Hide' : 'Show' }}</span>\n</div>\n" }]
        }], propDecorators: { showChange: [{
                type: Output
            }], show: [{
                type: Input
            }] } });

class FSWFieldComponent extends FSWFieldBase {
    constructor() {
        super(...arguments);
        this.inputPrefixTemplate = null;
        this.inputSuffixTemplate = null;
        this.footerPrefixTemplate = null;
        this.footerSuffixTemplate = null;
        this.headerPrefixTemplate = null;
        this.headerSuffixTemplate = null;
        this.readonlyTemplate = null;
        this.controlTemplate = null;
        this.FSWFieldFooterPrefixKind = FSWFieldFooterPrefixKind;
        this.FSWFieldFooterSuffixKind = FSWFieldFooterSuffixKind;
        this.FSWFieldHeaderPrefixKind = FSWFieldHeaderPrefixKind;
        this.FSWFieldHeaderSuffixKind = FSWFieldHeaderSuffixKind;
    }
    get showFooter() {
        return (!!this.controlTemplate && !this.readOnly && (this.showFooterTemplate || this.showFooterError));
    }
    get showHeader() {
        return !!this.headerSuffixTemplate || !!this.headerPrefixTemplate;
    }
    get showFooterTemplate() {
        return !!this.footerSuffixTemplate || !!this.footerPrefixTemplate;
    }
    get showFooterError() {
        return this.showError && !!this.errorText;
    }
    get controlValueChange$() {
        if (!this.controlTemplate) {
            return of(null);
        }
        return this.controlTemplate.value$.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWFieldComponent, selector: "fsw-field", queries: [{ propertyName: "inputPrefixTemplate", first: true, predicate: FSWFieldInputPrefixDirective, descendants: true }, { propertyName: "inputSuffixTemplate", first: true, predicate: FSWFieldInputSuffixDirective, descendants: true }, { propertyName: "footerPrefixTemplate", first: true, predicate: FSWFieldFooterPrefixDirective, descendants: true }, { propertyName: "footerSuffixTemplate", first: true, predicate: FSWFieldFooterSuffixDirective, descendants: true }, { propertyName: "headerPrefixTemplate", first: true, predicate: FSWFieldHeaderPrefixDirective, descendants: true }, { propertyName: "headerSuffixTemplate", first: true, predicate: FSWFieldHeaderSuffixDirective, descendants: true }, { propertyName: "readonlyTemplate", first: true, predicate: FSWFieldReadonlyDirective, descendants: true }, { propertyName: "controlTemplate", first: true, predicate: FSWControlBase, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\n  class=\"{{ className }} {{ className }}--size-{{ size }}\"\n  [class.full-width]=\"fullWidth\"\n  [class.flex-width]=\"flexWidth\"\n  [class.read-only]=\"readOnly\"\n  [class.disabled]=\"disabled\"\n>\n  <header *ngIf=\"showHeader\">\n    <ng-container *ngIf=\"headerPrefixTemplate; else emptyTemplate\">\n      <ng-container [ngSwitch]=\"headerPrefixTemplate.kind\">\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderPrefixKind.CUSTOM\">\n          <ng-container *ngTemplateOutlet=\"headerPrefixTemplate.templateRef\"></ng-container>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <label\n            >{{ headerPrefixTemplate.label }}\n            <strong *ngIf=\"headerPrefixTemplate.required\">*</strong></label\n          >\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"headerSuffixTemplate; else emptyTemplate\">\n      <ng-container [ngSwitch]=\"headerSuffixTemplate.kind\">\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderSuffixKind.CUSTOM\">\n          <ng-container *ngTemplateOutlet=\"headerSuffixTemplate.templateRef\"></ng-container>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderSuffixKind.PASSWORD\">\n          <ng-container *ngIf=\"!readOnly\">\n            <fsw-field-password-control\n              (showChange)=\"controlTemplate?.togglePassword($event)\"\n            ></fsw-field-password-control>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </header>\n  <main>\n    <ng-container *ngIf=\"inputPrefixTemplate\">\n      <ng-container *ngTemplateOutlet=\"inputPrefixTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"!readOnly; else contextReadonlyTemplate\">\n      <ng-content></ng-content>\n    </ng-container>\n    <ng-container *ngIf=\"inputSuffixTemplate\">\n      <ng-container *ngTemplateOutlet=\"inputSuffixTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #contextReadonlyTemplate>\n      <ng-container *ngIf=\"readonlyTemplate; else noReadonlyTemplate\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            readonlyTemplate!.templateRef;\n            context: { $implicit: controlValueChange$ | async }\n          \"\n        ></ng-container>\n      </ng-container>\n      <ng-template #noReadonlyTemplate>\n        <span class=\"{{ className }}__no-input\">{{ controlValueChange$ | async }}</span>\n      </ng-template>\n    </ng-template>\n  </main>\n  <footer *ngIf=\"showFooter\">\n    <div *ngIf=\"showFooterTemplate\">\n      <ng-container *ngIf=\"footerPrefixTemplate; else errorTemplate\">\n        <ng-container [ngSwitch]=\"footerPrefixTemplate.kind\">\n          <ng-container *ngSwitchCase=\"FSWFieldFooterPrefixKind.CUSTOM\">\n            <ng-container *ngTemplateOutlet=\"footerPrefixTemplate.templateRef\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <span>{{ footerPrefixTemplate.helperText }}</span>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"footerSuffixTemplate; else emptyTemplate\">\n        <ng-container [ngSwitch]=\"footerSuffixTemplate.kind\">\n          <ng-container *ngSwitchCase=\"FSWFieldFooterSuffixKind.CUSTOM\">\n            <ng-container *ngTemplateOutlet=\"footerSuffixTemplate.templateRef\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"FSWFieldFooterSuffixKind.COUNTER\">\n            <ng-container *ngIf=\"controlTemplate?.counterLengthText$ | async as counterLengthText\">\n              <span>{{ counterLengthText }}</span>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </div>\n    <ng-container *ngIf=\"!showFooterError; else errorTemplate\"></ng-container>\n    <ng-template #errorTemplate>\n      <p *ngIf=\"showFooterError\">{{ errorText }}</p>\n    </ng-template>\n  </footer>\n  <ng-template #emptyTemplate>\n    <div></div>\n  </ng-template>\n</div>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: FSWFieldPasswordControlComponent, selector: "fsw-field-password-control", inputs: ["show"], outputs: ["showChange"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-field', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"{{ className }} {{ className }}--size-{{ size }}\"\n  [class.full-width]=\"fullWidth\"\n  [class.flex-width]=\"flexWidth\"\n  [class.read-only]=\"readOnly\"\n  [class.disabled]=\"disabled\"\n>\n  <header *ngIf=\"showHeader\">\n    <ng-container *ngIf=\"headerPrefixTemplate; else emptyTemplate\">\n      <ng-container [ngSwitch]=\"headerPrefixTemplate.kind\">\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderPrefixKind.CUSTOM\">\n          <ng-container *ngTemplateOutlet=\"headerPrefixTemplate.templateRef\"></ng-container>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <label\n            >{{ headerPrefixTemplate.label }}\n            <strong *ngIf=\"headerPrefixTemplate.required\">*</strong></label\n          >\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"headerSuffixTemplate; else emptyTemplate\">\n      <ng-container [ngSwitch]=\"headerSuffixTemplate.kind\">\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderSuffixKind.CUSTOM\">\n          <ng-container *ngTemplateOutlet=\"headerSuffixTemplate.templateRef\"></ng-container>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"FSWFieldHeaderSuffixKind.PASSWORD\">\n          <ng-container *ngIf=\"!readOnly\">\n            <fsw-field-password-control\n              (showChange)=\"controlTemplate?.togglePassword($event)\"\n            ></fsw-field-password-control>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </header>\n  <main>\n    <ng-container *ngIf=\"inputPrefixTemplate\">\n      <ng-container *ngTemplateOutlet=\"inputPrefixTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"!readOnly; else contextReadonlyTemplate\">\n      <ng-content></ng-content>\n    </ng-container>\n    <ng-container *ngIf=\"inputSuffixTemplate\">\n      <ng-container *ngTemplateOutlet=\"inputSuffixTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #contextReadonlyTemplate>\n      <ng-container *ngIf=\"readonlyTemplate; else noReadonlyTemplate\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            readonlyTemplate!.templateRef;\n            context: { $implicit: controlValueChange$ | async }\n          \"\n        ></ng-container>\n      </ng-container>\n      <ng-template #noReadonlyTemplate>\n        <span class=\"{{ className }}__no-input\">{{ controlValueChange$ | async }}</span>\n      </ng-template>\n    </ng-template>\n  </main>\n  <footer *ngIf=\"showFooter\">\n    <div *ngIf=\"showFooterTemplate\">\n      <ng-container *ngIf=\"footerPrefixTemplate; else errorTemplate\">\n        <ng-container [ngSwitch]=\"footerPrefixTemplate.kind\">\n          <ng-container *ngSwitchCase=\"FSWFieldFooterPrefixKind.CUSTOM\">\n            <ng-container *ngTemplateOutlet=\"footerPrefixTemplate.templateRef\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            <span>{{ footerPrefixTemplate.helperText }}</span>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"footerSuffixTemplate; else emptyTemplate\">\n        <ng-container [ngSwitch]=\"footerSuffixTemplate.kind\">\n          <ng-container *ngSwitchCase=\"FSWFieldFooterSuffixKind.CUSTOM\">\n            <ng-container *ngTemplateOutlet=\"footerSuffixTemplate.templateRef\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"FSWFieldFooterSuffixKind.COUNTER\">\n            <ng-container *ngIf=\"controlTemplate?.counterLengthText$ | async as counterLengthText\">\n              <span>{{ counterLengthText }}</span>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </div>\n    <ng-container *ngIf=\"!showFooterError; else errorTemplate\"></ng-container>\n    <ng-template #errorTemplate>\n      <p *ngIf=\"showFooterError\">{{ errorText }}</p>\n    </ng-template>\n  </footer>\n  <ng-template #emptyTemplate>\n    <div></div>\n  </ng-template>\n</div>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { inputPrefixTemplate: [{
                type: ContentChild,
                args: [FSWFieldInputPrefixDirective]
            }], inputSuffixTemplate: [{
                type: ContentChild,
                args: [FSWFieldInputSuffixDirective]
            }], footerPrefixTemplate: [{
                type: ContentChild,
                args: [FSWFieldFooterPrefixDirective]
            }], footerSuffixTemplate: [{
                type: ContentChild,
                args: [FSWFieldFooterSuffixDirective]
            }], headerPrefixTemplate: [{
                type: ContentChild,
                args: [FSWFieldHeaderPrefixDirective]
            }], headerSuffixTemplate: [{
                type: ContentChild,
                args: [FSWFieldHeaderSuffixDirective]
            }], readonlyTemplate: [{
                type: ContentChild,
                args: [FSWFieldReadonlyDirective]
            }], controlTemplate: [{
                type: ContentChild,
                args: [FSWControlBase]
            }] } });

class FSWInputBase extends FSWControlBase {
    constructor() {
        super(...arguments);
        this.hasError = false;
        this.className = 'fsw-input';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputBase, inputs: { hasError: "hasError" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputBase, decorators: [{
            type: Directive
        }], propDecorators: { hasError: [{
                type: Input
            }] } });

var FSWInputDirective_1;
let FSWInputDirective = class FSWInputDirective extends FSWInputBase {
    static { FSWInputDirective_1 = this; }
    get maxLength() {
        return this.elementRef.nativeElement.maxLength;
    }
    get type() {
        return this.elementRef.nativeElement.type;
    }
    get isInput() {
        return this.elementRef.nativeElement.tagName.toLowerCase() === 'input';
    }
    get isReadonly() {
        return this.elementRef.nativeElement.readOnly;
    }
    get isDisabled() {
        return this.elementRef.nativeElement.disabled;
    }
    get value() {
        return this.elementRef.nativeElement.value;
    }
    get isInputPassword() {
        return this.isInput && this.initialType === 'password';
    }
    get hostClassName() {
        return `${this.className}`;
    }
    get controlType() {
        return FSWControlTypes.INPUT;
    }
    constructor(elementRef, _cdr, _ngControl) {
        super();
        this.elementRef = elementRef;
        this._cdr = _cdr;
        this._ngControl = _ngControl;
    }
    ngOnInit() {
        this.controlChanges();
    }
    ngAfterViewInit() {
        this.initialType = this.type;
        this.setLength(this.elementRef.nativeElement.value.length);
        this._cdr.detectChanges();
    }
    inputHostListener(event) {
        this.setLength(event.target.value.length || 0);
    }
    togglePassword(value) {
        if (this.isInputPassword) {
            this.elementRef.nativeElement.setAttribute('type', value ? 'text' : 'password');
        }
    }
    controlChanges() {
        this._ngControl?.control?.valueChanges
            ?.pipe(startWith(this._ngControl.control.value), filter((value) => !isEqual(value, this.value$.value)), tap((value) => {
            if (this.isValidNumber(value)) {
                this._ngControl.control?.setValue(Number(value), { emitEvent: false });
            }
            this.value$.next(value);
        }), followDestroy(this))
            .subscribe();
    }
    isValidNumber(value) {
        if (this.elementRef?.nativeElement?.type !== 'number' || !value?.toString().length) {
            return false;
        }
        return !isNaN(Number(value));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputDirective, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i2$1.NgControl, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputDirective, selector: "input[fswInput], textarea[fswInput]", host: { listeners: { "input": "inputHostListener($event)" }, properties: { "class": "hostClassName", "class.has-error": "hasError" } }, providers: [
            {
                provide: FSWControlBase,
                useExisting: FSWInputDirective_1,
            },
        ], usesInheritance: true, ngImport: i0 }); }
};
FSWInputDirective = FSWInputDirective_1 = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ElementRef,
        ChangeDetectorRef,
        NgControl])
], FSWInputDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInput], textarea[fswInput]',
                    host: {
                        '[class]': 'hostClassName',
                        '[class.has-error]': 'hasError',
                    },
                    providers: [
                        {
                            provide: FSWControlBase,
                            useExisting: FSWInputDirective,
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i2$1.NgControl, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { inputHostListener: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

const FSW_SELECT_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWSelectComponent),
};
class FSWSelectComponent extends FSWSelectBase {
    constructor() {
        super(...arguments);
        this.prefixTemplate = null;
        this.itemTemplates = null;
        this.searchControl = new FormControl('');
        this.templateFiltered$ = this.searchControl.valueChanges.pipe(startWith(''), map((value) => (value || '').toLowerCase()), map((value) => (this.itemTemplates || []).filter((item) => (item.text || '').toLowerCase().includes(value))));
    }
    get selected() {
        return !!this._selectedValues?.length;
    }
    get _selectedItems() {
        const templates = this.itemTemplates?.toArray();
        const values = this._selectedValues;
        if (!templates?.length || !values?.length) {
            return null;
        }
        return values
            .map((value) => templates.find((item) => item.value == value))
            .filter((item) => !!item);
    }
    isSelected(value) {
        return this._selectedValues?.some((v) => isEqual(v, value) || v == value) || false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSelectComponent, selector: "fsw-select", providers: [
            FSW_SELECT_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWSelectComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWSelectPrefixDirective, descendants: true }, { propertyName: "itemTemplates", predicate: FSWSelectItemDirective }], usesInheritance: true, ngImport: i0, template: "<div\n  #selectDropdown=\"fswDropdown\"\n  fswDropdown\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [class.focused]=\"isOpen\"\n  [cdkMenuTriggerFor]=\"isReadonly || isDisabled ? null : itemsTemplate\"\n  [cdkMenuPosition]=\"positions\"\n  [fixedWidth]=\"fixedWidth\"\n  [offsetY]=\"offsetY\"\n  (cdkMenuOpened)=\"_onTouched(); isOpen = true\"\n  (cdkMenuClosed)=\"_onTouched(); isOpen = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n  </ng-container>\n  <span class=\"{{ className }}__label\" [class.is-placeholder]=\"isPlaceholder\">{{ render }}</span>\n  <span class=\"{{ className }}__icons\">\n    <i\n      *ngIf=\"selected && !isDisabled && !isReadonly && allowedClear\"\n      [fswIcon]=\"'common-close-circle'\"\n      class=\"{{ className }}__clear-icon\"\n      (click)=\"clear()\"\n    ></i>\n    <i\n      [fswIcon]=\"'common-arrow-dropdown'\"\n      class=\"{{ className }}__arrow-icon\"\n      [class.animate]=\"isOpen\"\n    ></i>\n  </span>\n</div>\n\n<ng-template #itemsTemplate>\n  <fsw-select-container\n    [customClasses]=\"containerClasses\"\n    [maxHeight]=\"maxHeight\"\n    *ngIf=\"itemTemplates?.length\"\n  >\n    <ng-container *ngIf=\"searchPlaceHolder\">\n      <div class=\"{{ className }}__search-box\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [placeholder]=\"searchPlaceHolder\" [formControl]=\"searchControl\" />\n        </fsw-field>\n      </div>\n    </ng-container>\n    <ng-container *ngFor=\"let item of templateFiltered$ | async\">\n      <fsw-select-item\n        (clickEvent)=\"selectItem(item.value); closeOnSelected && selectDropdown.close(true)\"\n        [item]=\"item\"\n        [selected]=\"isSelected(item.value)\"\n        [value]=\"value\"\n        [customClasses]=\"itemClasses\"\n      >\n      </fsw-select-item>\n    </ng-container>\n  </fsw-select-container>\n</ng-template>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "directive", type: FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }, { kind: "directive", type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWSelectContainerComponent, selector: "fsw-select-container", inputs: ["maxHeight", "customClasses"] }, { kind: "component", type: FSWSelectItemComponent, selector: "fsw-select-item", inputs: ["item", "customClasses", "selected", "value"], outputs: ["clickEvent"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-select', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_SELECT_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWSelectComponent,
                        },
                    ], template: "<div\n  #selectDropdown=\"fswDropdown\"\n  fswDropdown\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [class.focused]=\"isOpen\"\n  [cdkMenuTriggerFor]=\"isReadonly || isDisabled ? null : itemsTemplate\"\n  [cdkMenuPosition]=\"positions\"\n  [fixedWidth]=\"fixedWidth\"\n  [offsetY]=\"offsetY\"\n  (cdkMenuOpened)=\"_onTouched(); isOpen = true\"\n  (cdkMenuClosed)=\"_onTouched(); isOpen = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n  </ng-container>\n  <span class=\"{{ className }}__label\" [class.is-placeholder]=\"isPlaceholder\">{{ render }}</span>\n  <span class=\"{{ className }}__icons\">\n    <i\n      *ngIf=\"selected && !isDisabled && !isReadonly && allowedClear\"\n      [fswIcon]=\"'common-close-circle'\"\n      class=\"{{ className }}__clear-icon\"\n      (click)=\"clear()\"\n    ></i>\n    <i\n      [fswIcon]=\"'common-arrow-dropdown'\"\n      class=\"{{ className }}__arrow-icon\"\n      [class.animate]=\"isOpen\"\n    ></i>\n  </span>\n</div>\n\n<ng-template #itemsTemplate>\n  <fsw-select-container\n    [customClasses]=\"containerClasses\"\n    [maxHeight]=\"maxHeight\"\n    *ngIf=\"itemTemplates?.length\"\n  >\n    <ng-container *ngIf=\"searchPlaceHolder\">\n      <div class=\"{{ className }}__search-box\">\n        <fsw-field [fullWidth]=\"true\">\n          <input fswInput [placeholder]=\"searchPlaceHolder\" [formControl]=\"searchControl\" />\n        </fsw-field>\n      </div>\n    </ng-container>\n    <ng-container *ngFor=\"let item of templateFiltered$ | async\">\n      <fsw-select-item\n        (clickEvent)=\"selectItem(item.value); closeOnSelected && selectDropdown.close(true)\"\n        [item]=\"item\"\n        [selected]=\"isSelected(item.value)\"\n        [value]=\"value\"\n        [customClasses]=\"itemClasses\"\n      >\n      </fsw-select-item>\n    </ng-container>\n  </fsw-select-container>\n</ng-template>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWSelectPrefixDirective]
            }], itemTemplates: [{
                type: ContentChildren,
                args: [FSWSelectItemDirective]
            }] } });

const UI$9 = [FSWDropdownDirective];
class FSWDropdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownModule, declarations: [FSWDropdownDirective], imports: [CommonModule], exports: [FSWDropdownDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$9],
                    imports: [CommonModule],
                    exports: [UI$9],
                }]
        }] });

const UI$8 = [
    FSWFieldComponent,
    FSWFieldInputPrefixDirective,
    FSWFieldInputSuffixDirective,
    FSWFieldFooterPrefixDirective,
    FSWFieldFooterSuffixDirective,
    FSWFieldHeaderPrefixDirective,
    FSWFieldHeaderSuffixDirective,
    FSWFieldReadonlyDirective,
    FSWFieldPasswordControlComponent,
];
class FSWFieldModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldModule, declarations: [FSWFieldComponent,
            FSWFieldInputPrefixDirective,
            FSWFieldInputSuffixDirective,
            FSWFieldFooterPrefixDirective,
            FSWFieldFooterSuffixDirective,
            FSWFieldHeaderPrefixDirective,
            FSWFieldHeaderSuffixDirective,
            FSWFieldReadonlyDirective,
            FSWFieldPasswordControlComponent], imports: [CommonModule, FSWIconModule], exports: [FSWFieldComponent,
            FSWFieldInputPrefixDirective,
            FSWFieldInputSuffixDirective,
            FSWFieldFooterPrefixDirective,
            FSWFieldFooterSuffixDirective,
            FSWFieldHeaderPrefixDirective,
            FSWFieldHeaderSuffixDirective,
            FSWFieldReadonlyDirective,
            FSWFieldPasswordControlComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldModule, imports: [CommonModule, FSWIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$8],
                    imports: [CommonModule, FSWIconModule],
                    exports: [UI$8],
                }]
        }] });

class FSWInputPatternDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.pattern = null;
    }
    ngOnInit() {
        if (this.pattern == null) {
            this.elementRef.nativeElement.removeAttribute('pattern');
            return;
        }
        this.elementRef.nativeElement.setAttribute('pattern', this.pattern.toString());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputPatternDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputPatternDirective, selector: "input[fswInputPattern], textarea[fswInputPattern]", inputs: { pattern: ["fswInputPattern", "pattern"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputPatternDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInputPattern], textarea[fswInputPattern]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { pattern: [{
                type: Input,
                args: ['fswInputPattern']
            }] } });

class FSWInputMinDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.min = null;
    }
    ngOnInit() {
        if (this.min == null) {
            this.elementRef.nativeElement.removeAttribute('min');
            return;
        }
        this.elementRef.nativeElement.setAttribute('min', this.min.toString());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMinDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputMinDirective, selector: "input[fswInputMin]", inputs: { min: ["fswInputMin", "min"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMinDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInputMin]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { min: [{
                type: Input,
                args: ['fswInputMin']
            }] } });

class FSWInputMaxDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.max = null;
    }
    ngOnInit() {
        if (this.max == null) {
            this.elementRef.nativeElement.removeAttribute('max');
            return;
        }
        this.elementRef.nativeElement.setAttribute('max', this.max.toString());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMaxDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputMaxDirective, selector: "input[fswInputMax]", inputs: { max: ["fswInputMax", "max"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMaxDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInputMax]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { max: [{
                type: Input,
                args: ['fswInputMax']
            }] } });

class FSWInputMinLengthDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.minLength = null;
    }
    ngOnInit() {
        if (this.minLength == null) {
            this.elementRef.nativeElement.removeAttribute('minLength');
            return;
        }
        this.elementRef.nativeElement.setAttribute('minLength', this.minLength.toString());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMinLengthDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputMinLengthDirective, selector: "input[fswInputMinLength], textarea[fswInputMinLength]", inputs: { minLength: ["fswInputMinLength", "minLength"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMinLengthDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInputMinLength], textarea[fswInputMinLength]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { minLength: [{
                type: Input,
                args: ['fswInputMinLength']
            }] } });

class FSWInputMaxLengthDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.maxLength = null;
    }
    ngOnInit() {
        if (this.maxLength == null) {
            this.elementRef.nativeElement.removeAttribute('maxLength');
            return;
        }
        this.elementRef.nativeElement.setAttribute('maxLength', this.maxLength.toString());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMaxLengthDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWInputMaxLengthDirective, selector: "input[fswInputMaxLength], textarea[fswInputMaxLength]", inputs: { maxLength: ["fswInputMaxLength", "maxLength"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputMaxLengthDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[fswInputMaxLength], textarea[fswInputMaxLength]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { maxLength: [{
                type: Input,
                args: ['fswInputMaxLength']
            }] } });

const UI$7 = [
    FSWInputDirective,
    FSWInputPatternDirective,
    FSWInputMinDirective,
    FSWInputMaxDirective,
    FSWInputMinLengthDirective,
    FSWInputMaxLengthDirective,
];
class FSWInputModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWInputModule, declarations: [FSWInputDirective,
            FSWInputPatternDirective,
            FSWInputMinDirective,
            FSWInputMaxDirective,
            FSWInputMinLengthDirective,
            FSWInputMaxLengthDirective], exports: [FSWInputDirective,
            FSWInputPatternDirective,
            FSWInputMinDirective,
            FSWInputMaxDirective,
            FSWInputMinLengthDirective,
            FSWInputMaxLengthDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$7],
                    exports: [UI$7],
                }]
        }] });

const UI$6 = [
    FSWSelectComponent,
    FSWSelectContainerComponent,
    FSWSelectItemComponent,
    FSWSelectPrefixDirective,
    FSWSelectItemDirective,
];
class FSWSelectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectModule, declarations: [FSWSelectComponent,
            FSWSelectContainerComponent,
            FSWSelectItemComponent,
            FSWSelectPrefixDirective,
            FSWSelectItemDirective], imports: [CommonModule,
            FSWIconModule,
            CdkMenuModule,
            FSWDropdownModule,
            FSWCheckboxModule,
            FormsModule,
            FSWRadioModule,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule], exports: [FSWSelectComponent,
            FSWSelectContainerComponent,
            FSWSelectItemComponent,
            FSWSelectPrefixDirective,
            FSWSelectItemDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectModule, imports: [CommonModule,
            FSWIconModule,
            CdkMenuModule,
            FSWDropdownModule,
            FSWCheckboxModule,
            FormsModule,
            FSWRadioModule,
            FSWFieldModule,
            FSWInputModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$6],
                    exports: [UI$6],
                    imports: [
                        CommonModule,
                        FSWIconModule,
                        CdkMenuModule,
                        FSWDropdownModule,
                        FSWCheckboxModule,
                        FormsModule,
                        FSWRadioModule,
                        FSWFieldModule,
                        FSWInputModule,
                        ReactiveFormsModule,
                    ],
                }]
        }] });

class FSWPaginationComponent {
    get listPage() {
        const length = this.sumOfPages;
        if (length < 1) {
            return [];
        }
        if (length <= 7) {
            return Array.from({ length }).map((_, i) => ({
                value: i + 1,
                key: i + 1,
            }));
        }
        const distanceFromFirstPage = this.currentPage - 1;
        const distanceFromLastPage = length - this.currentPage;
        const numberOfItemsNotAvailableToShow = length - 6;
        const maxNumberOfItemsNotAvailableToShow = numberOfItemsNotAvailableToShow < 4 ? numberOfItemsNotAvailableToShow : 4;
        const showFirstTruncation = distanceFromFirstPage > maxNumberOfItemsNotAvailableToShow;
        const showLastTruncation = distanceFromLastPage > 4;
        const numberOfTruncations = (showFirstTruncation ? 1 : 0) + (showLastTruncation ? 1 : 0);
        return [
            this._generatePage(1),
            numberOfTruncations === 2
                ? this._truncationPage
                : showFirstTruncation
                    ? this._truncationPage
                    : this._generatePage(2),
            numberOfTruncations === 2
                ? this._generatePage(this.currentPage - 1)
                : showFirstTruncation
                    ? this._generatePage(length - 4)
                    : this._generatePage(3),
            numberOfTruncations === 2
                ? this._generatePage(this.currentPage)
                : showFirstTruncation
                    ? this._generatePage(length - 3)
                    : this._generatePage(4),
            numberOfTruncations === 2
                ? this._generatePage(this.currentPage + 1)
                : showFirstTruncation
                    ? this._generatePage(length - 2)
                    : this._generatePage(5),
            numberOfTruncations === 2
                ? this._truncationPage
                : showLastTruncation
                    ? this._truncationPage
                    : this._generatePage(length - 1),
            this._generatePage(length),
        ];
    }
    get sumOfPages() {
        if (this.total <= this.itemsPerPage) {
            return 1;
        }
        const remainder = this.total % this.itemsPerPage;
        const beautyTotal = this.total - remainder;
        return beautyTotal / this.itemsPerPage + (remainder > 0 ? 1 : 0);
    }
    get isFirstPage() {
        return this.currentPage === 1;
    }
    get isLastPage() {
        return this.currentPage === this.sumOfPages;
    }
    get totalText() {
        const min = (this.currentPage - 1) * this.itemsPerPage + 1;
        const max = this.currentPage * this.itemsPerPage > this.total
            ? this.total
            : this.currentPage * this.itemsPerPage;
        return `${min}-${max}`;
    }
    get _truncationPage() {
        return {
            key: 'truncation',
            value: '...',
        };
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this.currentPageChange = new EventEmitter();
        this.itemsPerPageChange = new EventEmitter();
        this.total = 0;
        this.itemsPerPage = 10;
        this.currentPage = 1;
        this.itemsPerPageOptions = [10, 20, 50];
        this.showSelectOptions = true;
        this.showViewTotalText = true;
        this.showNavigationText = true;
        this.totalTextInside = false;
        this.className = 'fsw-pagination';
        this.FSWSelectItemKind = FSWSelectItemKind;
        this.numberOfItemsPerPageOptions = this._getNumberOfItemsPerPageOptions();
    }
    ngOnChanges() {
        this.numberOfItemsPerPageOptions = this._getNumberOfItemsPerPageOptions();
    }
    pageSelection(value) {
        this.currentPage = Number.parseInt(`${value}`);
        this.currentPageChange.next(this.currentPage);
        this._cdr.markForCheck();
    }
    itemsPerPageSelection(value) {
        const current = this.currentPage * this.itemsPerPage > this.total
            ? this.total
            : this.currentPage * this.itemsPerPage;
        this.itemsPerPage = value;
        this.itemsPerPageChange.next(this.itemsPerPage);
        this._resolveCurrentPage(current);
        this._cdr.markForCheck();
    }
    next() {
        this.currentPage += 1;
        this.currentPageChange.next(this.currentPage);
    }
    previous() {
        this.currentPage -= 1;
        this.currentPageChange.next(this.currentPage);
    }
    _resolveCurrentPage(oldCurrentPageItems) {
        if (this.currentPage === 1) {
            return;
        }
        if (this.itemsPerPage >= oldCurrentPageItems) {
            this.currentPage = 1;
            this.currentPageChange.next(this.currentPage);
            return;
        }
        const div = oldCurrentPageItems % this.itemsPerPage;
        this.currentPage = (oldCurrentPageItems - div) / this.itemsPerPage + (div > 0 ? 1 : 0);
        this.currentPageChange.next(this.currentPage);
    }
    _generatePage(value) {
        return {
            key: value,
            value,
        };
    }
    _getNumberOfItemsPerPageOptions() {
        return [...(this.itemsPerPageOptions || [10, 20, 50]).sort(), 'all'].map((e) => ({
            value: (e === 'all' ? this.total : e),
            render: e,
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPaginationComponent, selector: "fsw-pagination", inputs: { total: "total", itemsPerPage: "itemsPerPage", currentPage: "currentPage", itemsPerPageOptions: "itemsPerPageOptions", showSelectOptions: "showSelectOptions", showViewTotalText: "showViewTotalText", showNavigationText: "showNavigationText", totalTextInside: "totalTextInside" }, outputs: { currentPageChange: "currentPageChange", itemsPerPageChange: "itemsPerPageChange" }, usesOnChanges: true, ngImport: i0, template: "<nav class=\"{{ className }}\" *ngIf=\"total\">\n  <main>\n    <button\n      [attr.content]=\"showNavigationText ? 'Prev' : null\"\n      [class.show-content]=\"showNavigationText\"\n      [disabled]=\"isFirstPage\"\n      (click)=\"!isFirstPage && previous()\"\n    ></button>\n    <ng-container *ngIf=\"!totalTextInside; else totalTextTemplate\">\n      <ul>\n        <ng-container *ngFor=\"let page of listPage\">\n          <ng-container *ngIf=\"page.key === 'truncation'; else defaultItemTemplate\">\n            <li>...</li>\n          </ng-container>\n          <ng-template #defaultItemTemplate>\n            <li\n              (click)=\"pageSelection(page.key)\"\n              [class]=\"'not-truncation'\"\n              [class.active]=\"currentPage === page.key\"\n            >\n              {{ page.value }}\n            </li>\n          </ng-template>\n        </ng-container>\n      </ul>\n    </ng-container>\n    <button\n      [attr.content]=\"showNavigationText ? 'Next' : null\"\n      [class.show-content]=\"showNavigationText\"\n      [disabled]=\"isLastPage\"\n      (click)=\"!isLastPage && next()\"\n    ></button>\n  </main>\n  <ng-container *ngIf=\"showSelectOptions\">\n    <fsw-field [size]=\"'s'\">\n      <fsw-select\n        [ngModel]=\"itemsPerPage\"\n        (ngModelChange)=\"itemsPerPageSelection($event)\"\n        [allowedClear]=\"false\"\n      >\n        <ng-container *ngFor=\"let item of numberOfItemsPerPageOptions\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [value]=\"item.value\"\n            [kind]=\"FSWSelectItemKind.CUSTOM\"\n            [text]=\"'View ' + item.render\"\n          >\n            <small class=\"{{ className }}__option-item\" [class.active]=\"selected\">\n              View {{ item.render }}\n            </small>\n          </ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n  </ng-container>\n  <ng-container\n    *ngIf=\"!showViewTotalText || totalTextInside; else totalTextTemplate\"\n  ></ng-container>\n  <ng-template #totalTextTemplate>\n    <label>\n      <span>{{ totalText }}</span>\n      <span>of {{ total }}</span>\n    </label>\n  </ng-template>\n</nav>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<nav class=\"{{ className }}\" *ngIf=\"total\">\n  <main>\n    <button\n      [attr.content]=\"showNavigationText ? 'Prev' : null\"\n      [class.show-content]=\"showNavigationText\"\n      [disabled]=\"isFirstPage\"\n      (click)=\"!isFirstPage && previous()\"\n    ></button>\n    <ng-container *ngIf=\"!totalTextInside; else totalTextTemplate\">\n      <ul>\n        <ng-container *ngFor=\"let page of listPage\">\n          <ng-container *ngIf=\"page.key === 'truncation'; else defaultItemTemplate\">\n            <li>...</li>\n          </ng-container>\n          <ng-template #defaultItemTemplate>\n            <li\n              (click)=\"pageSelection(page.key)\"\n              [class]=\"'not-truncation'\"\n              [class.active]=\"currentPage === page.key\"\n            >\n              {{ page.value }}\n            </li>\n          </ng-template>\n        </ng-container>\n      </ul>\n    </ng-container>\n    <button\n      [attr.content]=\"showNavigationText ? 'Next' : null\"\n      [class.show-content]=\"showNavigationText\"\n      [disabled]=\"isLastPage\"\n      (click)=\"!isLastPage && next()\"\n    ></button>\n  </main>\n  <ng-container *ngIf=\"showSelectOptions\">\n    <fsw-field [size]=\"'s'\">\n      <fsw-select\n        [ngModel]=\"itemsPerPage\"\n        (ngModelChange)=\"itemsPerPageSelection($event)\"\n        [allowedClear]=\"false\"\n      >\n        <ng-container *ngFor=\"let item of numberOfItemsPerPageOptions\">\n          <ng-template\n            fswSelectItem\n            let-selected\n            [value]=\"item.value\"\n            [kind]=\"FSWSelectItemKind.CUSTOM\"\n            [text]=\"'View ' + item.render\"\n          >\n            <small class=\"{{ className }}__option-item\" [class.active]=\"selected\">\n              View {{ item.render }}\n            </small>\n          </ng-template>\n        </ng-container>\n      </fsw-select>\n    </fsw-field>\n  </ng-container>\n  <ng-container\n    *ngIf=\"!showViewTotalText || totalTextInside; else totalTextTemplate\"\n  ></ng-container>\n  <ng-template #totalTextTemplate>\n    <label>\n      <span>{{ totalText }}</span>\n      <span>of {{ total }}</span>\n    </label>\n  </ng-template>\n</nav>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { currentPageChange: [{
                type: Output
            }], itemsPerPageChange: [{
                type: Output
            }], total: [{
                type: Input
            }], itemsPerPage: [{
                type: Input
            }], currentPage: [{
                type: Input
            }], itemsPerPageOptions: [{
                type: Input
            }], showSelectOptions: [{
                type: Input
            }], showViewTotalText: [{
                type: Input
            }], showNavigationText: [{
                type: Input
            }], totalTextInside: [{
                type: Input
            }] } });

const UI$5 = [FSWPaginationComponent];
class FSWPaginationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, declarations: [FSWPaginationComponent], imports: [CommonModule, FSWSelectModule, FormsModule, FSWFieldModule], exports: [FSWPaginationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, imports: [CommonModule, FSWSelectModule, FormsModule, FSWFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$5],
                    exports: [UI$5],
                    imports: [CommonModule, FSWSelectModule, FormsModule, FSWFieldModule],
                }]
        }] });

var FSWTabsSizes;
(function (FSWTabsSizes) {
    FSWTabsSizes["M"] = "m";
    FSWTabsSizes["S"] = "s";
})(FSWTabsSizes || (FSWTabsSizes = {}));

var FSWTabsStyles;
(function (FSWTabsStyles) {
    FSWTabsStyles["INLINE"] = "inline";
    FSWTabsStyles["STACKED"] = "stacked";
})(FSWTabsStyles || (FSWTabsStyles = {}));

var FSWTabsBackgroundStyles;
(function (FSWTabsBackgroundStyles) {
    FSWTabsBackgroundStyles["UNDERLINE"] = "underline";
    FSWTabsBackgroundStyles["FILL"] = "fill";
})(FSWTabsBackgroundStyles || (FSWTabsBackgroundStyles = {}));

var FSWTabsStatuses;
(function (FSWTabsStatuses) {
    FSWTabsStatuses["DEFAULT"] = "default";
    FSWTabsStatuses["SUCCESS"] = "success";
    FSWTabsStatuses["MISSING"] = "missing";
    FSWTabsStatuses["ERROR"] = "error";
})(FSWTabsStatuses || (FSWTabsStatuses = {}));

const FSW_TABS_GROUP_TOKEN = new InjectionToken('FSW_TABS_GROUP_TOKEN');

let FSWTabsBase = class FSWTabsBase {
    constructor(_cdr, _tabsGroupComponent) {
        this._cdr = _cdr;
        this._tabsGroupComponent = _tabsGroupComponent;
        this.selectTab = new EventEmitter();
        //#region Inputs
        this.key = randomId();
        this.label = null;
        this.maxTextWidth = null;
        this.icon = null;
        this.iconClass = null;
        this.iconFontSize = null;
        this.size = FSWTabsSizes.M;
        this.renderStyle = FSWTabsStyles.INLINE;
        this.status = FSWTabsStatuses.DEFAULT;
        this.backgroundStyle = FSWTabsBackgroundStyles.UNDERLINE;
        this.active = false;
        this.className = 'fsw-tabs';
    }
    select() {
        this.selectTab.emit(this.key);
        if (!this._tabsGroupComponent)
            return;
        this._tabsGroupComponent.setKey(this.key);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsBase, deps: [{ token: i0.ChangeDetectorRef }, { token: FSW_TABS_GROUP_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTabsBase, inputs: { key: "key", label: "label", maxTextWidth: "maxTextWidth", icon: "icon", iconClass: "iconClass", iconFontSize: "iconFontSize", size: "size", renderStyle: "renderStyle", status: "status", backgroundStyle: "backgroundStyle", active: "active" }, outputs: { selectTab: "selectTab" }, ngImport: i0 }); }
};
FSWTabsBase = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ChangeDetectorRef, Object])
], FSWTabsBase);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_TABS_GROUP_TOKEN]
                }] }]; }, propDecorators: { selectTab: [{
                type: Output
            }], key: [{
                type: Input
            }], label: [{
                type: Input
            }], maxTextWidth: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], iconFontSize: [{
                type: Input
            }], size: [{
                type: Input
            }], renderStyle: [{
                type: Input
            }], status: [{
                type: Input
            }], backgroundStyle: [{
                type: Input
            }], active: [{
                type: Input
            }] } });

class FSWTabsGroupBase {
    constructor(_cdr) {
        this._cdr = _cdr;
        this.activeKeyChange = new EventEmitter();
        this.activeKey = null;
        this.customRowGap = null;
        this.customColumnGap = null;
        this.listTemplate = null;
        this.className = 'fsw-tabs-group';
    }
    ngAfterViewInit() {
        this.updateListTemplate();
    }
    updateListTemplate() {
        this.listTemplate = [...(this.itemTemplates || [])];
        if (!this.listTemplate?.length) {
            this._cdr.detectChanges();
            return;
        }
        if (this.activeKey) {
            this._cdr.detectChanges();
            return;
        }
        this.activeKey = this.listTemplate[0].key;
        this.listTemplate[0].selectTab.emit(this.activeKey);
        this._cdr.detectChanges();
    }
    setKey(value) {
        this.activeKey = value;
        this.activeKeyChange.emit(this.activeKey);
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsGroupBase, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTabsGroupBase, inputs: { activeKey: "activeKey", customRowGap: "customRowGap", customColumnGap: "customColumnGap" }, outputs: { activeKeyChange: "activeKeyChange" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsGroupBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { activeKeyChange: [{
                type: Output
            }], activeKey: [{
                type: Input
            }], customRowGap: [{
                type: Input
            }], customColumnGap: [{
                type: Input
            }] } });

class FSWTabsDirective extends FSWTabsBase {
    constructor(templateRef, _cdr, _tabsGroupComponent) {
        super(_cdr, _tabsGroupComponent);
        this.templateRef = templateRef;
        this._cdr = _cdr;
        this._tabsGroupComponent = _tabsGroupComponent;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ChangeDetectorRef }, { token: FSW_TABS_GROUP_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTabsDirective, selector: "ng-template[fswTabs]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswTabs]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_TABS_GROUP_TOKEN]
                }] }]; } });

class FSWTabsComponent extends FSWTabsBase {
    constructor() {
        super(...arguments);
        this.tooltipPosition = [
            {
                originX: 'center',
                originY: 'bottom',
                overlayX: 'center',
                overlayY: 'top',
                offsetY: 12,
            },
            {
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom',
            },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWTabsComponent, selector: "fsw-tabs", usesInheritance: true, ngImport: i0, template: "<span\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }} {{ className }}--status-{{\n    status\n  }} {{ className }}--size-{{ size }} {{ className }}--background-style-{{ backgroundStyle }}\"\n  (click)=\"select()\"\n  [class.active]=\"active\"\n  [style.--fsw-tabs-text-width]=\"maxTextWidth\"\n>\n  <i *ngIf=\"icon\" [fswIcon]=\"icon\" [class]=\"iconClass\" [fontSize]=\"iconFontSize\"></i>\n  <span\n    *ngIf=\"label\"\n    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n    [cdkMenuPosition]=\"tooltipPosition\"\n    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n    (mouseenter)=\"cdkMenuTrigger.open()\"\n    (mouseleave)=\"cdkMenuTrigger.close()\"\n    >{{ label }}</span\n  >\n  <ng-template #tooltipTemplate>\n    <span fswTooltip [size]=\"'s'\">{{ label }}</span>\n  </ng-template>\n</span>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: FSWTooltipDirective, selector: "[fswTooltip]" }, { kind: "directive", type: i2.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-tabs', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span\n  class=\"{{ className }} {{ className }}--style-{{ renderStyle }} {{ className }}--status-{{\n    status\n  }} {{ className }}--size-{{ size }} {{ className }}--background-style-{{ backgroundStyle }}\"\n  (click)=\"select()\"\n  [class.active]=\"active\"\n  [style.--fsw-tabs-text-width]=\"maxTextWidth\"\n>\n  <i *ngIf=\"icon\" [fswIcon]=\"icon\" [class]=\"iconClass\" [fontSize]=\"iconFontSize\"></i>\n  <span\n    *ngIf=\"label\"\n    [cdkMenuTriggerFor]=\"tooltipTemplate\"\n    [cdkMenuPosition]=\"tooltipPosition\"\n    #cdkMenuTrigger=\"cdkMenuTriggerFor\"\n    (mouseenter)=\"cdkMenuTrigger.open()\"\n    (mouseleave)=\"cdkMenuTrigger.close()\"\n    >{{ label }}</span\n  >\n  <ng-template #tooltipTemplate>\n    <span fswTooltip [size]=\"'s'\">{{ label }}</span>\n  </ng-template>\n</span>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWTabsGroupComponent extends FSWTabsGroupBase {
    constructor() {
        super(...arguments);
        this._itemTemplates = null;
    }
    set itemTemplates(value) {
        this._itemTemplates = value;
        this.updateListTemplate();
    }
    get itemTemplates() {
        return this._itemTemplates;
    }
    get activeTab() {
        return this.listTemplate?.find((item) => item.key === this.activeKey);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWTabsGroupComponent, selector: "fsw-tabs-group", providers: [
            {
                provide: FSW_TABS_GROUP_TOKEN,
                useExisting: FSWTabsGroupComponent,
            },
        ], queries: [{ propertyName: "itemTemplates", predicate: FSWTabsDirective }], usesInheritance: true, ngImport: i0, template: "<nav\n  class=\"{{ className }}\"\n  *ngIf=\"listTemplate?.length\"\n  [style.--fsw-tabs-group-row-gap]=\"customRowGap\"\n  [style.--fsw-tabs-group-column-gap]=\"customColumnGap\"\n>\n  <header>\n    <ng-container *ngFor=\"let item of listTemplate\">\n      <fsw-tabs\n        (selectTab)=\"item.selectTab.emit(item.key)\"\n        [icon]=\"item.icon\"\n        [renderStyle]=\"item.renderStyle\"\n        [size]=\"item.size\"\n        [maxTextWidth]=\"item.maxTextWidth\"\n        [status]=\"item.status\"\n        [key]=\"item.key\"\n        [label]=\"item.label\"\n        [backgroundStyle]=\"item.backgroundStyle\"\n        [active]=\"activeTab?.key === item.key\"\n        [iconClass]=\"item.iconClass\"\n        [iconFontSize]=\"item.iconFontSize\"\n      ></fsw-tabs>\n    </ng-container>\n  </header>\n  <ng-container *ngIf=\"activeTab\">\n    <main>\n      <ng-container *ngTemplateOutlet=\"activeTab.templateRef\"></ng-container>\n    </main>\n  </ng-container>\n</nav>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: FSWTabsComponent, selector: "fsw-tabs" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-tabs-group', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: FSW_TABS_GROUP_TOKEN,
                            useExisting: FSWTabsGroupComponent,
                        },
                    ], template: "<nav\n  class=\"{{ className }}\"\n  *ngIf=\"listTemplate?.length\"\n  [style.--fsw-tabs-group-row-gap]=\"customRowGap\"\n  [style.--fsw-tabs-group-column-gap]=\"customColumnGap\"\n>\n  <header>\n    <ng-container *ngFor=\"let item of listTemplate\">\n      <fsw-tabs\n        (selectTab)=\"item.selectTab.emit(item.key)\"\n        [icon]=\"item.icon\"\n        [renderStyle]=\"item.renderStyle\"\n        [size]=\"item.size\"\n        [maxTextWidth]=\"item.maxTextWidth\"\n        [status]=\"item.status\"\n        [key]=\"item.key\"\n        [label]=\"item.label\"\n        [backgroundStyle]=\"item.backgroundStyle\"\n        [active]=\"activeTab?.key === item.key\"\n        [iconClass]=\"item.iconClass\"\n        [iconFontSize]=\"item.iconFontSize\"\n      ></fsw-tabs>\n    </ng-container>\n  </header>\n  <ng-container *ngIf=\"activeTab\">\n    <main>\n      <ng-container *ngTemplateOutlet=\"activeTab.templateRef\"></ng-container>\n    </main>\n  </ng-container>\n</nav>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { itemTemplates: [{
                type: ContentChildren,
                args: [FSWTabsDirective]
            }] } });

const UI$4 = [FSWTabsComponent, FSWTabsGroupComponent, FSWTabsDirective];
class FSWTabsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsModule, declarations: [FSWTabsComponent, FSWTabsGroupComponent, FSWTabsDirective], imports: [CommonModule, FSWIconModule, FSWTooltipModule, CdkMenuModule], exports: [FSWTabsComponent, FSWTabsGroupComponent, FSWTabsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsModule, imports: [CommonModule, FSWIconModule, FSWTooltipModule, CdkMenuModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$4],
                    exports: [UI$4],
                    imports: [CommonModule, FSWIconModule, FSWTooltipModule, CdkMenuModule],
                }]
        }] });

var FSWTagsSizes;
(function (FSWTagsSizes) {
    FSWTagsSizes["M"] = "m";
    FSWTagsSizes["S"] = "s";
})(FSWTagsSizes || (FSWTagsSizes = {}));

var FSWTagsStyles;
(function (FSWTagsStyles) {
    FSWTagsStyles["DEFAULT"] = "default";
    FSWTagsStyles["OUTLINE"] = "outline";
    FSWTagsStyles["DOTTED"] = "dotted";
})(FSWTagsStyles || (FSWTagsStyles = {}));

var FSWTagsColors;
(function (FSWTagsColors) {
    FSWTagsColors["BLUE"] = "blue";
    FSWTagsColors["GRAY"] = "gray";
    FSWTagsColors["YELLOW"] = "yellow";
    FSWTagsColors["RED"] = "red";
    FSWTagsColors["GREEN"] = "green";
    FSWTagsColors["PURPLE"] = "purple";
})(FSWTagsColors || (FSWTagsColors = {}));

class FSWTagsBase {
    constructor() {
        this.closeClick = new EventEmitter();
        this.color = FSWTagsColors.BLUE;
        this.renderStyle = FSWTagsStyles.DEFAULT;
        this.size = FSWTagsSizes.M;
        this.icon = null;
        this.hiddenCloseButton = false;
        this.disabled = false;
        this.selected = false;
        this.className = 'fsw-tags';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTagsBase, inputs: { color: "color", renderStyle: "renderStyle", size: "size", icon: "icon", hiddenCloseButton: "hiddenCloseButton", disabled: "disabled", selected: "selected" }, outputs: { closeClick: "closeClick" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsBase, decorators: [{
            type: Directive
        }], propDecorators: { closeClick: [{
                type: Output
            }], color: [{
                type: Input
            }], renderStyle: [{
                type: Input
            }], size: [{
                type: Input
            }], icon: [{
                type: Input
            }], hiddenCloseButton: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selected: [{
                type: Input
            }] } });

class FSWTagsDirective extends FSWTagsBase {
    get hostClassName() {
        return `${this.className} ${this.className}--style-${this.renderStyle} ${this.className}--size-${this.size} ${this.className}--color-${this.color}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTagsDirective, selector: "[fswTags]", host: { properties: { "class": "hostClassName", "class.disabled": "disabled", "class.selected": "selected" } }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswTags]',
                    host: {
                        '[class]': 'hostClassName',
                        '[class.disabled]': 'disabled',
                        '[class.selected]': 'selected',
                    },
                }]
        }] });

class FSWTagsComponent extends FSWTagsBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWTagsComponent, selector: "fsw-tags", usesInheritance: true, ngImport: i0, template: "<span\n  fswTags\n  [color]=\"color\"\n  [renderStyle]=\"renderStyle\"\n  [size]=\"size\"\n  [disabled]=\"disabled\"\n  [selected]=\"selected\"\n>\n  <i *ngIf=\"icon\" [fswIcon]=\"icon\"></i>\n  <span>\n    <ng-content></ng-content>\n  </span>\n  <i\n    *ngIf=\"!hiddenCloseButton\"\n    (click)=\"closeClick.emit()\"\n    [fswIcon]=\"'common-close'\"\n    class=\"{{ className }}__close-icon\"\n  ></i>\n</span>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: FSWTagsDirective, selector: "[fswTags]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-tags', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span\n  fswTags\n  [color]=\"color\"\n  [renderStyle]=\"renderStyle\"\n  [size]=\"size\"\n  [disabled]=\"disabled\"\n  [selected]=\"selected\"\n>\n  <i *ngIf=\"icon\" [fswIcon]=\"icon\"></i>\n  <span>\n    <ng-content></ng-content>\n  </span>\n  <i\n    *ngIf=\"!hiddenCloseButton\"\n    (click)=\"closeClick.emit()\"\n    [fswIcon]=\"'common-close'\"\n    class=\"{{ className }}__close-icon\"\n  ></i>\n</span>\n", styles: [":host{display:contents}\n"] }]
        }] });

const UI$3 = [FSWTagsComponent, FSWTagsDirective];
class FSWTagsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsModule, declarations: [FSWTagsComponent, FSWTagsDirective], imports: [CommonModule, FSWIconModule], exports: [FSWTagsComponent, FSWTagsDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsModule, imports: [CommonModule, FSWIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTagsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWIconModule],
                    declarations: [UI$3],
                    exports: [UI$3],
                }]
        }] });

class FSWPanelHeaderSuffixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelHeaderSuffixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWPanelHeaderSuffixDirective, selector: "ng-template[fswPanelHeaderSuffix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelHeaderSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswPanelHeaderSuffix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWPanelComponent {
    constructor() {
        //#region Inputs
        this.headerSuffix = null;
        this.title = '';
        this.titleClasses = '';
        this.headerClasses = '';
        this.customClasses = '';
        this.className = 'fsw-panel';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWPanelComponent, selector: "fsw-panel", inputs: { title: "title", titleClasses: "titleClasses", headerClasses: "headerClasses", customClasses: "customClasses" }, queries: [{ propertyName: "headerSuffix", first: true, predicate: FSWPanelHeaderSuffixDirective, descendants: true }], ngImport: i0, template: "<section class=\"{{ className }} {{ customClasses }}\">\n  <header *ngIf=\"title || headerSuffix\" class=\"{{ headerClasses }}\">\n    <h6 class=\"{{ titleClasses }}\">{{ title }}</h6>\n    <ng-container *ngIf=\"headerSuffix\">\n      <ng-container *ngTemplateOutlet=\"headerSuffix.templateRef\"></ng-container>\n    </ng-container>\n  </header>\n  <main>\n    <ng-content></ng-content>\n  </main>\n</section>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-panel', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section class=\"{{ className }} {{ customClasses }}\">\n  <header *ngIf=\"title || headerSuffix\" class=\"{{ headerClasses }}\">\n    <h6 class=\"{{ titleClasses }}\">{{ title }}</h6>\n    <ng-container *ngIf=\"headerSuffix\">\n      <ng-container *ngTemplateOutlet=\"headerSuffix.templateRef\"></ng-container>\n    </ng-container>\n  </header>\n  <main>\n    <ng-content></ng-content>\n  </main>\n</section>\n" }]
        }], propDecorators: { headerSuffix: [{
                type: ContentChild,
                args: [FSWPanelHeaderSuffixDirective]
            }], title: [{
                type: Input
            }], titleClasses: [{
                type: Input
            }], headerClasses: [{
                type: Input
            }], customClasses: [{
                type: Input
            }] } });

const UI$2 = [FSWPanelComponent, FSWPanelHeaderSuffixDirective];
class FSWPanelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelModule, declarations: [FSWPanelComponent, FSWPanelHeaderSuffixDirective], imports: [CommonModule], exports: [FSWPanelComponent, FSWPanelHeaderSuffixDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI$2],
                    exports: [UI$2],
                    imports: [CommonModule],
                }]
        }] });

class FSWModalComponent {
    get fadeIn() {
        return this.animationStatus;
    }
    constructor() {
        this.body = null;
        this.footer = null;
        this.closeEvent = new EventEmitter();
        this.confirmEvent = new EventEmitter();
        this.cancelEvent = new EventEmitter();
        this.afterOpenedEvent = new EventEmitter();
        this.afterClosedEvent = new EventEmitter();
        this.title = '';
        this.confirmButton = null;
        this.confirmButtonAppearance = FSWButtonAppearances.PRIMARY;
        this.confirmButtonSize = FSWButtonSizes.M;
        this.confirmButtonDisabled = false;
        this.cancelButton = null;
        this.cancelButtonAppearance = FSWButtonAppearances.SECONDARY;
        this.cancelButtonSize = FSWButtonSizes.M;
        this.cancelButtonDisabled = false;
        this.hiddenCloseButton = false;
        this.hiddenBody = false;
        this.hiddenFooter = false;
        this.closeOnConfirm = false;
        this.closeOnCancel = false;
        this.size = FSWModalSizes.M;
        this.buttonStyle = FSWModalButtonStyles.RIGHT_BLOCK;
        this.buttonDirection = FSWModalButtonDirections.LTR;
        this.fullBlock = false;
        this.bodyCustomClasses = '';
        this.customWidth = null;
        this.animationStatus = 'enter';
        this.FSWModalButtonDirections = FSWModalButtonDirections;
        this.className = 'fsw-modal';
    }
    confirm() {
        if (this.confirmButtonDisabled) {
            return;
        }
        this.confirmEvent.emit();
        if (this.closeOnConfirm) {
            this.close();
        }
    }
    cancel() {
        if (this.cancelButtonDisabled) {
            return;
        }
        this.cancelEvent.emit();
        if (this.closeOnCancel) {
            this.close();
        }
    }
    close() {
        this.closeEvent.emit();
    }
    animationDone() {
        if (this.animationStatus === 'leave') {
            this.afterClosedEvent.emit();
        }
        else {
            this.afterOpenedEvent.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWModalComponent, selector: "fsw-modal", inputs: { title: "title", confirmButton: "confirmButton", confirmButtonAppearance: "confirmButtonAppearance", confirmButtonSize: "confirmButtonSize", confirmButtonDisabled: "confirmButtonDisabled", cancelButton: "cancelButton", cancelButtonAppearance: "cancelButtonAppearance", cancelButtonSize: "cancelButtonSize", cancelButtonDisabled: "cancelButtonDisabled", hiddenCloseButton: "hiddenCloseButton", hiddenBody: "hiddenBody", hiddenFooter: "hiddenFooter", closeOnConfirm: "closeOnConfirm", closeOnCancel: "closeOnCancel", size: "size", buttonStyle: "buttonStyle", buttonDirection: "buttonDirection", fullBlock: "fullBlock", bodyCustomClasses: "bodyCustomClasses", customWidth: "customWidth" }, outputs: { closeEvent: "closeEvent", confirmEvent: "confirmEvent", cancelEvent: "cancelEvent", afterOpenedEvent: "afterOpenedEvent", afterClosedEvent: "afterClosedEvent" }, host: { listeners: { "@fadeIn.done": "animationDone()" }, properties: { "@fadeIn": "this.fadeIn" } }, queries: [{ propertyName: "body", first: true, predicate: FSWModalBodyDirective, descendants: true }, { propertyName: "footer", first: true, predicate: FSWModalFooterDirective, descendants: true }], ngImport: i0, template: "<section\n  class=\"{{ className }} {{ className }}--size-{{ size }}\"\n  [style.--fsw-modal-custom-width]=\"customWidth || '464px'\"\n>\n  <header>\n    <h5>{{ title }}</h5>\n    <i\n      *ngIf=\"!hiddenCloseButton\"\n      class=\"{{ className }}__close-icon\"\n      [fswIcon]=\"'common-close'\"\n      (click)=\"close()\"\n    ></i>\n  </header>\n  <main *ngIf=\"body && !hiddenBody\" class=\"{{ bodyCustomClasses }}\">\n    <ng-container *ngTemplateOutlet=\"body.templateRef\"></ng-container>\n  </main>\n  <footer\n    *ngIf=\"\n      (!hiddenFooter && footer) || (!hiddenFooter && !footer && (cancelButton || confirmButton))\n    \"\n    class=\"button-style--{{ buttonStyle }}\"\n  >\n    <ng-container *ngIf=\"footer; else defaultFooter\">\n      <ng-container *ngTemplateOutlet=\"footer.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #defaultFooter>\n      <ng-container\n        *ngIf=\"buttonDirection === FSWModalButtonDirections.RTL; else defaultDirectionTemplate\"\n      >\n        <ng-container *ngTemplateOutlet=\"confirmButtonTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"cancelButtonTemplate\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDirectionTemplate>\n        <ng-container *ngTemplateOutlet=\"cancelButtonTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"confirmButtonTemplate\"></ng-container>\n      </ng-template>\n      <ng-template #confirmButtonTemplate>\n        <ng-container *ngIf=\"confirmButton\">\n          <button\n            fswButton\n            [appearance]=\"confirmButtonAppearance\"\n            [size]=\"confirmButtonSize\"\n            [disabled]=\"confirmButtonDisabled\"\n            (click)=\"confirm()\"\n          >\n            {{ confirmButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n      <ng-template #cancelButtonTemplate>\n        <ng-container *ngIf=\"cancelButton\">\n          <button\n            fswButton\n            [appearance]=\"cancelButtonAppearance\"\n            [size]=\"cancelButtonSize\"\n            [disabled]=\"cancelButtonDisabled\"\n            (click)=\"cancel()\"\n          >\n            {{ cancelButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n    </ng-template>\n  </footer>\n</section>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }], animations: [fadeIn], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-modal', changeDetection: ChangeDetectionStrategy.OnPush, animations: [fadeIn], template: "<section\n  class=\"{{ className }} {{ className }}--size-{{ size }}\"\n  [style.--fsw-modal-custom-width]=\"customWidth || '464px'\"\n>\n  <header>\n    <h5>{{ title }}</h5>\n    <i\n      *ngIf=\"!hiddenCloseButton\"\n      class=\"{{ className }}__close-icon\"\n      [fswIcon]=\"'common-close'\"\n      (click)=\"close()\"\n    ></i>\n  </header>\n  <main *ngIf=\"body && !hiddenBody\" class=\"{{ bodyCustomClasses }}\">\n    <ng-container *ngTemplateOutlet=\"body.templateRef\"></ng-container>\n  </main>\n  <footer\n    *ngIf=\"\n      (!hiddenFooter && footer) || (!hiddenFooter && !footer && (cancelButton || confirmButton))\n    \"\n    class=\"button-style--{{ buttonStyle }}\"\n  >\n    <ng-container *ngIf=\"footer; else defaultFooter\">\n      <ng-container *ngTemplateOutlet=\"footer.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #defaultFooter>\n      <ng-container\n        *ngIf=\"buttonDirection === FSWModalButtonDirections.RTL; else defaultDirectionTemplate\"\n      >\n        <ng-container *ngTemplateOutlet=\"confirmButtonTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"cancelButtonTemplate\"></ng-container>\n      </ng-container>\n      <ng-template #defaultDirectionTemplate>\n        <ng-container *ngTemplateOutlet=\"cancelButtonTemplate\"></ng-container>\n        <ng-container *ngTemplateOutlet=\"confirmButtonTemplate\"></ng-container>\n      </ng-template>\n      <ng-template #confirmButtonTemplate>\n        <ng-container *ngIf=\"confirmButton\">\n          <button\n            fswButton\n            [appearance]=\"confirmButtonAppearance\"\n            [size]=\"confirmButtonSize\"\n            [disabled]=\"confirmButtonDisabled\"\n            (click)=\"confirm()\"\n          >\n            {{ confirmButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n      <ng-template #cancelButtonTemplate>\n        <ng-container *ngIf=\"cancelButton\">\n          <button\n            fswButton\n            [appearance]=\"cancelButtonAppearance\"\n            [size]=\"cancelButtonSize\"\n            [disabled]=\"cancelButtonDisabled\"\n            (click)=\"cancel()\"\n          >\n            {{ cancelButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n    </ng-template>\n  </footer>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { body: [{
                type: ContentChild,
                args: [FSWModalBodyDirective]
            }], footer: [{
                type: ContentChild,
                args: [FSWModalFooterDirective]
            }], closeEvent: [{
                type: Output
            }], confirmEvent: [{
                type: Output
            }], cancelEvent: [{
                type: Output
            }], afterOpenedEvent: [{
                type: Output
            }], afterClosedEvent: [{
                type: Output
            }], title: [{
                type: Input
            }], confirmButton: [{
                type: Input
            }], confirmButtonAppearance: [{
                type: Input
            }], confirmButtonSize: [{
                type: Input
            }], confirmButtonDisabled: [{
                type: Input
            }], cancelButton: [{
                type: Input
            }], cancelButtonAppearance: [{
                type: Input
            }], cancelButtonSize: [{
                type: Input
            }], cancelButtonDisabled: [{
                type: Input
            }], hiddenCloseButton: [{
                type: Input
            }], hiddenBody: [{
                type: Input
            }], hiddenFooter: [{
                type: Input
            }], closeOnConfirm: [{
                type: Input
            }], closeOnCancel: [{
                type: Input
            }], size: [{
                type: Input
            }], buttonStyle: [{
                type: Input
            }], buttonDirection: [{
                type: Input
            }], fullBlock: [{
                type: Input
            }], bodyCustomClasses: [{
                type: Input
            }], customWidth: [{
                type: Input
            }], fadeIn: [{
                type: HostBinding,
                args: ['@fadeIn']
            }], animationDone: [{
                type: HostListener,
                args: ['@fadeIn.done']
            }] } });

class FSWModalModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, declarations: [FSWModalBodyDirective, FSWModalFooterDirective, FSWModalComponent], imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule], exports: [FSWModalBodyDirective, FSWModalFooterDirective, FSWModalComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule],
                    declarations: [FSWModalBodyDirective, FSWModalFooterDirective, FSWModalComponent],
                    exports: [FSWModalBodyDirective, FSWModalFooterDirective, FSWModalComponent],
                }]
        }] });

var FSWAlertStatuses;
(function (FSWAlertStatuses) {
    FSWAlertStatuses["INFO"] = "info";
    FSWAlertStatuses["SUCCESS"] = "success";
    FSWAlertStatuses["ERROR"] = "error";
    FSWAlertStatuses["WARNING"] = "warning";
})(FSWAlertStatuses || (FSWAlertStatuses = {}));

var FSWAlertSizes;
(function (FSWAlertSizes) {
    FSWAlertSizes["M"] = "m";
    FSWAlertSizes["L"] = "l";
})(FSWAlertSizes || (FSWAlertSizes = {}));

var FSWAlertHorizontalPositions;
(function (FSWAlertHorizontalPositions) {
    FSWAlertHorizontalPositions["START"] = "start";
    FSWAlertHorizontalPositions["CENTER"] = "center";
    FSWAlertHorizontalPositions["END"] = "end";
    FSWAlertHorizontalPositions["LEFT"] = "left";
    FSWAlertHorizontalPositions["RIGHT"] = "right";
})(FSWAlertHorizontalPositions || (FSWAlertHorizontalPositions = {}));
var FSWAlertVerticalPositions;
(function (FSWAlertVerticalPositions) {
    FSWAlertVerticalPositions["MIDDLE"] = "middle";
    FSWAlertVerticalPositions["TOP"] = "top";
    FSWAlertVerticalPositions["BOTTOM"] = "bottom";
})(FSWAlertVerticalPositions || (FSWAlertVerticalPositions = {}));

const FSW_ALERT_SERVICE_TOKEN = new InjectionToken('FSW_ALERT_SERVICE_TOKEN');

const FSW_ALERT_CONFIG_TOKEN = new InjectionToken('FSW_ALERT_CONFIG_TOKEN');

class FSWAlertStatusPipePipe {
    transform(value) {
        switch (value) {
            case FSWAlertStatuses.SUCCESS:
                return `${FSWIconFolders.COMMON}-${FSWIconCommons.CHECK_CIRCLE}`;
            case FSWAlertStatuses.WARNING:
            case FSWAlertStatuses.ERROR:
                return `${FSWIconFolders.COMMON}-${FSWIconCommons.WARNING_CIRCLE}`;
            default:
                return `${FSWIconFolders.COMMON}-${FSWIconCommons.INFORMATION_CIRCLE}`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertStatusPipePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertStatusPipePipe, name: "fswAlertStatusPipe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertStatusPipePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswAlertStatusPipe',
                }]
        }] });

class FSWAlertBodyDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertBodyDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWAlertBodyDirective, selector: "ng-template[fswAlertBody]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertBodyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswAlertBody]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWAlertFooterDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertFooterDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWAlertFooterDirective, selector: "ng-template[fswAlertFooter]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswAlertFooter]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWAlertHostComponent {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.id = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertHostComponent, deps: [{ token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAlertHostComponent, selector: "fsw-alert-host", inputs: { id: "id" }, host: { properties: { "id": "id" } }, ngImport: i0, template: '', isInline: true, styles: [":host{display:flex;flex-direction:column;gap:12px;position:relative}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertHostComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-alert-host', changeDetection: ChangeDetectionStrategy.OnPush, template: '', host: {
                        '[id]': 'id',
                    }, styles: [":host{display:flex;flex-direction:column;gap:12px;position:relative}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }]; }, propDecorators: { id: [{
                type: Input
            }] } });

class FSWAlertComponent {
    get fadeIn() {
        return this.animationStatus;
    }
    get data() {
        return this._config.data;
    }
    get content() {
        return this._config.content;
    }
    get contentString() {
        return this.content;
    }
    get contentTemplate() {
        return this.content;
    }
    get contentComponent() {
        return this.content;
    }
    get contentType() {
        if (typeof this.content === 'string') {
            return 'string';
        }
        if (this.content instanceof TemplateRef) {
            return 'template';
        }
        return 'component';
    }
    constructor(cdr, _config) {
        this.cdr = cdr;
        this._config = _config;
        this.body = null;
        this.footer = null;
        this.closeClick = new EventEmitter();
        this.confirmClick = new EventEmitter();
        this.cancelClick = new EventEmitter();
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
        this.title = '';
        this.confirmButton = null;
        this.cancelButton = null;
        this.hiddenCloseButton = false;
        this.hiddenBody = false;
        this.hiddenFooter = false;
        this.closeOnConfirm = false;
        this.closeOnCancel = false;
        this.status = FSWAlertStatuses.INFO;
        this.size = FSWAlertSizes.M;
        this.through = 'component';
        this.animationStatus = 'enter';
        this.className = 'fsw-alert';
        if (_config) {
            this.through = 'snack';
            this._setupSnack();
        }
    }
    confirm() {
        this.confirmClick.emit();
        if (this.closeOnConfirm) {
            this.close();
        }
    }
    cancel() {
        this.cancelClick.emit();
        if (this.closeOnCancel) {
            this.close();
        }
    }
    close() {
        this.closeClick.emit();
    }
    animationDone() {
        if (this.animationStatus === 'leave') {
            this.closed.next(new Date());
        }
        else {
            this.opened.next(new Date());
        }
    }
    _setupSnack() {
        this.title = this._config.option.title;
        this.status = this._config.option.status;
        this.size = this._config.option.size;
        this.confirmButton = this._config.option.confirmButton;
        this.cancelButton = this._config.option.cancelButton;
        this.hiddenBody = this._config.option.hiddenBody;
        this.hiddenFooter = this._config.option.hiddenFooter;
        this.hiddenCloseButton = this._config.option.hiddenCloseButton;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: FSW_ALERT_CONFIG_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWAlertComponent, selector: "fsw-alert", inputs: { title: "title", confirmButton: "confirmButton", cancelButton: "cancelButton", hiddenCloseButton: "hiddenCloseButton", hiddenBody: "hiddenBody", hiddenFooter: "hiddenFooter", closeOnConfirm: "closeOnConfirm", closeOnCancel: "closeOnCancel", status: "status", size: "size" }, outputs: { closeClick: "closeClick", confirmClick: "confirmClick", cancelClick: "cancelClick", opened: "opened", closed: "closed" }, host: { listeners: { "@fadeIn.done": "animationDone()" }, properties: { "@fadeIn": "this.fadeIn" } }, queries: [{ propertyName: "body", first: true, predicate: FSWAlertBodyDirective, descendants: true }, { propertyName: "footer", first: true, predicate: FSWAlertFooterDirective, descendants: true }], ngImport: i0, template: "<article\n  class=\"{{ className }} {{ className }}--size-{{ size }} {{ className }}--status-{{ status }} {{\n    className\n  }}--{{ animationStatus }}\"\n>\n  <ng-container *ngIf=\"status | fswAlertStatusPipe as icon\">\n    <i [fswIcon]=\"icon\" class=\"{{ className }}__status-icon\"></i>\n  </ng-container>\n  <div class=\"{{ className }}__content\" [class.w-full]=\"hiddenCloseButton\">\n    <header>\n      <span>{{ title }}</span>\n    </header>\n    <ng-container [ngSwitch]=\"through\">\n      <ng-container *ngSwitchCase=\"'snack'\">\n        <main *ngIf=\"content && !hiddenBody\">\n          <ng-container [ngSwitch]=\"contentType\">\n            <ng-container *ngSwitchCase=\"'component'\">\n              <ng-container *ngComponentOutlet=\"contentComponent\"></ng-container>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'string'\">\n              {{ contentString }}\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <ng-container\n                *ngTemplateOutlet=\"contentTemplate; context: { $implicit: data }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </main>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <main *ngIf=\"body && !hiddenBody\">\n          <ng-container *ngTemplateOutlet=\"body.templateRef\"></ng-container>\n        </main>\n      </ng-container>\n    </ng-container>\n    <footer\n      *ngIf=\"\n        (!hiddenFooter && footer) || (!hiddenFooter && !footer && (cancelButton || confirmButton))\n      \"\n    >\n      <ng-container *ngIf=\"footer; else defaultFooter\">\n        <ng-container *ngTemplateOutlet=\"footer.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultFooter>\n        <ng-container *ngIf=\"confirmButton\">\n          <button fswButton [size]=\"'small'\" (click)=\"confirm()\">\n            {{ confirmButton }}\n          </button>\n        </ng-container>\n        <ng-container *ngIf=\"cancelButton\">\n          <button fswButton [appearance]=\"'link'\" [size]=\"'block'\" (click)=\"cancel()\">\n            {{ cancelButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n    </footer>\n  </div>\n  <i\n    *ngIf=\"!hiddenCloseButton\"\n    [fswIcon]=\"'common-close'\"\n    class=\"{{ className }}__close-icon\"\n    (click)=\"close()\"\n  ></i>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: FSWButtonDirective, selector: "button[fswButton], a[fswButton], input[type=\"button\"][fswButton], input[type=\"submit\"][fswButton]" }, { kind: "pipe", type: FSWAlertStatusPipePipe, name: "fswAlertStatusPipe" }], animations: [fadeIn], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-alert', changeDetection: ChangeDetectionStrategy.OnPush, animations: [fadeIn], template: "<article\n  class=\"{{ className }} {{ className }}--size-{{ size }} {{ className }}--status-{{ status }} {{\n    className\n  }}--{{ animationStatus }}\"\n>\n  <ng-container *ngIf=\"status | fswAlertStatusPipe as icon\">\n    <i [fswIcon]=\"icon\" class=\"{{ className }}__status-icon\"></i>\n  </ng-container>\n  <div class=\"{{ className }}__content\" [class.w-full]=\"hiddenCloseButton\">\n    <header>\n      <span>{{ title }}</span>\n    </header>\n    <ng-container [ngSwitch]=\"through\">\n      <ng-container *ngSwitchCase=\"'snack'\">\n        <main *ngIf=\"content && !hiddenBody\">\n          <ng-container [ngSwitch]=\"contentType\">\n            <ng-container *ngSwitchCase=\"'component'\">\n              <ng-container *ngComponentOutlet=\"contentComponent\"></ng-container>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'string'\">\n              {{ contentString }}\n            </ng-container>\n            <ng-container *ngSwitchDefault>\n              <ng-container\n                *ngTemplateOutlet=\"contentTemplate; context: { $implicit: data }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </main>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <main *ngIf=\"body && !hiddenBody\">\n          <ng-container *ngTemplateOutlet=\"body.templateRef\"></ng-container>\n        </main>\n      </ng-container>\n    </ng-container>\n    <footer\n      *ngIf=\"\n        (!hiddenFooter && footer) || (!hiddenFooter && !footer && (cancelButton || confirmButton))\n      \"\n    >\n      <ng-container *ngIf=\"footer; else defaultFooter\">\n        <ng-container *ngTemplateOutlet=\"footer.templateRef\"></ng-container>\n      </ng-container>\n      <ng-template #defaultFooter>\n        <ng-container *ngIf=\"confirmButton\">\n          <button fswButton [size]=\"'small'\" (click)=\"confirm()\">\n            {{ confirmButton }}\n          </button>\n        </ng-container>\n        <ng-container *ngIf=\"cancelButton\">\n          <button fswButton [appearance]=\"'link'\" [size]=\"'block'\" (click)=\"cancel()\">\n            {{ cancelButton }}\n          </button>\n        </ng-container>\n      </ng-template>\n    </footer>\n  </div>\n  <i\n    *ngIf=\"!hiddenCloseButton\"\n    [fswIcon]=\"'common-close'\"\n    class=\"{{ className }}__close-icon\"\n    (click)=\"close()\"\n  ></i>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_ALERT_CONFIG_TOKEN]
                }] }]; }, propDecorators: { body: [{
                type: ContentChild,
                args: [FSWAlertBodyDirective]
            }], footer: [{
                type: ContentChild,
                args: [FSWAlertFooterDirective]
            }], closeClick: [{
                type: Output
            }], confirmClick: [{
                type: Output
            }], cancelClick: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], title: [{
                type: Input
            }], confirmButton: [{
                type: Input
            }], cancelButton: [{
                type: Input
            }], hiddenCloseButton: [{
                type: Input
            }], hiddenBody: [{
                type: Input
            }], hiddenFooter: [{
                type: Input
            }], closeOnConfirm: [{
                type: Input
            }], closeOnCancel: [{
                type: Input
            }], status: [{
                type: Input
            }], size: [{
                type: Input
            }], fadeIn: [{
                type: HostBinding,
                args: ['@fadeIn']
            }], animationDone: [{
                type: HostListener,
                args: ['@fadeIn.done']
            }] } });

class FSWAlertService {
    constructor(_overlay, _applicationService, _document) {
        this._overlay = _overlay;
        this._applicationService = _applicationService;
        this._document = _document;
    }
    error(title, content, option = {}) {
        return this.open(title, FSWAlertStatuses.ERROR, content, option);
    }
    info(title, content, option = {}) {
        return this.open(title, FSWAlertStatuses.INFO, content, option);
    }
    success(title, content, option = {}) {
        return this.open(title, FSWAlertStatuses.SUCCESS, content, option);
    }
    warning(title, content, option = {}) {
        return this.open(title, FSWAlertStatuses.WARNING, content, option);
    }
    open(title, status, content, option = {}) {
        const config = this._getDefaultConfig(title, status, content, option);
        const container = this._getContainer(config.option);
        const injector = this._applicationService.createInjector([
            {
                provide: FSW_ALERT_CONFIG_TOKEN,
                useValue: config,
            },
        ]);
        const componentRef = this._applicationService.createComponentRef(FSWAlertComponent, injector);
        this._applicationService.attachHostView(componentRef.hostView);
        const element = this._applicationService.getHostViewElement(componentRef.hostView);
        this._applicationService.appendTo(element, container);
        const instance = componentRef.instance;
        let timeout;
        instance.closeClick
            .pipe(take(1), tap(() => timeout && clearTimeout(timeout)), tap(() => {
            instance.animationStatus = 'leave';
            instance.cdr.markForCheck();
            timeout = setTimeout(() => {
                this._applicationService.detachHostView(componentRef.hostView);
                this._applicationService.removeFrom(element, container);
                componentRef.destroy();
                clearTimeout(timeout);
            }, 300);
        }))
            .subscribe();
        if (option.duration) {
            timeout = setTimeout(() => {
                instance.closeClick.emit();
            }, option.duration);
        }
        return {
            afterCancelButtonClick: instance.cancelClick.asObservable(),
            afterCloseButtonClick: instance.closeClick.asObservable(),
            afterConfirmButtonClick: instance.confirmClick.asObservable(),
            afterOpened: instance.opened.asObservable(),
            afterClosed: instance.closed.asObservable(),
        };
    }
    _getDefaultConfig(title, status, content, option = {}) {
        return {
            option: {
                title,
                hiddenCloseButton: false,
                hiddenBody: false,
                hiddenFooter: false,
                horizontalOffset: '0px',
                verticalOffset: '4px',
                horizontalPosition: FSWAlertHorizontalPositions.RIGHT,
                verticalPosition: FSWAlertVerticalPositions.TOP,
                duration: 2000,
                cancelButton: null,
                confirmButton: null,
                closeOnConfirm: false,
                closeOnCancel: false,
                size: FSWAlertSizes.M,
                status,
                ...option,
            },
            content,
        };
    }
    _generateId(option) {
        return `fsw-alert-host-${option.horizontalPosition}-${option.verticalPosition}`;
    }
    _getContainer(option) {
        const id = this._generateId(option);
        const existed = this._document.getElementById(id);
        if (existed) {
            return existed;
        }
        const overlayRef = this._createOverlay(option);
        const containerPortal = new ComponentPortal(FSWAlertHostComponent);
        const containerRef = overlayRef.attach(containerPortal);
        const instance = containerRef.instance;
        instance.id = id;
        return this._applicationService.getHostViewElement(containerRef.hostView);
    }
    _createOverlay(option) {
        const overlayConfig = new OverlayConfig();
        const positionStrategy = this._overlay.position().global();
        // Set horizontal position.
        const isLeft = option.horizontalPosition === 'left' || option.horizontalPosition === 'start';
        const isCenter = option.horizontalPosition == 'center';
        const isRight = !isLeft && !isCenter;
        if (isLeft) {
            positionStrategy.left(option.horizontalOffset || '0');
        }
        else if (isRight) {
            positionStrategy.right(option.horizontalOffset || '0');
        }
        else {
            positionStrategy.centerHorizontally(option.horizontalOffset);
        }
        // Set vertical position.
        if (option.verticalPosition === FSWAlertVerticalPositions.TOP) {
            positionStrategy.top(option.verticalOffset || '0');
        }
        else if (option.verticalPosition === FSWAlertVerticalPositions.BOTTOM) {
            positionStrategy.bottom(option.verticalOffset || '0');
        }
        else {
            positionStrategy.centerVertically(option.verticalOffset);
        }
        overlayConfig.positionStrategy = positionStrategy;
        return this._overlay.create(overlayConfig);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertService, deps: [{ token: i1$1.Overlay }, { token: FSW_APPLICATION_SERVICE_TOKEN }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.Overlay }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_APPLICATION_SERVICE_TOKEN]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class FSWAlertModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertModule, declarations: [FSWAlertStatusPipePipe,
            FSWAlertComponent,
            FSWAlertFooterDirective,
            FSWAlertBodyDirective,
            FSWAlertHostComponent], imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule], exports: [FSWAlertStatusPipePipe,
            FSWAlertComponent,
            FSWAlertFooterDirective,
            FSWAlertBodyDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertModule, providers: [
            {
                provide: FSW_ALERT_SERVICE_TOKEN,
                useClass: FSWAlertService,
            },
        ], imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FSWIconModule, FSWButtonModule, FSWApplicationServiceModule],
                    declarations: [
                        FSWAlertStatusPipePipe,
                        FSWAlertComponent,
                        FSWAlertFooterDirective,
                        FSWAlertBodyDirective,
                        FSWAlertHostComponent,
                    ],
                    exports: [
                        FSWAlertStatusPipePipe,
                        FSWAlertComponent,
                        FSWAlertFooterDirective,
                        FSWAlertBodyDirective,
                    ],
                    providers: [
                        {
                            provide: FSW_ALERT_SERVICE_TOKEN,
                            useClass: FSWAlertService,
                        },
                    ],
                }]
        }] });

class FSWSwitchLabelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchLabelDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSwitchLabelDirective, selector: "ng-template[fswSwitchLabel]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswSwitchLabel]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var FSWSwitchSizes;
(function (FSWSwitchSizes) {
    FSWSwitchSizes["M"] = "m";
    FSWSwitchSizes["L"] = "l";
})(FSWSwitchSizes || (FSWSwitchSizes = {}));

class FSWSwitchBase extends FSWControlBase {
    //#region Control Setup
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    get isReadonly() {
        return this.readOnly;
    }
    get isDisabled() {
        return this.disabled;
    }
    get controlType() {
        return FSWControlTypes.SWITCH;
    }
    //#endregion Control Setup
    constructor() {
        super();
        //#region Inputs
        this.id = randomId();
        this.label = null;
        this.size = FSWSwitchSizes.M;
        this.disabled = false;
        this.hasError = false;
        this.readOnly = false;
        this._value = false;
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
        this.className = 'fsw-switch';
    }
    //#region Control Methods
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    writeValue(value) {
        if (isEqual(value, this.value)) {
            return;
        }
        this.value = value;
        this.value$.next(value);
        this._onChange(value);
        this._onTouched();
    }
    listenInputChange() {
        if (this.disabled || this.readOnly)
            return;
        this.writeValue(!this.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWSwitchBase, inputs: { id: "id", label: "label", size: "size", disabled: "disabled", hasError: "hasError", readOnly: "readOnly" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchBase, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { id: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], disabled: [{
                type: Input
            }], hasError: [{
                type: Input
            }], readOnly: [{
                type: Input
            }] } });

const FSW_SWITCH_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FSWSwitchComponent),
    multi: true,
};
class FSWSwitchComponent extends FSWSwitchBase {
    constructor() {
        super();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWSwitchComponent, selector: "fsw-switch", providers: [
            FSW_SWITCH_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWSwitchComponent,
            },
        ], usesInheritance: true, ngImport: i0, template: "<div\n\tclass=\"{{ className }} {{ className }}--size-{{ size }}\"\n\t[class.has-error]=\"hasError\"\n\t[class.read-only]=\"isReadonly\"\n\t[class.disabled]=\"isDisabled\"\n\t(click)=\"listenInputChange()\"\n>\n\t<input\n\t\t[id]=\"id\"\n\t\t[disabled]=\"isDisabled\"\n\t\t[readOnly]=\"isReadonly\"\n\t\t[checked]=\"value\"\n\t\ttype=\"checkbox\"\n\t/>\n\t<label *ngIf=\"label\" [for]=\"id\">{{ label }}</label>\n</div>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-switch', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_SWITCH_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWSwitchComponent,
                        },
                    ], template: "<div\n\tclass=\"{{ className }} {{ className }}--size-{{ size }}\"\n\t[class.has-error]=\"hasError\"\n\t[class.read-only]=\"isReadonly\"\n\t[class.disabled]=\"isDisabled\"\n\t(click)=\"listenInputChange()\"\n>\n\t<input\n\t\t[id]=\"id\"\n\t\t[disabled]=\"isDisabled\"\n\t\t[readOnly]=\"isReadonly\"\n\t\t[checked]=\"value\"\n\t\ttype=\"checkbox\"\n\t/>\n\t<label *ngIf=\"label\" [for]=\"id\">{{ label }}</label>\n</div>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return []; } });

const UI$1 = [FSWSwitchLabelDirective];
class FSWSwitchModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchModule, declarations: [FSWSwitchComponent, FSWSwitchLabelDirective], imports: [CommonModule], exports: [FSWSwitchComponent, FSWSwitchLabelDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FSWSwitchComponent, UI$1],
                    exports: [FSWSwitchComponent, UI$1],
                    imports: [CommonModule],
                }]
        }] });

class FSWDateTimePickerPrefixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerPrefixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswDateTimePickerPrefix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWDateTimePickerSuffixDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerSuffixDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswDateTimePickerSuffix]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWDateTimePickerLabelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerLabelDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerLabelDirective, selector: "ng-template[fswDateTimePickerLabel]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswDateTimePickerLabel]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWDateTimePickerActiveDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.scrollIntoView = false;
        this.firstScroll = false;
    }
    ngOnChanges() {
        if (!this.scrollIntoView || this.firstScroll) {
            return;
        }
        this.firstScroll = true;
        this.elementRef.nativeElement.scrollIntoView({
            block: 'center',
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerActiveDirective, selector: "[fswDateTimePickerActive]", inputs: { scrollIntoView: ["fswDateTimePickerActive", "scrollIntoView"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDateTimePickerActive]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { scrollIntoView: [{
                type: Input,
                args: ['fswDateTimePickerActive']
            }] } });

class FSWDateTimePickerBoxDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerBoxDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerBoxDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[fswDateTimePickerBox]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

class FSWDateTimePickerTargetBase extends FSWControlBase {
    constructor() {
        super(...arguments);
        this.closedBox = new EventEmitter();
        this.openedBox = new EventEmitter();
        this.className = 'fsw-date-time-picker';
        this.placeHolder = '';
        this.hasError = false;
        this.internalError = false;
        this.isDisabled = false;
        this.isReadonly = false;
        this.isFocused = false;
        this.closeOnSelected = false;
        this.positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this.value = null;
        this.editedValue = null;
        this.defaultValue = null;
        this._cdr = inject(ChangeDetectorRef);
        //#region Control Setup
        this._onTouched = () => {
            // Initial
        };
        this._onChange = () => {
            // Initial
        };
    }
    //#endregion Control Setup
    get controlType() {
        return FSWControlTypes.DATE_TIME_PICKER;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    writeValue(value) {
        if (isEqual(value, this.value)) {
            return;
        }
        this.value$.next(value);
        this.value = cloneDeep(value);
        this.defaultValue = cloneDeep(value);
        this.editedValue = cloneDeep(value);
        this._onChange(this.value);
        this._onTouched();
        this._cdr.markForCheck();
    }
    notTriggerWriteValue(value) {
        this.editedValue = cloneDeep(value);
        this._cdr.markForCheck();
    }
    triggerWriteValueAndClose(value, picker) {
        if (isEqual(value, this.defaultValue)) {
            return;
        }
        if (this.isFocused && !!picker) {
            picker.close(true);
        }
        this.writeValue(value);
    }
    resetEditedValue() {
        this.editedValue = cloneDeep(this.defaultValue);
        this._cdr.markForCheck();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTargetBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerTargetBase, inputs: { className: "className", placeHolder: "placeHolder", hasError: "hasError", internalError: "internalError", isDisabled: "isDisabled", isReadonly: "isReadonly", isFocused: "isFocused", closeOnSelected: "closeOnSelected", positions: "positions" }, outputs: { closedBox: "closedBox", openedBox: "openedBox" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTargetBase, decorators: [{
            type: Directive
        }], propDecorators: { closedBox: [{
                type: Output
            }], openedBox: [{
                type: Output
            }], className: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], hasError: [{
                type: Input
            }], internalError: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], isReadonly: [{
                type: Input
            }], isFocused: [{
                type: Input
            }], closeOnSelected: [{
                type: Input
            }], positions: [{
                type: Input
            }] } });

class FSWDateTimePickerBase extends FSWDateTimePickerTargetBase {
    constructor() {
        super(...arguments);
        this.apply = new EventEmitter();
        this.cancel = new EventEmitter();
        this.min = null;
        this.max = null;
    }
    get isRangeError() {
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerBase, inputs: { min: "min", max: "max", format: "format", locale: "locale" }, outputs: { apply: "apply", cancel: "cancel" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerBase, decorators: [{
            type: Directive
        }], propDecorators: { apply: [{
                type: Output
            }], cancel: [{
                type: Output
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], format: [{
                type: Input
            }], locale: [{
                type: Input
            }] } });

class FSWYearPickerBase extends FSWDateTimePickerBase {
    constructor() {
        super(...arguments);
        this._years = Array.from({ length: 200 }).map((_, i) => 1950 + i);
    }
    set years(years) {
        if (years?.length) {
            this._years = years;
        }
    }
    get years() {
        return this._years;
    }
    writeValue(value) {
        try {
            if (value) {
                value = new Date(value);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWYearPickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWYearPickerBase, inputs: { years: "years" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWYearPickerBase, decorators: [{
            type: Directive
        }], propDecorators: { years: [{
                type: Input
            }] } });

class FSWComboPickerBaseModel extends FSWDateTimePickerBase {
    constructor() {
        super(...arguments);
        this._dayLabels = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat',
        ];
        this._monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        this._years = Array.from({ length: 200 }).map((_, i) => 1950 + i);
    }
    set dayLabels(dayLabels) {
        if (dayLabels?.length) {
            this._dayLabels = dayLabels;
        }
    }
    get dayLabels() {
        return this._dayLabels;
    }
    set monthLabels(monthLabels) {
        if (monthLabels?.length) {
            this._monthLabels = monthLabels;
        }
    }
    get monthLabels() {
        return this._monthLabels;
    }
    set years(years) {
        if (years?.length) {
            this._years = years;
        }
    }
    get years() {
        return this._years;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWComboPickerBaseModel, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWComboPickerBaseModel, inputs: { dayLabels: "dayLabels", monthLabels: "monthLabels", years: "years" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWComboPickerBaseModel, decorators: [{
            type: Directive
        }], propDecorators: { dayLabels: [{
                type: Input
            }], monthLabels: [{
                type: Input
            }], years: [{
                type: Input
            }] } });

class FSWDayPickerBase extends FSWDateTimePickerBase {
    constructor() {
        super(...arguments);
        this._dayLabels = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat',
        ];
    }
    set dayLabels(dayLabels) {
        if (dayLabels?.length) {
            this._dayLabels = dayLabels;
        }
    }
    get dayLabels() {
        return this._dayLabels;
    }
    writeValue(value) {
        try {
            if (value) {
                value = timeReset(value);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDayPickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDayPickerBase, inputs: { dayLabels: "dayLabels" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDayPickerBase, decorators: [{
            type: Directive
        }], propDecorators: { dayLabels: [{
                type: Input
            }] } });

class FSWMonthPickerBase extends FSWDateTimePickerBase {
    constructor() {
        super(...arguments);
        this._monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    }
    set monthLabels(monthLabels) {
        if (monthLabels?.length) {
            this._monthLabels = monthLabels;
        }
    }
    get monthLabels() {
        return this._monthLabels;
    }
    writeValue(value) {
        try {
            if (value) {
                value = new Date(value);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMonthPickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWMonthPickerBase, inputs: { monthLabels: "monthLabels" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMonthPickerBase, decorators: [{
            type: Directive
        }], propDecorators: { monthLabels: [{
                type: Input
            }] } });

class FSWDatePickerBase extends FSWComboPickerBaseModel {
    writeValue(value) {
        try {
            if (value) {
                value = timeReset(value);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDatePickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDatePickerBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDatePickerBase, decorators: [{
            type: Directive
        }] });

class FSWRangePickerBase extends FSWComboPickerBaseModel {
    writeValue(value) {
        try {
            if (value?.start) {
                value.start = timeReset(value.start);
            }
            if (value?.end) {
                value.end = timeReset(value.end);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRangePickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWRangePickerBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRangePickerBase, decorators: [{
            type: Directive
        }] });

class FSWTimePickerBase extends FSWDateTimePickerBase {
    writeValue(value) {
        try {
            if (value) {
                value = new Date(value);
            }
        }
        catch (err) {
            console.error(err);
        }
        super.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTimePickerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWTimePickerBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTimePickerBase, decorators: [{
            type: Directive
        }] });

class FSWDateTimePickerControllerComponent {
    constructor() {
        this.cancel = new EventEmitter();
        this.apply = new EventEmitter();
        this.className = 'fsw-date-time-picker__controller';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerControllerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: { cancel: "cancel", apply: "apply" }, ngImport: i0, template: "<footer class=\"{{ className }}\">\n  <fsw-button [size]=\"'s'\" (click)=\"apply.emit($event)\">Apply</fsw-button>\n  <fsw-button [appearance]=\"'link'\" [size]=\"'s'\" (click)=\"cancel.emit($event)\">Cancel</fsw-button>\n</footer>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "component", type: FSWButtonComponent, selector: "fsw-button", inputs: ["tooltip"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerControllerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-controller', changeDetection: ChangeDetectionStrategy.OnPush, template: "<footer class=\"{{ className }}\">\n  <fsw-button [size]=\"'s'\" (click)=\"apply.emit($event)\">Apply</fsw-button>\n  <fsw-button [appearance]=\"'link'\" [size]=\"'s'\" (click)=\"cancel.emit($event)\">Cancel</fsw-button>\n</footer>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { cancel: [{
                type: Output
            }], apply: [{
                type: Output
            }] } });

class FSWDateTimePickerActiveDayPipe {
    transform(current, params) {
        if (!current) {
            return false;
        }
        const { min, max } = params;
        if (!min && !max) {
            return true;
        }
        if (min && max) {
            return compareDesc(min, current) >= 0 && compareDesc(max, current) <= 0;
        }
        if (min) {
            return compareDesc(min, current) >= 0;
        }
        if (max) {
            return compareDesc(max, current) <= 0;
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveDayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveDayPipe, name: "fswDateTimePickerActiveDay" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveDayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveDay',
                }]
        }] });

class FSWDateTimePickerActiveRangePipe {
    transform(currentHover, params) {
        return this._internalTransform(currentHover, params);
    }
    _internalTransform(currentHover, { range, current, }) {
        if (!range || !current) {
            return '';
        }
        if (range.end && range.start) {
            return currentHover
                ? this._fullCheckClass(current, range, currentHover)
                : this._completeRangeCheckClass(current, range, 'complete');
        }
        return currentHover ? this._notCompleteRangeCheckClass(current, range, currentHover) : '';
    }
    _fullCheckClass(current, range, currentHover) {
        if (compareAsc(current, range.start) >= 0 && compareDesc(range.end, current) <= 0) {
            return this._completeRangeCheckClass(current, range, 'complete');
        }
        if (compareAsc(range.start, currentHover) > 0 || compareDesc(range.end, currentHover) > 0) {
            return this._inHoverRangeCheckClass(current, range, currentHover);
        }
        return '';
    }
    _completeRangeCheckClass(current, range, key) {
        if (compareAsc(current, range.start) > 0 && compareDesc(range.end, current) < 0) {
            return `in-range-${key}-middle`;
        }
        if (compareAsc(current, range.start) === 0) {
            return `in-range-${key}-start`;
        }
        if (compareDesc(current, range.end) === 0) {
            return `in-range-${key}-end`;
        }
        return ``;
    }
    _notCompleteRangeCheckClass(current, range, currentHover) {
        const forceRange = cloneDeep(range);
        if (forceRange.start) {
            if (compareDesc(forceRange.start, currentHover) > 0) {
                forceRange.end = currentHover;
            }
            else if (compareDesc(forceRange.start, currentHover) < 0) {
                forceRange.end = forceRange.start;
                forceRange.start = currentHover;
            }
        }
        else if (forceRange.end) {
            if (compareDesc(forceRange.end, currentHover) > 0) {
                forceRange.start = forceRange.end;
                forceRange.end = currentHover;
            }
            else if (compareDesc(forceRange.end, currentHover) < 0) {
                forceRange.start = currentHover;
            }
        }
        return this._completeRangeCheckClass(current, forceRange, 'hover');
    }
    _inHoverRangeCheckClass(current, range, currentHover) {
        if (compareDesc(range.start, currentHover) < 0) {
            return this._completeRangeCheckClass(current, {
                start: currentHover,
                end: range.start,
            }, 'before');
        }
        if (compareDesc(range.end, currentHover) > 0) {
            return this._completeRangeCheckClass(current, {
                start: range.end,
                end: currentHover,
            }, 'after');
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveRangePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveRangePipe, name: "fswDateTimePickerActiveRange" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveRangePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveRange',
                }]
        }] });

const FSW_DATE_PICKER_DAY_BOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWDateTimePickerDayBoxComponent),
};
class FSWDateTimePickerDayBoxComponent extends FSWDayPickerBase {
    constructor() {
        super(...arguments);
        this.previous = new EventEmitter();
        this.currentHoverChange = new EventEmitter();
        this.next = new EventEmitter();
        this.monthClick = new EventEmitter();
        this.isInside = false;
        this.isInRange = false;
        this.currentHover = null;
        this.range = null;
        this.showPrevious = true;
        this.showNext = true;
        this.hiddenNextMonth = false;
        this.hiddenLastMonth = false;
        this.className = 'fsw-date-time-picker__day-box';
        this.renderDays = [];
        this._current = null;
    }
    set current(value) {
        this._current = value;
        this.updateRenderDays();
    }
    get current() {
        return this._current;
    }
    writeValue(value) {
        if (!isEqual(value, this.value)) {
            super.writeValue(value);
            this.updateRenderDays();
        }
        else {
            super.writeValue(value);
        }
    }
    updateRenderDays() {
        const renderDays = this.current
            ? this._generateRenderDay(this.current)
            : this._generateRenderDay(new Date());
        this.renderDays = renderDays.map((dates) => {
            return dates.map((date) => ({
                date,
                active: date && this.value
                    ? date.getFullYear() === this.value.getFullYear() &&
                        date.getMonth() === this.value.getMonth() &&
                        date.getDate() === this.value.getDate()
                    : false,
                inMonth: date && this.current
                    ? date.getFullYear() === this.current.getFullYear() &&
                        date.getMonth() === this.current.getMonth()
                    : false,
            }));
        });
    }
    select(date) {
        if (!date) {
            return;
        }
        this.writeValue(date);
    }
    _generateRenderDay(current) {
        const dayRender = [];
        const currentMonth = new Date(current.getFullYear(), current.getMonth());
        const lastMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1);
        const nextMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1);
        const startFrom = currentMonth.getDay();
        const firstWeek = this._getFirstWeek(currentMonth, lastMonth, startFrom);
        const otherWeeks = this._getOtherWeeks(currentMonth, nextMonth, startFrom);
        dayRender.push(firstWeek, ...otherWeeks);
        return dayRender;
    }
    _getFirstWeek(currentMonth, lastMonth, startFrom) {
        const daysInLastMonth = getDaysInMonth(lastMonth);
        const daysInCurrentMonth = getDaysInMonth(currentMonth);
        const listDayInLastMonth = Array.from({ length: daysInLastMonth }).map((_, day) => new Date(lastMonth.getFullYear(), lastMonth.getMonth(), day + 1));
        const listDayInCurrentMonth = Array.from({ length: daysInCurrentMonth }).map((_, day) => new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day + 1));
        return listDayInLastMonth
            .slice(daysInLastMonth - startFrom)
            .map((e) => (this.hiddenLastMonth ? null : e))
            .concat(listDayInCurrentMonth.slice(0, 6 - startFrom + 1));
    }
    _getOtherWeeks(currentMonth, nextMonth, startFrom) {
        const weeks = [[], [], [], [], []];
        const daysInCurrentMonth = getDaysInMonth(currentMonth);
        const daysInNextMonth = getDaysInMonth(nextMonth);
        const listDayInCurrentMonth = Array.from({ length: daysInCurrentMonth }).map((_, day) => new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day + 1));
        const listDayInNextMonth = Array.from({ length: daysInNextMonth }).map((_, day) => new Date(nextMonth.getFullYear(), nextMonth.getMonth(), day + 1));
        const maxDays = daysInCurrentMonth - (6 - startFrom + 1);
        const listDayInMiddleMonth = listDayInCurrentMonth.slice(daysInCurrentMonth - maxDays);
        const neededDayInNextMonth = maxDays > 28 ? 35 - maxDays : 28 - maxDays;
        const days = listDayInMiddleMonth.concat(listDayInNextMonth
            .slice(0, neededDayInNextMonth)
            .map((e) => (this.hiddenNextMonth ? null : e)));
        for (let i = 1; i <= 5; i++) {
            for (let j = 0; j < 7; j++) {
                const day = days[(i - 1) * 7 + j];
                if (day) {
                    weeks[i - 1].push(day);
                }
            }
        }
        return weeks;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerDayBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerDayBoxComponent, selector: "fsw-date-time-picker-day-box", inputs: { current: "current", isInside: "isInside", isInRange: "isInRange", currentHover: "currentHover", range: "range", showPrevious: "showPrevious", showNext: "showNext", hiddenNextMonth: "hiddenNextMonth", hiddenLastMonth: "hiddenLastMonth" }, outputs: { previous: "previous", currentHoverChange: "currentHoverChange", next: "next", monthClick: "monthClick" }, providers: [FSW_DATE_PICKER_DAY_BOX_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\" [class.in-range]=\"isInRange\">\n  <header>\n    <i\n      [fswIcon]=\"'common-arrow-left'\"\n      class=\"previous\"\n      *ngIf=\"showPrevious\"\n      (click)=\"previous.emit()\"\n    ></i>\n    <span (click)=\"monthClick.emit()\">{{ current | date : 'MMMM yyyy' }}</span>\n    <i [fswIcon]=\"'common-arrow-right'\" class=\"next\" *ngIf=\"showNext\" (click)=\"next.emit()\"></i>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let dayLabel of dayLabels\">\n      <button class=\"week-day\">\n        <span>{{ dayLabel }}</span>\n      </button>\n    </ng-container>\n    <ng-container *ngFor=\"let days of renderDays\">\n      <ng-container *ngFor=\"let day of days\">\n        <button\n          [fswDateTimePickerActive]=\"day.active\"\n          [class.active]=\"day.active\"\n          [disabled]=\"!(day.date | fswDateTimePickerActiveDay : { min, max })\"\n          [class]=\"currentHover | fswDateTimePickerActiveRange : { range, current: day.date }\"\n          [class.day-not-in-month]=\"!day.inMonth\"\n          (mouseenter)=\"day.date && currentHoverChange.emit(day.date)\"\n          (click)=\"select(day.date)\"\n        >\n          <span>{{ day.date | date : 'dd' }}</span>\n        </button>\n      </ng-container>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit()\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "directive", type: FSWDateTimePickerActiveDirective, selector: "[fswDateTimePickerActive]", inputs: ["fswDateTimePickerActive"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: FSWDateTimePickerActiveDayPipe, name: "fswDateTimePickerActiveDay" }, { kind: "pipe", type: FSWDateTimePickerActiveRangePipe, name: "fswDateTimePickerActiveRange" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerDayBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-day-box', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSW_DATE_PICKER_DAY_BOX_ACCESSOR], template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\" [class.in-range]=\"isInRange\">\n  <header>\n    <i\n      [fswIcon]=\"'common-arrow-left'\"\n      class=\"previous\"\n      *ngIf=\"showPrevious\"\n      (click)=\"previous.emit()\"\n    ></i>\n    <span (click)=\"monthClick.emit()\">{{ current | date : 'MMMM yyyy' }}</span>\n    <i [fswIcon]=\"'common-arrow-right'\" class=\"next\" *ngIf=\"showNext\" (click)=\"next.emit()\"></i>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let dayLabel of dayLabels\">\n      <button class=\"week-day\">\n        <span>{{ dayLabel }}</span>\n      </button>\n    </ng-container>\n    <ng-container *ngFor=\"let days of renderDays\">\n      <ng-container *ngFor=\"let day of days\">\n        <button\n          [fswDateTimePickerActive]=\"day.active\"\n          [class.active]=\"day.active\"\n          [disabled]=\"!(day.date | fswDateTimePickerActiveDay : { min, max })\"\n          [class]=\"currentHover | fswDateTimePickerActiveRange : { range, current: day.date }\"\n          [class.day-not-in-month]=\"!day.inMonth\"\n          (mouseenter)=\"day.date && currentHoverChange.emit(day.date)\"\n          (click)=\"select(day.date)\"\n        >\n          <span>{{ day.date | date : 'dd' }}</span>\n        </button>\n      </ng-container>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit()\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { previous: [{
                type: Output
            }], currentHoverChange: [{
                type: Output
            }], next: [{
                type: Output
            }], monthClick: [{
                type: Output
            }], current: [{
                type: Input
            }], isInside: [{
                type: Input
            }], isInRange: [{
                type: Input
            }], currentHover: [{
                type: Input
            }], range: [{
                type: Input
            }], showPrevious: [{
                type: Input
            }], showNext: [{
                type: Input
            }], hiddenNextMonth: [{
                type: Input
            }], hiddenLastMonth: [{
                type: Input
            }] } });

class FSWDateTimePickerActiveMonthPipe {
    transform(current, params) {
        const { min, max } = params;
        if (!min && !max) {
            return true;
        }
        const value = params.value || new Date();
        if (min && max) {
            return ((value.getFullYear() === min.getFullYear()
                ? current >= min.getMonth()
                : value.getFullYear() > min.getFullYear()) &&
                (value.getFullYear() === max.getFullYear()
                    ? current <= max.getMonth()
                    : value.getFullYear() < max.getFullYear()));
        }
        if (min) {
            return value.getFullYear() === min.getFullYear()
                ? current >= min.getMonth()
                : value.getFullYear() > min.getFullYear();
        }
        if (max) {
            return value.getFullYear() === max.getFullYear()
                ? current <= max.getMonth()
                : value.getFullYear() < max.getFullYear();
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMonthPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMonthPipe, name: "fswDateTimePickerActiveMonth" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMonthPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveMonth',
                }]
        }] });

const FSW_DATE_PICKER_MONTH_BOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWDateTimePickerMonthBoxComponent),
};
class FSWDateTimePickerMonthBoxComponent extends FSWMonthPickerBase {
    constructor() {
        super(...arguments);
        this.back = new EventEmitter();
        this.yearClick = new EventEmitter();
        this.isInside = false;
        this.className = 'fsw-date-time-picker__month-box';
        this.months = Array.from({ length: 12 }).map((_, i) => i);
    }
    get currentMonth() {
        return this.value?.getMonth() || null;
    }
    select(data) {
        let value = new Date();
        if (!this.value) {
            value.setDate(1);
        }
        else {
            value = new Date(this.value);
        }
        value.setMonth(data);
        this.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerMonthBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerMonthBoxComponent, selector: "fsw-date-time-picker-month-box", inputs: { isInside: "isInside" }, outputs: { back: "back", yearClick: "yearClick" }, providers: [FSW_DATE_PICKER_MONTH_BOX_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\">\n  <header>\n    <i *ngIf=\"isInside\" [fswIcon]=\"'common-arrow-left'\" (click)=\"back.emit()\"></i>\n    <span (click)=\"yearClick.emit()\">{{ value | date : 'yyyy' }}</span>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let month of months\">\n      <button\n        [fswDateTimePickerActive]=\"month === currentMonth\"\n        [class.active]=\"month === currentMonth\"\n        [disabled]=\"!(month | fswDateTimePickerActiveMonth : { value, min, max })\"\n        (click)=\"select(month)\"\n      >\n        <span>{{ monthLabels[month] }}</span>\n      </button>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit(value)\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "directive", type: FSWDateTimePickerActiveDirective, selector: "[fswDateTimePickerActive]", inputs: ["fswDateTimePickerActive"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }, { kind: "pipe", type: FSWDateTimePickerActiveMonthPipe, name: "fswDateTimePickerActiveMonth" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerMonthBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-month-box', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSW_DATE_PICKER_MONTH_BOX_ACCESSOR], template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\">\n  <header>\n    <i *ngIf=\"isInside\" [fswIcon]=\"'common-arrow-left'\" (click)=\"back.emit()\"></i>\n    <span (click)=\"yearClick.emit()\">{{ value | date : 'yyyy' }}</span>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let month of months\">\n      <button\n        [fswDateTimePickerActive]=\"month === currentMonth\"\n        [class.active]=\"month === currentMonth\"\n        [disabled]=\"!(month | fswDateTimePickerActiveMonth : { value, min, max })\"\n        (click)=\"select(month)\"\n      >\n        <span>{{ monthLabels[month] }}</span>\n      </button>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit(value)\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { back: [{
                type: Output
            }], yearClick: [{
                type: Output
            }], isInside: [{
                type: Input
            }] } });

class FSWDateTimePickerActiveYearPipe {
    transform(current, params) {
        const { min, max } = params;
        if (!min && !max) {
            return true;
        }
        if (min && max) {
            return current >= min.getFullYear() && current <= max.getFullYear();
        }
        if (min) {
            return current >= min.getFullYear();
        }
        if (max) {
            return current <= max.getFullYear();
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveYearPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveYearPipe, name: "fswDateTimePickerActiveYear" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveYearPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveYear',
                }]
        }] });

const FSW_DATE_PICKER_YEAR_BOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWDateTimePickerYearBoxComponent),
};
class FSWDateTimePickerYearBoxComponent extends FSWYearPickerBase {
    constructor() {
        super(...arguments);
        this.back = new EventEmitter();
        this.isInside = false;
        this.className = 'fsw-date-time-picker__year-box';
    }
    get currentYear() {
        return this.value?.getFullYear() || null;
    }
    select(data) {
        let value = new Date();
        if (!this.value) {
            value.setMonth(0);
            value.setDate(1);
        }
        else {
            value = new Date(this.value);
        }
        value.setFullYear(data);
        this.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerYearBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerYearBoxComponent, selector: "fsw-date-time-picker-year-box", inputs: { isInside: "isInside" }, outputs: { back: "back" }, providers: [FSW_DATE_PICKER_YEAR_BOX_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\">\n  <header>\n    <i *ngIf=\"isInside\" (click)=\"back.emit()\" [fswIcon]=\"'common-arrow-left'\"></i>\n    <span>Select year</span>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let year of years\">\n      <button\n        [fswDateTimePickerActive]=\"year === currentYear\"\n        [class.active]=\"year === currentYear\"\n        [disabled]=\"!(year | fswDateTimePickerActiveYear : { min, max })\"\n        (click)=\"select(year)\"\n      >\n        <span>{{ year }}</span>\n      </button>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit()\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "directive", type: FSWDateTimePickerActiveDirective, selector: "[fswDateTimePickerActive]", inputs: ["fswDateTimePickerActive"] }, { kind: "pipe", type: FSWDateTimePickerActiveYearPipe, name: "fswDateTimePickerActiveYear" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerYearBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-year-box', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSW_DATE_PICKER_YEAR_BOX_ACCESSOR], template: "<article class=\"{{ className }}\" [class.in-side]=\"isInside\">\n  <header>\n    <i *ngIf=\"isInside\" (click)=\"back.emit()\" [fswIcon]=\"'common-arrow-left'\"></i>\n    <span>Select year</span>\n  </header>\n  <main>\n    <ng-container *ngFor=\"let year of years\">\n      <button\n        [fswDateTimePickerActive]=\"year === currentYear\"\n        [class.active]=\"year === currentYear\"\n        [disabled]=\"!(year | fswDateTimePickerActiveYear : { min, max })\"\n        (click)=\"select(year)\"\n      >\n        <span>{{ year }}</span>\n      </button>\n    </ng-container>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!isInside && !closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit()\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { back: [{
                type: Output
            }], isInside: [{
                type: Input
            }] } });

class FSWDateTimePickerActiveHourPipe {
    transform(current, params) {
        const { min, max } = params;
        if (!min && !max) {
            return true;
        }
        if (min && max) {
            return current >= min.getHours() && current <= max.getHours();
        }
        if (min) {
            return current >= min.getHours();
        }
        if (max) {
            return current <= max.getHours();
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveHourPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveHourPipe, name: "fswDateTimePickerActiveHour" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveHourPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveHour',
                }]
        }] });

class FSWDateTimePickerActiveMinutePipe {
    transform(current, params) {
        const { min, max, value } = params;
        if (!min && !max) {
            return true;
        }
        if (!value) {
            return true;
        }
        if (min && max) {
            return ((value.getHours() === min.getHours() ? current >= min.getMinutes() : true) &&
                (value.getHours() === max.getHours() ? current <= max.getMinutes() : true));
        }
        if (min) {
            return value.getHours() === min.getHours() ? current >= min.getMinutes() : true;
        }
        if (max) {
            return value.getHours() === max.getHours() ? current <= max.getMinutes() : true;
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMinutePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMinutePipe, name: "fswDateTimePickerActiveMinute" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerActiveMinutePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDateTimePickerActiveMinute',
                }]
        }] });

const FSW_DATE_PICKER_TIME_BOX_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWDateTimePickerTimeBoxComponent),
};
class FSWDateTimePickerTimeBoxComponent extends FSWTimePickerBase {
    constructor() {
        super(...arguments);
        this.className = 'fsw-date-time-picker__time-box';
        this.hours = Array.from({ length: 24 }).map((_, i) => i);
        this.minutes = Array.from({ length: 60 }).map((_, i) => i);
    }
    get currentHour() {
        return this.value?.getHours() || null;
    }
    get currentMinute() {
        return this.value?.getMinutes() || null;
    }
    select(data, type) {
        let value = new Date();
        if (this.value) {
            value = new Date(this.value);
        }
        type === 'hour' ? value.setHours(data) : value.setMinutes(data);
        this.writeValue(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTimeBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerTimeBoxComponent, selector: "fsw-date-time-picker-time-box", providers: [FSW_DATE_PICKER_TIME_BOX_ACCESSOR], usesInheritance: true, ngImport: i0, template: "<article class=\"{{ className }}\">\n  <main>\n    <div class=\"{{ className }}__list\">\n      <ng-container *ngFor=\"let hour of hours\">\n        <button\n          [fswDateTimePickerActive]=\"hour === currentHour\"\n          [class.active]=\"hour === currentHour\"\n          [disabled]=\"!(hour | fswDateTimePickerActiveHour : { min, max })\"\n          (click)=\"select(hour, 'hour')\"\n        >\n          <span>{{ hour }}</span>\n        </button>\n      </ng-container>\n    </div>\n    <div class=\"{{ className }}__list\">\n      <ng-container *ngFor=\"let minute of minutes\">\n        <button\n          [fswDateTimePickerActive]=\"minute === currentMinute\"\n          [class.active]=\"minute === currentMinute\"\n          [disabled]=\"!(minute | fswDateTimePickerActiveMinute : { min, max, value })\"\n          (click)=\"select(minute, 'minute')\"\n        >\n          <span>{{ minute }}</span>\n        </button>\n      </ng-container>\n    </div>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit(value)\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "directive", type: FSWDateTimePickerActiveDirective, selector: "[fswDateTimePickerActive]", inputs: ["fswDateTimePickerActive"] }, { kind: "pipe", type: FSWDateTimePickerActiveHourPipe, name: "fswDateTimePickerActiveHour" }, { kind: "pipe", type: FSWDateTimePickerActiveMinutePipe, name: "fswDateTimePickerActiveMinute" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTimeBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-time-box', changeDetection: ChangeDetectionStrategy.OnPush, providers: [FSW_DATE_PICKER_TIME_BOX_ACCESSOR], template: "<article class=\"{{ className }}\">\n  <main>\n    <div class=\"{{ className }}__list\">\n      <ng-container *ngFor=\"let hour of hours\">\n        <button\n          [fswDateTimePickerActive]=\"hour === currentHour\"\n          [class.active]=\"hour === currentHour\"\n          [disabled]=\"!(hour | fswDateTimePickerActiveHour : { min, max })\"\n          (click)=\"select(hour, 'hour')\"\n        >\n          <span>{{ hour }}</span>\n        </button>\n      </ng-container>\n    </div>\n    <div class=\"{{ className }}__list\">\n      <ng-container *ngFor=\"let minute of minutes\">\n        <button\n          [fswDateTimePickerActive]=\"minute === currentMinute\"\n          [class.active]=\"minute === currentMinute\"\n          [disabled]=\"!(minute | fswDateTimePickerActiveMinute : { min, max, value })\"\n          (click)=\"select(minute, 'minute')\"\n        >\n          <span>{{ minute }}</span>\n        </button>\n      </ng-container>\n    </div>\n  </main>\n  <fsw-date-time-picker-controller\n    *ngIf=\"!closeOnSelected\"\n    (cancel)=\"cancel.emit()\"\n    (apply)=\"apply.emit(value)\"\n  ></fsw-date-time-picker-controller>\n</article>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDateTimePickerTargetComponent extends FSWDateTimePickerTargetBase {
    constructor() {
        super(...arguments);
        this.prefixTemplate = null;
        this.suffixTemplate = null;
        this.labelTemplate = null;
        this.boxTemplate = null;
        this.render = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTargetComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: { render: "render" }, queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }, { propertyName: "suffixTemplate", first: true, predicate: FSWDateTimePickerSuffixDirective, descendants: true }, { propertyName: "labelTemplate", first: true, predicate: FSWDateTimePickerLabelDirective, descendants: true }, { propertyName: "boxTemplate", first: true, predicate: FSWDateTimePickerBoxDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\n  fswDropdown\n  #targetPicker=\"fswDropdown\"\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [class.focused]=\"isFocused\"\n  [cdkMenuTriggerFor]=\"isDisabled || isReadonly ? null : pickerTemplate\"\n  [cdkMenuPosition]=\"positions\"\n  [fixedWidth]=\"true\"\n  [offsetY]=\"4\"\n  [allowBackDropClick]=\"true\"\n  (cdkMenuOpened)=\"openedBox.emit()\"\n  (cdkMenuClosed)=\"closedBox.emit()\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n  </ng-container>\n  <span\n    class=\"{{ className }}__label\"\n    [class.internal-error]=\"!labelTemplate && render && internalError\"\n    [class.is-placeholder]=\"!labelTemplate && !render\"\n  >\n    <ng-container *ngIf=\"labelTemplate; else placeHolderTemplate\">\n      <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #placeHolderTemplate>\n      {{ render || placeHolder }}\n    </ng-template>\n  </span>\n  <ng-container *ngIf=\"suffixTemplate\">\n    <ng-container *ngTemplateOutlet=\"suffixTemplate.templateRef\"></ng-container>\n  </ng-container>\n</div>\n\n<ng-template #pickerTemplate>\n  <main>\n    <ng-container *ngIf=\"boxTemplate\">\n      <ng-container\n        *ngTemplateOutlet=\"boxTemplate.templateRef; context: { $implicit: targetPicker }\"\n      ></ng-container>\n    </ng-container>\n  </main>\n</ng-template>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.CdkMenuTrigger, selector: "[cdkMenuTriggerFor]", inputs: ["cdkMenuTriggerFor", "cdkMenuPosition", "cdkMenuTriggerData"], outputs: ["cdkMenuOpened", "cdkMenuClosed"], exportAs: ["cdkMenuTriggerFor"] }, { kind: "directive", type: FSWDropdownDirective, selector: "[cdkMenuTriggerFor][fswDropdown]", inputs: ["fixedWidth", "allowBackDropClick", "offsetY", "offsetX", "event", "conditional"], exportAs: ["fswDropdown"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerTargetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-time-picker-target', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  fswDropdown\n  #targetPicker=\"fswDropdown\"\n  class=\"{{ className }}\"\n  [class.has-error]=\"hasError\"\n  [class.disabled]=\"isDisabled\"\n  [class.read-only]=\"isReadonly\"\n  [class.focused]=\"isFocused\"\n  [cdkMenuTriggerFor]=\"isDisabled || isReadonly ? null : pickerTemplate\"\n  [cdkMenuPosition]=\"positions\"\n  [fixedWidth]=\"true\"\n  [offsetY]=\"4\"\n  [allowBackDropClick]=\"true\"\n  (cdkMenuOpened)=\"openedBox.emit()\"\n  (cdkMenuClosed)=\"closedBox.emit()\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n  </ng-container>\n  <span\n    class=\"{{ className }}__label\"\n    [class.internal-error]=\"!labelTemplate && render && internalError\"\n    [class.is-placeholder]=\"!labelTemplate && !render\"\n  >\n    <ng-container *ngIf=\"labelTemplate; else placeHolderTemplate\">\n      <ng-container *ngTemplateOutlet=\"labelTemplate.templateRef\"></ng-container>\n    </ng-container>\n    <ng-template #placeHolderTemplate>\n      {{ render || placeHolder }}\n    </ng-template>\n  </span>\n  <ng-container *ngIf=\"suffixTemplate\">\n    <ng-container *ngTemplateOutlet=\"suffixTemplate.templateRef\"></ng-container>\n  </ng-container>\n</div>\n\n<ng-template #pickerTemplate>\n  <main>\n    <ng-container *ngIf=\"boxTemplate\">\n      <ng-container\n        *ngTemplateOutlet=\"boxTemplate.templateRef; context: { $implicit: targetPicker }\"\n      ></ng-container>\n    </ng-container>\n  </main>\n</ng-template>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }], suffixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerSuffixDirective]
            }], labelTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerLabelDirective]
            }], boxTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerBoxDirective]
            }], render: [{
                type: Input
            }] } });

const FSW_TIME_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWTimePickerComponent),
};
class FSWTimePickerComponent extends FSWTimePickerBase {
    constructor() {
        super(...arguments);
        this.prefixTemplate = null;
    }
    get isRangeError() {
        if (!this.value) {
            return false;
        }
        const hourAvailable = new FSWDateTimePickerActiveHourPipe().transform(this.value.getHours(), {
            min: this.min,
            max: this.max,
        });
        const minuteAvailable = new FSWDateTimePickerActiveMinutePipe().transform(this.value.getMinutes(), {
            value: this.value,
            min: this.min,
            max: this.max,
        });
        return !hourAvailable || !minuteAvailable;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTimePickerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWTimePickerComponent, selector: "fsw-time-picker", providers: [
            FSW_TIME_PICKER_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWTimePickerComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'hh:MM' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-time'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-time-box\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-time-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "directive", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]" }, { kind: "directive", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]" }, { kind: "component", type: FSWDateTimePickerTimeBoxComponent, selector: "fsw-date-time-picker-time-box" }, { kind: "component", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: ["render"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-time-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_TIME_PICKER_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWTimePickerComponent,
                        },
                    ], template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'hh:MM' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-time'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-time-box\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-time-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }] } });

const FSW_YEAR_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWYearPickerComponent),
};
class FSWYearPickerComponent extends FSWYearPickerBase {
    constructor() {
        super(...arguments);
        this.prefixTemplate = null;
    }
    get isRangeError() {
        if (!this.value) {
            return false;
        }
        const yearAvailable = new FSWDateTimePickerActiveYearPipe().transform(this.value.getFullYear(), {
            min: this.min,
            max: this.max,
        });
        return !yearAvailable;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWYearPickerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWYearPickerComponent, selector: "fsw-year-picker", providers: [
            FSW_YEAR_PICKER_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWYearPickerComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-year-box\n      [years]=\"years\"\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-year-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "directive", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]" }, { kind: "directive", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]" }, { kind: "component", type: FSWDateTimePickerYearBoxComponent, selector: "fsw-date-time-picker-year-box", inputs: ["isInside"], outputs: ["back"] }, { kind: "component", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: ["render"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWYearPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-year-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_YEAR_PICKER_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWYearPickerComponent,
                        },
                    ], template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-year-box\n      [years]=\"years\"\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-year-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }] } });

const FSW_DATE_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWDatePickerComponent),
};
class FSWDatePickerComponent extends FSWDatePickerBase {
    get isRangeError() {
        const dateAvailable = new FSWDateTimePickerActiveDayPipe().transform(this.value, {
            min: this.min,
            max: this.max,
        });
        return !dateAvailable;
    }
    constructor() {
        super();
        this.prefixTemplate = null;
        this.activeBox = 'day';
        this.current = new Date();
    }
    writeValue(value) {
        super.writeValue(value);
        this.resetCurrent();
    }
    resetCurrent() {
        this.current = this.editedValue ? new Date(this.editedValue) : new Date();
        this.updateCurrent(this.current, true, true);
    }
    updateCurrent(value, notTrigger = false, notEmit = false) {
        if (!value) {
            return;
        }
        this.current = new Date(value);
        if (!notTrigger) {
            if (this.closeOnSelected) {
                this.triggerWriteValueAndClose(value);
            }
            else {
                this.notTriggerWriteValue(value);
            }
        }
        !notEmit && this._cdr.markForCheck();
    }
    previous() {
        this.current.setDate(1);
        this.current.setMonth(this.current.getMonth() - 1);
        this.updateCurrent(this.current, true);
    }
    next() {
        this.current.setDate(1);
        this.current.setMonth(this.current.getMonth() + 1);
        this.updateCurrent(this.current, true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDatePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDatePickerComponent, selector: "fsw-date-picker", providers: [
            FSW_DATE_PICKER_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWDatePickerComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'dd/MM/yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); resetCurrent(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <article class=\"{{ className }}__combo-box\">\n      <main>\n        <fsw-date-time-picker-day-box\n          *ngIf=\"activeBox === 'day'\"\n          [ngModel]=\"editedValue\"\n          [showPrevious]=\"true\"\n          [showNext]=\"true\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          [current]=\"current\"\n          (next)=\"next()\"\n          (previous)=\"previous()\"\n          (monthClick)=\"activeBox = 'month'\"\n          (ngModelChange)=\"\n            closeOnSelected\n              ? triggerWriteValueAndClose($event, picker)\n              : notTriggerWriteValue($event)\n          \"\n        ></fsw-date-time-picker-day-box>\n        <fsw-date-time-picker-month-box\n          *ngIf=\"activeBox === 'month'\"\n          [monthLabels]=\"monthLabels\"\n          [ngModel]=\"current\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          (yearClick)=\"activeBox = 'year'\"\n          (back)=\"activeBox = 'day'\"\n          (ngModelChange)=\"updateCurrent($event)\"\n        ></fsw-date-time-picker-month-box>\n        <fsw-date-time-picker-year-box\n          *ngIf=\"activeBox === 'year'\"\n          [years]=\"years\"\n          [ngModel]=\"current\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          (back)=\"activeBox = 'month'\"\n          (ngModelChange)=\"updateCurrent($event)\"\n        ></fsw-date-time-picker-year-box>\n      </main>\n      <fsw-date-time-picker-controller\n        *ngIf=\"!closeOnSelected\"\n        (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n        (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n      ></fsw-date-time-picker-controller>\n    </article>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "directive", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]" }, { kind: "directive", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]" }, { kind: "component", type: FSWDateTimePickerMonthBoxComponent, selector: "fsw-date-time-picker-month-box", inputs: ["isInside"], outputs: ["back", "yearClick"] }, { kind: "component", type: FSWDateTimePickerYearBoxComponent, selector: "fsw-date-time-picker-year-box", inputs: ["isInside"], outputs: ["back"] }, { kind: "component", type: FSWDateTimePickerDayBoxComponent, selector: "fsw-date-time-picker-day-box", inputs: ["current", "isInside", "isInRange", "currentHover", "range", "showPrevious", "showNext", "hiddenNextMonth", "hiddenLastMonth"], outputs: ["previous", "currentHoverChange", "next", "monthClick"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "component", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: ["render"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-date-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_DATE_PICKER_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWDatePickerComponent,
                        },
                    ], template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'dd/MM/yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); resetCurrent(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <article class=\"{{ className }}__combo-box\">\n      <main>\n        <fsw-date-time-picker-day-box\n          *ngIf=\"activeBox === 'day'\"\n          [ngModel]=\"editedValue\"\n          [showPrevious]=\"true\"\n          [showNext]=\"true\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          [current]=\"current\"\n          (next)=\"next()\"\n          (previous)=\"previous()\"\n          (monthClick)=\"activeBox = 'month'\"\n          (ngModelChange)=\"\n            closeOnSelected\n              ? triggerWriteValueAndClose($event, picker)\n              : notTriggerWriteValue($event)\n          \"\n        ></fsw-date-time-picker-day-box>\n        <fsw-date-time-picker-month-box\n          *ngIf=\"activeBox === 'month'\"\n          [monthLabels]=\"monthLabels\"\n          [ngModel]=\"current\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          (yearClick)=\"activeBox = 'year'\"\n          (back)=\"activeBox = 'day'\"\n          (ngModelChange)=\"updateCurrent($event)\"\n        ></fsw-date-time-picker-month-box>\n        <fsw-date-time-picker-year-box\n          *ngIf=\"activeBox === 'year'\"\n          [years]=\"years\"\n          [ngModel]=\"current\"\n          [isInside]=\"true\"\n          [min]=\"min\"\n          [max]=\"max\"\n          (back)=\"activeBox = 'month'\"\n          (ngModelChange)=\"updateCurrent($event)\"\n        ></fsw-date-time-picker-year-box>\n      </main>\n      <fsw-date-time-picker-controller\n        *ngIf=\"!closeOnSelected\"\n        (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n        (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n      ></fsw-date-time-picker-controller>\n    </article>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }] } });

const FSW_MONTH_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWMonthPickerComponent),
};
class FSWMonthPickerComponent extends FSWMonthPickerBase {
    constructor() {
        super(...arguments);
        this.prefixTemplate = null;
    }
    get isRangeError() {
        if (!this.value) {
            return false;
        }
        const monthAvailable = new FSWDateTimePickerActiveMonthPipe().transform(this.value.getMonth(), {
            value: this.value,
            min: this.min,
            max: this.max,
        });
        return !monthAvailable;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMonthPickerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWMonthPickerComponent, selector: "fsw-month-picker", providers: [
            FSW_MONTH_PICKER_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWMonthPickerComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'MMMM yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-month-box\n      [monthLabels]=\"monthLabels\"\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-month-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "directive", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]" }, { kind: "directive", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]" }, { kind: "component", type: FSWDateTimePickerMonthBoxComponent, selector: "fsw-date-time-picker-month-box", inputs: ["isInside"], outputs: ["back", "yearClick"] }, { kind: "component", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: ["render"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWMonthPickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-month-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_MONTH_PICKER_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWMonthPickerComponent,
                        },
                    ], template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"editedValue ? (editedValue | date : format || 'MMMM yyyy' : locale) : null\"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <fsw-date-time-picker-month-box\n      [monthLabels]=\"monthLabels\"\n      [ngModel]=\"editedValue\"\n      [closeOnSelected]=\"closeOnSelected\"\n      (ngModelChange)=\"\n        closeOnSelected ? triggerWriteValueAndClose($event, picker) : notTriggerWriteValue($event)\n      \"\n      (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n      (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n    ></fsw-date-time-picker-month-box>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }] } });

const FSW_RANGE_PICKER_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => FSWRangePickerComponent),
};
class FSWRangePickerComponent extends FSWRangePickerBase {
    get isRangeError() {
        if (!this.value) {
            return false;
        }
        const startAvailable = new FSWDateTimePickerActiveDayPipe().transform(this.value.start, {
            min: this.min,
            max: this.value.end,
        });
        const endAvailable = new FSWDateTimePickerActiveDayPipe().transform(this.value.end, {
            min: this.value.start,
            max: this.max,
        });
        return !startAvailable || !endAvailable;
    }
    get maxStartCurrent() {
        const value = new Date(this.endCurrent);
        value.setDate(value.getDate() - 1);
        return value;
    }
    get minEndCurrent() {
        const value = new Date(this.startCurrent);
        value.setMonth(value.getMonth() + 1);
        return value;
    }
    constructor() {
        super();
        this.prefixTemplate = null;
        this.startActiveBox = 'day';
        this.endActiveBox = 'day';
        this.startCurrent = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        this.endCurrent = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);
        this.currentHover$ = new BehaviorSubject(null);
    }
    writeValue(value) {
        super.writeValue(value);
        this.resetCurrent();
    }
    resetCurrent() {
        this.startCurrent = this.editedValue?.start
            ? new Date(this.editedValue.start.getFullYear(), this.editedValue.start.getMonth(), 1)
            : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        this.endCurrent = this.editedValue?.end
            ? new Date(this.editedValue.end.getFullYear(), this.editedValue.end.getMonth(), 1)
            : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1);
        if (compareDesc(this.startCurrent, this.endCurrent) === 0) {
            this.endCurrent.setMonth(this.endCurrent.getMonth() + 1);
        }
        this.updateCurrent(this.startCurrent, 'start', true, true);
        this.updateCurrent(this.endCurrent, 'end', true);
    }
    updateCurrent(value, key, notTrigger = false, notEmit = false) {
        if (!value) {
            return;
        }
        if (key === 'start') {
            this.startCurrent = new Date(value);
        }
        else {
            this.endCurrent = new Date(value);
        }
        if (!notTrigger) {
            if (this.closeOnSelected) {
                this.triggerRangeValueAndClose(value, key);
            }
            else {
                this.notTriggerRangeValue(value, key);
            }
        }
        !notEmit && this._cdr.markForCheck();
    }
    previous() {
        this.startCurrent.setDate(1);
        this.startCurrent.setMonth(this.startCurrent.getMonth() - 1);
        this.endCurrent.setDate(1);
        this.endCurrent.setMonth(this.endCurrent.getMonth() - 1);
        this.updateCurrent(this.startCurrent, 'start', true, true);
        this.updateCurrent(this.endCurrent, 'end', true);
    }
    next() {
        this.startCurrent.setDate(1);
        this.startCurrent.setMonth(this.startCurrent.getMonth() + 1);
        this.endCurrent.setDate(1);
        this.endCurrent.setMonth(this.endCurrent.getMonth() + 1);
        this.updateCurrent(this.startCurrent, 'start', true, true);
        this.updateCurrent(this.endCurrent, 'end', true);
    }
    notTriggerRangeValue(value, key) {
        const updatedValue = this.getTriggerUpdatedValue(value, key);
        this.notTriggerWriteValue(updatedValue);
    }
    triggerRangeValueAndClose(value, key, picker) {
        const updatedValue = this.getTriggerUpdatedValue(value, key);
        if (isEqual(updatedValue, this.defaultValue)) {
            return;
        }
        if (this.isFocused && updatedValue?.end && updatedValue?.start && picker) {
            picker.close(true);
        }
        this.writeValue(updatedValue);
    }
    getTriggerUpdatedValue(value, key) {
        if (!value) {
            return cloneDeep(this.editedValue);
        }
        if (!this.editedValue || (!this.editedValue.end && !this.editedValue.start)) {
            return {
                start: key === 'start' ? new Date(value) : null,
                end: key === 'end' ? new Date(value) : null,
            };
        }
        if (this.editedValue.end && this.editedValue.start) {
            if (compareDesc(this.editedValue.start, new Date(value)) === 0 ||
                compareDesc(this.editedValue.end, new Date(value)) === 0) {
                return cloneDeep(this.editedValue);
            }
            if (compareDesc(this.editedValue.start, new Date(value)) > 0) {
                return {
                    start: this.editedValue.start,
                    end: new Date(value),
                };
            }
            return {
                end: this.editedValue.end,
                start: new Date(value),
            };
        }
        if (this.editedValue.start) {
            if (compareDesc(this.editedValue.start, new Date(value)) === 0) {
                return cloneDeep(this.editedValue);
            }
            if (compareDesc(this.editedValue.start, new Date(value)) > 0) {
                return {
                    start: this.editedValue.start,
                    end: new Date(value),
                };
            }
            return {
                end: this.editedValue.start,
                start: new Date(value),
            };
        }
        if (this.editedValue.end) {
            if (compareDesc(this.editedValue.end, new Date(value)) === 0) {
                return cloneDeep(this.editedValue);
            }
            if (compareDesc(this.editedValue.end, new Date(value)) > 0) {
                return {
                    start: this.editedValue.end,
                    end: new Date(value),
                };
            }
            return {
                end: this.editedValue.end,
                start: new Date(value),
            };
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRangePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWRangePickerComponent, selector: "fsw-range-picker", providers: [
            FSW_RANGE_PICKER_ACCESSOR,
            {
                provide: FSWControlBase,
                useExisting: FSWRangePickerComponent,
            },
        ], queries: [{ propertyName: "prefixTemplate", first: true, predicate: FSWDateTimePickerPrefixDirective, descendants: true }], usesInheritance: true, ngImport: i0, template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"\n    editedValue\n      ? (editedValue.start ? (editedValue.start | date : format || 'dd/MM/yyyy' : locale) : '') +\n        '-' +\n        (editedValue.end ? (editedValue.end | date : format || 'dd/MM/yyyy' : locale) : '')\n      : null\n  \"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); resetCurrent(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <article class=\"{{ className }}__range-box\">\n      <main>\n        <ng-container>\n          <fsw-date-time-picker-day-box\n            *ngIf=\"startActiveBox === 'day'\"\n            [ngModel]=\"editedValue?.start\"\n            [showNext]=\"false\"\n            [isInside]=\"true\"\n            [isInRange]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            [current]=\"startCurrent\"\n            [range]=\"editedValue\"\n            [currentHover]=\"currentHover$ | async\"\n            (currentHoverChange)=\"currentHover$.next($event)\"\n            (previous)=\"previous()\"\n            (monthClick)=\"startActiveBox = 'month'\"\n            (ngModelChange)=\"\n              closeOnSelected\n                ? triggerRangeValueAndClose($event, 'start', picker)\n                : notTriggerRangeValue($event, 'start')\n            \"\n          ></fsw-date-time-picker-day-box>\n          <fsw-date-time-picker-month-box\n            *ngIf=\"startActiveBox === 'month'\"\n            [monthLabels]=\"monthLabels\"\n            [ngModel]=\"startCurrent\"\n            [isInside]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            (yearClick)=\"startActiveBox = 'year'\"\n            (back)=\"startActiveBox = 'day'\"\n            (ngModelChange)=\"updateCurrent($event, 'start', true)\"\n          ></fsw-date-time-picker-month-box>\n          <fsw-date-time-picker-year-box\n            *ngIf=\"startActiveBox === 'year'\"\n            [years]=\"years\"\n            [ngModel]=\"startCurrent\"\n            [isInside]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            (back)=\"startActiveBox = 'month'\"\n            (ngModelChange)=\"updateCurrent($event, 'start', true)\"\n          ></fsw-date-time-picker-year-box>\n        </ng-container>\n        <ng-container>\n          <fsw-date-time-picker-day-box\n            *ngIf=\"endActiveBox === 'day'\"\n            [ngModel]=\"editedValue?.end\"\n            [showPrevious]=\"false\"\n            [isInside]=\"true\"\n            [isInRange]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            [current]=\"endCurrent\"\n            [range]=\"editedValue\"\n            [currentHover]=\"currentHover$ | async\"\n            (currentHoverChange)=\"currentHover$.next($event)\"\n            (next)=\"next()\"\n            (monthClick)=\"endActiveBox = 'month'\"\n            (ngModelChange)=\"\n              closeOnSelected\n                ? triggerRangeValueAndClose($event, 'end', picker)\n                : notTriggerRangeValue($event, 'end')\n            \"\n          ></fsw-date-time-picker-day-box>\n          <fsw-date-time-picker-month-box\n            *ngIf=\"endActiveBox === 'month'\"\n            [monthLabels]=\"monthLabels\"\n            [ngModel]=\"endCurrent\"\n            [isInside]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            (yearClick)=\"endActiveBox = 'year'\"\n            (back)=\"endActiveBox = 'day'\"\n            (ngModelChange)=\"updateCurrent($event, 'end', true)\"\n          ></fsw-date-time-picker-month-box>\n          <fsw-date-time-picker-year-box\n            *ngIf=\"endActiveBox === 'year'\"\n            [years]=\"years\"\n            [ngModel]=\"endCurrent\"\n            [isInside]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            (back)=\"endActiveBox = 'month'\"\n            (ngModelChange)=\"updateCurrent($event, 'end', true)\"\n          ></fsw-date-time-picker-year-box>\n        </ng-container>\n      </main>\n      <fsw-date-time-picker-controller\n        *ngIf=\"!closeOnSelected\"\n        (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n        (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n      ></fsw-date-time-picker-controller>\n    </article>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: FSWIconDirective, selector: "i[fswIcon]", inputs: ["fswIcon", "fontSize"] }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "directive", type: FSWDateTimePickerSuffixDirective, selector: "ng-template[fswDateTimePickerSuffix]" }, { kind: "directive", type: FSWDateTimePickerBoxDirective, selector: "ng-template[fswDateTimePickerBox]" }, { kind: "component", type: FSWDateTimePickerMonthBoxComponent, selector: "fsw-date-time-picker-month-box", inputs: ["isInside"], outputs: ["back", "yearClick"] }, { kind: "component", type: FSWDateTimePickerYearBoxComponent, selector: "fsw-date-time-picker-year-box", inputs: ["isInside"], outputs: ["back"] }, { kind: "component", type: FSWDateTimePickerDayBoxComponent, selector: "fsw-date-time-picker-day-box", inputs: ["current", "isInside", "isInRange", "currentHover", "range", "showPrevious", "showNext", "hiddenNextMonth", "hiddenLastMonth"], outputs: ["previous", "currentHoverChange", "next", "monthClick"] }, { kind: "component", type: FSWDateTimePickerControllerComponent, selector: "fsw-date-time-picker-controller", outputs: ["cancel", "apply"] }, { kind: "component", type: FSWDateTimePickerTargetComponent, selector: "fsw-date-time-picker-target", inputs: ["render"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWRangePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-range-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        FSW_RANGE_PICKER_ACCESSOR,
                        {
                            provide: FSWControlBase,
                            useExisting: FSWRangePickerComponent,
                        },
                    ], template: "<fsw-date-time-picker-target\n  [positions]=\"positions\"\n  [hasError]=\"hasError\"\n  [internalError]=\"isRangeError\"\n  [isFocused]=\"isFocused\"\n  [isDisabled]=\"isDisabled\"\n  [isReadonly]=\"isReadonly\"\n  [placeHolder]=\"placeHolder\"\n  [render]=\"\n    editedValue\n      ? (editedValue.start ? (editedValue.start | date : format || 'dd/MM/yyyy' : locale) : '') +\n        '-' +\n        (editedValue.end ? (editedValue.end | date : format || 'dd/MM/yyyy' : locale) : '')\n      : null\n  \"\n  (openedBox)=\"_onTouched(); isFocused = true\"\n  (closedBox)=\"_onTouched(); resetEditedValue(); resetCurrent(); isFocused = false\"\n>\n  <ng-container *ngIf=\"prefixTemplate\">\n    <ng-template fswDateTimePickerPrefix>\n      <ng-container *ngTemplateOutlet=\"prefixTemplate.templateRef\"></ng-container>\n    </ng-template>\n  </ng-container>\n  <ng-template fswDateTimePickerSuffix>\n    <i [fswIcon]=\"'common-calendar-alternative'\"></i>\n  </ng-template>\n  <ng-template fswDateTimePickerBox let-picker>\n    <article class=\"{{ className }}__range-box\">\n      <main>\n        <ng-container>\n          <fsw-date-time-picker-day-box\n            *ngIf=\"startActiveBox === 'day'\"\n            [ngModel]=\"editedValue?.start\"\n            [showNext]=\"false\"\n            [isInside]=\"true\"\n            [isInRange]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            [current]=\"startCurrent\"\n            [range]=\"editedValue\"\n            [currentHover]=\"currentHover$ | async\"\n            (currentHoverChange)=\"currentHover$.next($event)\"\n            (previous)=\"previous()\"\n            (monthClick)=\"startActiveBox = 'month'\"\n            (ngModelChange)=\"\n              closeOnSelected\n                ? triggerRangeValueAndClose($event, 'start', picker)\n                : notTriggerRangeValue($event, 'start')\n            \"\n          ></fsw-date-time-picker-day-box>\n          <fsw-date-time-picker-month-box\n            *ngIf=\"startActiveBox === 'month'\"\n            [monthLabels]=\"monthLabels\"\n            [ngModel]=\"startCurrent\"\n            [isInside]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            (yearClick)=\"startActiveBox = 'year'\"\n            (back)=\"startActiveBox = 'day'\"\n            (ngModelChange)=\"updateCurrent($event, 'start', true)\"\n          ></fsw-date-time-picker-month-box>\n          <fsw-date-time-picker-year-box\n            *ngIf=\"startActiveBox === 'year'\"\n            [years]=\"years\"\n            [ngModel]=\"startCurrent\"\n            [isInside]=\"true\"\n            [min]=\"min\"\n            [max]=\"maxStartCurrent\"\n            (back)=\"startActiveBox = 'month'\"\n            (ngModelChange)=\"updateCurrent($event, 'start', true)\"\n          ></fsw-date-time-picker-year-box>\n        </ng-container>\n        <ng-container>\n          <fsw-date-time-picker-day-box\n            *ngIf=\"endActiveBox === 'day'\"\n            [ngModel]=\"editedValue?.end\"\n            [showPrevious]=\"false\"\n            [isInside]=\"true\"\n            [isInRange]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            [current]=\"endCurrent\"\n            [range]=\"editedValue\"\n            [currentHover]=\"currentHover$ | async\"\n            (currentHoverChange)=\"currentHover$.next($event)\"\n            (next)=\"next()\"\n            (monthClick)=\"endActiveBox = 'month'\"\n            (ngModelChange)=\"\n              closeOnSelected\n                ? triggerRangeValueAndClose($event, 'end', picker)\n                : notTriggerRangeValue($event, 'end')\n            \"\n          ></fsw-date-time-picker-day-box>\n          <fsw-date-time-picker-month-box\n            *ngIf=\"endActiveBox === 'month'\"\n            [monthLabels]=\"monthLabels\"\n            [ngModel]=\"endCurrent\"\n            [isInside]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            (yearClick)=\"endActiveBox = 'year'\"\n            (back)=\"endActiveBox = 'day'\"\n            (ngModelChange)=\"updateCurrent($event, 'end', true)\"\n          ></fsw-date-time-picker-month-box>\n          <fsw-date-time-picker-year-box\n            *ngIf=\"endActiveBox === 'year'\"\n            [years]=\"years\"\n            [ngModel]=\"endCurrent\"\n            [isInside]=\"true\"\n            [max]=\"max\"\n            [min]=\"minEndCurrent\"\n            (back)=\"endActiveBox = 'month'\"\n            (ngModelChange)=\"updateCurrent($event, 'end', true)\"\n          ></fsw-date-time-picker-year-box>\n        </ng-container>\n      </main>\n      <fsw-date-time-picker-controller\n        *ngIf=\"!closeOnSelected\"\n        (cancel)=\"triggerWriteValueAndClose(defaultValue, picker)\"\n        (apply)=\"triggerWriteValueAndClose(editedValue, picker)\"\n      ></fsw-date-time-picker-controller>\n    </article>\n  </ng-template>\n</fsw-date-time-picker-target>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { prefixTemplate: [{
                type: ContentChild,
                args: [FSWDateTimePickerPrefixDirective]
            }] } });

const UI = [
    FSWDateTimePickerPrefixDirective,
    FSWDateTimePickerSuffixDirective,
    FSWDateTimePickerLabelDirective,
    FSWDateTimePickerBoxDirective,
    FSWDateTimePickerActiveMonthPipe,
    FSWDateTimePickerActiveHourPipe,
    FSWDateTimePickerActiveMinutePipe,
    FSWDateTimePickerActiveYearPipe,
    FSWDateTimePickerActiveDayPipe,
    FSWDateTimePickerMonthBoxComponent,
    FSWDateTimePickerTimeBoxComponent,
    FSWDateTimePickerYearBoxComponent,
    FSWDateTimePickerDayBoxComponent,
    FSWDateTimePickerControllerComponent,
    FSWDateTimePickerActiveDirective,
    FSWDateTimePickerActiveRangePipe,
    FSWDateTimePickerTargetComponent,
    FSWTimePickerComponent,
    FSWYearPickerComponent,
    FSWDatePickerComponent,
    FSWMonthPickerComponent,
    FSWRangePickerComponent,
];
class FSWDateTimePickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerModule, declarations: [FSWDateTimePickerPrefixDirective,
            FSWDateTimePickerSuffixDirective,
            FSWDateTimePickerLabelDirective,
            FSWDateTimePickerBoxDirective,
            FSWDateTimePickerActiveMonthPipe,
            FSWDateTimePickerActiveHourPipe,
            FSWDateTimePickerActiveMinutePipe,
            FSWDateTimePickerActiveYearPipe,
            FSWDateTimePickerActiveDayPipe,
            FSWDateTimePickerMonthBoxComponent,
            FSWDateTimePickerTimeBoxComponent,
            FSWDateTimePickerYearBoxComponent,
            FSWDateTimePickerDayBoxComponent,
            FSWDateTimePickerControllerComponent,
            FSWDateTimePickerActiveDirective,
            FSWDateTimePickerActiveRangePipe,
            FSWDateTimePickerTargetComponent,
            FSWTimePickerComponent,
            FSWYearPickerComponent,
            FSWDatePickerComponent,
            FSWMonthPickerComponent,
            FSWRangePickerComponent], imports: [CommonModule,
            FSWIconModule,
            CdkMenuModule,
            FSWDropdownModule,
            FormsModule,
            FSWButtonModule,
            ReactiveFormsModule], exports: [FSWDateTimePickerPrefixDirective,
            FSWDateTimePickerSuffixDirective,
            FSWDateTimePickerLabelDirective,
            FSWDateTimePickerBoxDirective,
            FSWDateTimePickerActiveMonthPipe,
            FSWDateTimePickerActiveHourPipe,
            FSWDateTimePickerActiveMinutePipe,
            FSWDateTimePickerActiveYearPipe,
            FSWDateTimePickerActiveDayPipe,
            FSWDateTimePickerMonthBoxComponent,
            FSWDateTimePickerTimeBoxComponent,
            FSWDateTimePickerYearBoxComponent,
            FSWDateTimePickerDayBoxComponent,
            FSWDateTimePickerControllerComponent,
            FSWDateTimePickerActiveDirective,
            FSWDateTimePickerActiveRangePipe,
            FSWDateTimePickerTargetComponent,
            FSWTimePickerComponent,
            FSWYearPickerComponent,
            FSWDatePickerComponent,
            FSWMonthPickerComponent,
            FSWRangePickerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerModule, imports: [CommonModule,
            FSWIconModule,
            CdkMenuModule,
            FSWDropdownModule,
            FormsModule,
            FSWButtonModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDateTimePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [UI],
                    exports: [UI],
                    imports: [
                        CommonModule,
                        FSWIconModule,
                        CdkMenuModule,
                        FSWDropdownModule,
                        FormsModule,
                        FSWButtonModule,
                        ReactiveFormsModule,
                    ],
                }]
        }] });

//#endregion BUILDER

class FSWDynamicBuilderDefaultBase {
    constructor() {
        this.element = null;
        this.dictionaries = null;
        this.config = null;
        this.index = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderDefaultBase, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderDefaultBase, inputs: { element: "element", dictionaries: "dictionaries", config: "config", index: "index" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderDefaultBase, decorators: [{
            type: Directive
        }], propDecorators: { element: [{
                type: Input
            }], dictionaries: [{
                type: Input
            }], config: [{
                type: Input
            }], index: [{
                type: Input
            }] } });

var FSWDynamicBuilderFormTypes;
(function (FSWDynamicBuilderFormTypes) {
    FSWDynamicBuilderFormTypes["CONTROL"] = "control";
    FSWDynamicBuilderFormTypes["GROUP"] = "group";
    FSWDynamicBuilderFormTypes["ARRAY"] = "array";
    FSWDynamicBuilderFormTypes["CONTAINER"] = "container";
    FSWDynamicBuilderFormTypes["TABLE"] = "table";
})(FSWDynamicBuilderFormTypes || (FSWDynamicBuilderFormTypes = {}));
var FSWDynamicBuilderDefaultNames;
(function (FSWDynamicBuilderDefaultNames) {
    FSWDynamicBuilderDefaultNames["CONTROL"] = "fsw-dynamic-builder-control";
    FSWDynamicBuilderDefaultNames["GROUP"] = "fsw-dynamic-builder-group";
    FSWDynamicBuilderDefaultNames["ARRAY"] = "fsw-dynamic-builder-array";
    FSWDynamicBuilderDefaultNames["CONTAINER"] = "fsw-dynamic-builder-container";
    FSWDynamicBuilderDefaultNames["TABLE"] = "fsw-dynamic-builder-table";
})(FSWDynamicBuilderDefaultNames || (FSWDynamicBuilderDefaultNames = {}));
var FSWDynamicBuilderControlTypes;
(function (FSWDynamicBuilderControlTypes) {
    FSWDynamicBuilderControlTypes["CHECKBOX"] = "checkbox";
    FSWDynamicBuilderControlTypes["CHECKBOX_GROUP"] = "checkbox-group";
    FSWDynamicBuilderControlTypes["RADIO_GROUP"] = "radio-group";
    FSWDynamicBuilderControlTypes["INPUT"] = "input";
    FSWDynamicBuilderControlTypes["SELECT"] = "select";
    FSWDynamicBuilderControlTypes["SWITCH"] = "switch";
    FSWDynamicBuilderControlTypes["DATE_TIME_PICKER"] = "date-time-picker";
    FSWDynamicBuilderControlTypes["TEMPLATE"] = "template";
})(FSWDynamicBuilderControlTypes || (FSWDynamicBuilderControlTypes = {}));
var FSWDynamicBuilderRootTypes;
(function (FSWDynamicBuilderRootTypes) {
    FSWDynamicBuilderRootTypes["ARRAY"] = "array";
    FSWDynamicBuilderRootTypes["GROUP"] = "group";
})(FSWDynamicBuilderRootTypes || (FSWDynamicBuilderRootTypes = {}));
var FSWDynamicBuilderHiddenFields;
(function (FSWDynamicBuilderHiddenFields) {
    FSWDynamicBuilderHiddenFields["READONLY_LISTENER"] = "_fswDynamicBuilderReadonly";
    FSWDynamicBuilderHiddenFields["SET_READONLY"] = "_fswDynamicBuilderSetReadonly";
    FSWDynamicBuilderHiddenFields["LOADING_LISTENER"] = "_fswDynamicBuilderLoading";
    FSWDynamicBuilderHiddenFields["SET_LOADING"] = "_fswDynamicBuilderSetLoading";
    FSWDynamicBuilderHiddenFields["ABSOLUTE_KEY"] = "_fswDynamicBuilderAbsoluteKey";
    FSWDynamicBuilderHiddenFields["CONTROLS"] = "_fswDynamicBuilderControls";
})(FSWDynamicBuilderHiddenFields || (FSWDynamicBuilderHiddenFields = {}));

function createFormControl(item, absoluteKey) {
    const control = new UntypedFormControl(item.context?.defaultValue, item.validations || []);
    defineDynamicBuilderAbsoluteKey(control, absoluteKey);
    defineControlReadonly(control, item.context?.isReadonly, item.readonlyWhen$);
    defineControlLoading(control, item.context?.isLoading, item.loadingWhen$);
    if (item.context?.isDisabled) {
        control.disable();
    }
    return control;
}
function createFormTable(item, absoluteKey) {
    const group = new UntypedFormGroup({}, item.validations || []);
    defineDynamicBuilderAbsoluteKey(group, absoluteKey);
    setupFormTable(group, item);
    defineGroupReadonly(group, false, item.readonlyWhen$);
    defineGroupLoading(group, false, item.loadingWhen$);
    return group;
}
function createFormTableItem(item, absoluteKey) {
    const group = new UntypedFormGroup({}, item.validations || []);
    defineDynamicBuilderAbsoluteKey(group, absoluteKey);
    setupFormTableItem(group, item);
    defineGroupReadonly(group, false, item.readonlyWhen$);
    defineGroupLoading(group, false, item.loadingWhen$);
    return group;
}
function createFormTableRow(item, absoluteKey) {
    const group = new UntypedFormGroup({}, item.validations || []);
    defineDynamicBuilderAbsoluteKey(group, absoluteKey);
    setupFormTableRow(group, item);
    defineGroupReadonly(group, false, item.readonlyWhen$);
    defineGroupLoading(group, false, item.loadingWhen$);
    return group;
}
function createFormTableBodyLoop(item, absoluteKey) {
    const array = new UntypedFormArray([], item.validations || []);
    defineDynamicBuilderAbsoluteKey(array, absoluteKey);
    setupFormTableBodyLoop(array, item);
    defineArrayReadonly(array, false, item.readonlyWhen$);
    defineArrayLoading(array, false, item.loadingWhen$);
    return array;
}
function createFormGroup(item, absoluteKey) {
    const group = new UntypedFormGroup({}, item.validations || []);
    defineDynamicBuilderAbsoluteKey(group, absoluteKey);
    setupFormGroup(group, item);
    defineGroupReadonly(group, false, item.readonlyWhen$);
    defineGroupLoading(group, false, item.loadingWhen$);
    return group;
}
function createFormArray(item, absoluteKey) {
    const array = new UntypedFormArray([], item.validations || []);
    defineDynamicBuilderAbsoluteKey(array, absoluteKey);
    setupFormArray(array, item);
    defineArrayReadonly(array, false, item.readonlyWhen$);
    defineArrayLoading(array, false, item.loadingWhen$);
    return array;
}
function createFormGroupByContainers(group, containers) {
    const fields = containers.reduce((acc, cur) => {
        return acc.concat(getContainerFields(cur));
    }, []);
    createFormGroupByFields(group, fields);
}
function getContainerFields(container) {
    return (container.fields || []).concat((container.containers || []).reduce((acc, cur) => acc.concat(getContainerFields(cur)), []));
}
function createFormGroupByFields(group, fields) {
    const groupKey = getDynamicBuilderAbsoluteKeyWithPrefix(group);
    fields.forEach((field) => {
        removeExistedControlOfFormGroup(group, field.key);
        group.addControl(field.key, transformItemToControl(field, `${groupKey}${field.key}`));
    });
    setDynamicBuilderHiddenControls(group, group.controls);
}
function setupFormGroup(group, item) {
    if (item.renderBy === 'container') {
        createFormGroupByContainers(group, item.containers);
    }
    else {
        createFormGroupByFields(group, item.fields);
    }
}
function setupFormTable(group, item) {
    const groupKey = getDynamicBuilderAbsoluteKeyWithPrefix(group);
    const { header, footer, items } = item;
    setupFormTableHeader(group, groupKey, header);
    items?.forEach((item) => {
        if (item.key) {
            removeExistedControlOfFormGroup(group, item.key);
            group.addControl(item.key, createFormTableItem(item, `${groupKey}.${item.key}`));
        }
        else {
            setupFormTableItem(group, item);
        }
    });
    setupFormTableFooter(group, groupKey, footer);
}
function setupFormTableItem(group, item) {
    const groupKey = getDynamicBuilderAbsoluteKeyWithPrefix(group);
    const { header, footer, body } = item;
    setupFormTableHeader(group, groupKey, header);
    setupFormTableBody(group, groupKey, body);
    setupFormTableFooter(group, groupKey, footer);
}
function setupFormTableHeader(group, groupKey, header) {
    if (header) {
        header
            .filter((row) => !!row.key)
            .forEach((row) => {
            removeExistedControlOfFormGroup(group, row.key);
            group.addControl(row.key, createFormTableRow(row, `${groupKey}${row.key}`));
        });
    }
}
function setupFormTableBody(group, groupKey, body) {
    if (body) {
        if (body.isLoop) {
            removeExistedControlOfFormGroup(group, body.key);
            group.addControl(body.key, createFormTableBodyLoop(body, `${groupKey}${body.key}`));
        }
        else {
            body.data
                .filter((row) => !!row.key)
                .forEach((row) => {
                removeExistedControlOfFormGroup(group, row.key);
                group.addControl(row.key, createFormTableRow(row, `${groupKey}${row.key}`));
            });
        }
    }
}
function setupFormTableFooter(group, groupKey, footer) {
    if (footer) {
        footer
            .filter((row) => !!row.key)
            .forEach((row) => {
            removeExistedControlOfFormGroup(group, row.key);
            group.addControl(row.key, createFormTableRow(row, `${groupKey}${row.key}`));
        });
    }
}
function setupFormTableRow(group, item) {
    item.columns
        .filter((column) => column.columnType === 'control')
        .forEach((column) => {
        const forceColumn = column;
        if (forceColumn.renderBy === 'container') {
            createFormGroupByContainers(group, forceColumn.containers);
        }
        else {
            createFormGroupByFields(group, forceColumn.fields);
        }
    });
}
function setupFormTableBodyLoop(array, item) {
    const customUpdateValue = (value, options) => {
        if (value == null || !isArray(value)) {
            return;
        }
        array.clear({ emitEvent: false });
        const arrayKey = getDynamicBuilderAbsoluteKeyWithPrefix(array);
        value.forEach((v, index) => {
            const formGroup = createFormTableRow(item.data, `${arrayKey}[${index}]`);
            formGroup.patchValue(v, { onlySelf: true, emitEvent: options?.emitEvent || true });
            array.push(formGroup, options);
        });
        getDynamicBuilderSetReadonly(array)(getDynamicBuilderReadonly(array).value);
        array.updateValueAndValidity(options);
    };
    array.patchValue = customUpdateValue;
    array.setValue = customUpdateValue;
}
function setupFormArray(array, item) {
    const customUpdateValue = (value, options) => {
        if (value == null || !isArray(value)) {
            return;
        }
        array.clear({ emitEvent: false });
        const arrayKey = getDynamicBuilderAbsoluteKeyWithPrefix(array);
        if (item.renderBy === 'container') {
            value.forEach((v, index) => {
                const formGroup = createFormGroup(item, `${arrayKey}[${index}]`);
                formGroup.patchValue(v, { onlySelf: true, emitEvent: options?.emitEvent || true });
                array.push(formGroup, options);
            });
        }
        else {
            value.forEach((v, index) => {
                const arrayItem = item.item;
                const control = transformItemToControl(arrayItem, `${arrayKey}[${index}]`);
                control.patchValue(v, { onlySelf: true, emitEvent: options?.emitEvent || true });
                array.push(control, options);
            });
        }
        array.updateValueAndValidity(options);
    };
    array.patchValue = customUpdateValue;
    array.setValue = customUpdateValue;
}
function transformItemToControl(item, absoluteKey) {
    switch (item.formType) {
        case FSWDynamicBuilderFormTypes.GROUP:
            return createFormGroup(item, absoluteKey);
        case FSWDynamicBuilderFormTypes.ARRAY:
            return createFormArray(item, absoluteKey);
        case FSWDynamicBuilderFormTypes.TABLE:
            return createFormTable(item, absoluteKey);
        default:
            return createFormControl(item, absoluteKey);
    }
}
function removeExistedControlOfFormGroup(formGroup, name) {
    const existed = formGroup.get(name);
    if (existed) {
        formGroup.removeControl(name);
    }
}
function removeAllControlsOfFormGroup(formGroup) {
    Object.keys(formGroup.controls).forEach((key) => formGroup.removeControl(key, { emitEvent: false }));
}
function getControlFromGroup(group, key, throwingError = false) {
    const control = group.get(key);
    if (!control && throwingError) {
        throw new Error(`Cannot find control with key: ${key}`);
    }
    return control;
}
function getControlFromGroupByGroupPath(group, path) {
    const keys = path.split('.').filter((key) => !!key);
    if (!keys.length) {
        throw new Error(`Path ${path} is not valid`);
    }
    const firstKey = keys.shift();
    let control = group.get(firstKey);
    keys.forEach((key) => {
        if (control && control instanceof UntypedFormGroup) {
            control = control.get(key);
        }
    });
    if (!control) {
        throw new Error(`Cannot find control with key: ${path}`);
    }
    return control;
}
function getControlFromArray(array, index) {
    const control = array.at(index);
    if (!control) {
        throw new Error(`Cannot find control with index: ${index}`);
    }
    return control;
}
function defineControlReadonly(control, defaultValue, readonlyWhen$) {
    defineDynamicBuilderReadonly(control, defaultValue);
    defineDynamicBuilderSetReadonly(control, (value) => {
        getDynamicBuilderReadonly(control).next(value);
    });
    if (readonlyWhen$) {
        readonlyWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetReadonly(control)(value)))
            .subscribe();
    }
}
function defineGroupReadonly(group, defaultValue, readonlyWhen$) {
    defineDynamicBuilderReadonly(group, defaultValue);
    defineDynamicBuilderSetReadonly(group, (value) => {
        getDynamicBuilderReadonly(group).next(value);
        Object.keys(group.controls).forEach((key) => {
            getDynamicBuilderSetReadonly(group.controls[key])(value);
        });
    });
    if (readonlyWhen$) {
        readonlyWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetReadonly(group)(value)))
            .subscribe();
    }
}
function defineArrayReadonly(array, defaultValue, readonlyWhen$) {
    defineDynamicBuilderReadonly(array, defaultValue);
    defineDynamicBuilderSetReadonly(array, (value) => {
        getDynamicBuilderReadonly(array).next(value);
        array.controls.forEach((control) => {
            getDynamicBuilderSetReadonly(control)(value);
        });
    });
    if (readonlyWhen$) {
        readonlyWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetReadonly(array)(value)))
            .subscribe();
    }
}
function defineControlLoading(control, defaultValue, loadingWhen$) {
    defineDynamicBuilderLoading(control, defaultValue);
    defineDynamicBuilderSetLoading(control, (value) => {
        getDynamicBuilderLoading(control).next(value);
    });
    if (loadingWhen$) {
        loadingWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetLoading(control)(value)))
            .subscribe();
    }
}
function defineGroupLoading(group, defaultValue, loadingWhen$) {
    defineDynamicBuilderLoading(group, defaultValue);
    defineDynamicBuilderSetLoading(group, (value) => {
        getDynamicBuilderLoading(group).next(value);
        Object.keys(group.controls).forEach((key) => {
            getDynamicBuilderSetLoading(group.controls[key])(value);
        });
    });
    if (loadingWhen$) {
        loadingWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetLoading(group)(value)))
            .subscribe();
    }
}
function defineArrayLoading(array, defaultValue, loadingWhen$) {
    defineDynamicBuilderLoading(array, defaultValue);
    defineDynamicBuilderSetLoading(array, (value) => {
        getDynamicBuilderLoading(array).next(value);
        array.controls.forEach((control) => {
            getDynamicBuilderSetLoading(control)(value);
        });
    });
    if (loadingWhen$) {
        loadingWhen$
            .pipe(startWith(defaultValue || false), tap((value) => getDynamicBuilderSetLoading(array)(value)))
            .subscribe();
    }
}
function assignData(instance, item) {
    const { id, name, customClasses, customProps, ...config } = item;
    instance.element = { id, name, customClasses, customProps };
    instance.config = config;
}
function assignControl(instance, item, control = null) {
    switch (item.formType) {
        case FSWDynamicBuilderFormTypes.GROUP:
            instance.control = control;
            break;
        case FSWDynamicBuilderFormTypes.ARRAY:
            instance.control = control;
            break;
        default:
            instance.control = control;
            break;
    }
}
function defineHiddenProp(field, prop, value) {
    Object.defineProperty(field, prop, {
        enumerable: false,
        writable: true,
        configurable: true,
        value,
    });
}
function getHiddenPropValue(field, prop) {
    return field[prop];
}
function defineDynamicBuilderAbsoluteKey(field, value) {
    defineHiddenProp(field, FSWDynamicBuilderHiddenFields.ABSOLUTE_KEY, value);
}
function getDynamicBuilderAbsoluteKeyWithPrefix(field) {
    const absoluteKey = getDynamicBuilderAbsoluteKey(field);
    return absoluteKey ? `${absoluteKey}.` : '';
}
function getDynamicBuilderAbsoluteKey(field) {
    return field[FSWDynamicBuilderHiddenFields.ABSOLUTE_KEY];
}
function defineDynamicBuilderReadonly(field, defaultValue) {
    defineHiddenProp(field, FSWDynamicBuilderHiddenFields.READONLY_LISTENER, new BehaviorSubject(!!defaultValue));
}
function getDynamicBuilderReadonly(field) {
    return field[FSWDynamicBuilderHiddenFields.READONLY_LISTENER];
}
function defineDynamicBuilderSetReadonly(field, cb) {
    defineHiddenProp(field, FSWDynamicBuilderHiddenFields.SET_READONLY, cb);
}
function getDynamicBuilderSetReadonly(field) {
    return field[FSWDynamicBuilderHiddenFields.SET_READONLY];
}
function defineDynamicBuilderLoading(field, defaultValue) {
    defineHiddenProp(field, FSWDynamicBuilderHiddenFields.LOADING_LISTENER, new BehaviorSubject(!!defaultValue));
}
function getDynamicBuilderLoading(field) {
    return field[FSWDynamicBuilderHiddenFields.LOADING_LISTENER];
}
function defineDynamicBuilderSetLoading(field, cb) {
    defineHiddenProp(field, FSWDynamicBuilderHiddenFields.SET_LOADING, cb);
}
function getDynamicBuilderSetLoading(field) {
    return field[FSWDynamicBuilderHiddenFields.SET_LOADING];
}
function getDynamicBuilderHiddenControls(field) {
    return field[FSWDynamicBuilderHiddenFields.CONTROLS] || {};
}
function setDynamicBuilderHiddenControls(field, controls) {
    return (field[FSWDynamicBuilderHiddenFields.CONTROLS] = {
        ...getDynamicBuilderHiddenControls(field),
        ...controls,
    });
}
function removeDynamicBuilderHiddenControls(field, key) {
    return (field[FSWDynamicBuilderHiddenFields.CONTROLS] = Object.keys(getDynamicBuilderHiddenControls(field)).reduce((acc, cur) => {
        if (cur !== key) {
            acc[cur] = getDynamicBuilderHiddenControls(field)[cur];
        }
        return acc;
    }, {}));
}

class FSWDynamicBuilderFormBase extends FSWDynamicBuilderDefaultBase {
    constructor() {
        super(...arguments);
        this.control = null;
    }
    get isReadonly$() {
        if (!this.control) {
            return of(false);
        }
        return getDynamicBuilderReadonly(this.control);
    }
    get isLoading$() {
        if (!this.control) {
            return of(false);
        }
        return getDynamicBuilderLoading(this.control);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderFormBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderFormBase, inputs: { control: "control" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderFormBase, decorators: [{
            type: Directive
        }], propDecorators: { control: [{
                type: Input
            }] } });

class FSWDynamicBuilderControlBase extends FSWDynamicBuilderFormBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderControlBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlBase, decorators: [{
            type: Directive
        }] });

let FSWDynamicBuilderArrayBase = class FSWDynamicBuilderArrayBase extends FSWDynamicBuilderFormBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderArrayBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderArrayBase, usesInheritance: true, ngImport: i0 }); }
};
FSWDynamicBuilderArrayBase = __decorate([
    autoDestroy()
], FSWDynamicBuilderArrayBase);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderArrayBase, decorators: [{
            type: Directive
        }] });

class FSWDynamicBuilderGroupBase extends FSWDynamicBuilderFormBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderGroupBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderGroupBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderGroupBase, decorators: [{
            type: Directive
        }] });

class FSWDynamicBuilderContainerBase extends FSWDynamicBuilderDefaultBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderContainerBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerBase, decorators: [{
            type: Directive
        }] });

class FSWDynamicBuilderTableBase extends FSWDynamicBuilderFormBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableBase, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableBase, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableBase, decorators: [{
            type: Directive
        }] });

class FSWDynamicBuilder {
    get groupConfig() {
        return this.config;
    }
    get tableConfig() {
        return this.config;
    }
    get arrayConfig() {
        return this.config;
    }
    get element() {
        return this.config;
    }
    constructor(_config) {
        this._config = _config;
        this.config = null;
        this.updateConfig(_config);
    }
    updateConfig(config) {
        this.config = config;
        if (!config) {
            return;
        }
        const { formType } = this.config;
        if (formType === FSWDynamicBuilderFormTypes.GROUP) {
            setupFormGroup(this.groupConfig.form, this.groupConfig);
            defineGroupReadonly(this.groupConfig.form, false, this.groupConfig.readonlyWhen$);
            defineGroupLoading(this.groupConfig.form, false, this.groupConfig.loadingWhen$);
        }
        else if (formType === FSWDynamicBuilderFormTypes.ARRAY) {
            this.arrayConfig.form.clear();
            setupFormArray(this.arrayConfig.form, this.arrayConfig);
            defineArrayReadonly(this.arrayConfig.form, false, this.arrayConfig.readonlyWhen$);
            defineArrayLoading(this.arrayConfig.form, false, this.groupConfig.loadingWhen$);
        }
        else {
            setupFormTable(this.tableConfig.form, this.tableConfig);
            defineGroupReadonly(this.tableConfig.form, false, this.tableConfig.readonlyWhen$);
            defineGroupLoading(this.tableConfig.form, false, this.tableConfig.loadingWhen$);
        }
    }
}

const FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN');
const FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN');
const FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN');
const FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN');
const FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN');

const FSW_DYNAMIC_BUILDER_SERVICE_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_SERVICE_TOKEN');

const FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN = new InjectionToken('FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN');

class FSWDynamicBuilderTemplatePipe {
    constructor(_service, _builderComponent) {
        this._service = _service;
        this._builderComponent = _builderComponent;
    }
    transform(key) {
        return this._service.getTemplate(key || '', this._builderComponent.groupId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplatePipe, deps: [{ token: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN }, { token: FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswDynamicBuilderTemplate',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN]
                }] }]; } });

class FSWDynamicBuilderCheckboxComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWFieldSizes = FSWFieldSizes;
        this.FSWCheckboxSizes = FSWCheckboxSizes;
        this.FSWCheckboxStyles = FSWCheckboxStyles;
    }
    get context() {
        return (this.config?.context || {});
    }
    get renderTemplate() {
        return (this.context.renderTemplate ||
            {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderCheckboxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderCheckboxComponent, selector: "fsw-dynamic-builder-checkbox", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-checkbox\n      [class]=\"element?.customClasses\"\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [label]=\"renderTemplate.label || null\"\n      [description]=\"renderTemplate.description || null\"\n      [size]=\"renderTemplate.size || FSWCheckboxSizes.M\"\n      [renderStyle]=\"renderTemplate.renderStyle || FSWCheckboxStyles.BLOCK\"\n      [readOnly]=\"!!context.isReadonly\"\n    ></fsw-checkbox>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "component", type: FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-checkbox\n      [class]=\"element?.customClasses\"\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [label]=\"renderTemplate.label || null\"\n      [description]=\"renderTemplate.description || null\"\n      [size]=\"renderTemplate.size || FSWCheckboxSizes.M\"\n      [renderStyle]=\"renderTemplate.renderStyle || FSWCheckboxStyles.BLOCK\"\n      [readOnly]=\"!!context.isReadonly\"\n    ></fsw-checkbox>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderCheckboxGroupComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWCheckboxSizes = FSWCheckboxSizes;
        this.FSWCheckboxStyles = FSWCheckboxStyles;
        this.FSWCheckboxDirections = FSWCheckboxDirections;
        this.FSWFieldSizes = FSWFieldSizes;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    getRenderTemplateOfItem(item) {
        return (item.renderTemplate || {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderCheckboxGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderCheckboxGroupComponent, selector: "fsw-dynamic-builder-checkbox-group", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-checkbox-group\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [direction]=\"context.direction || FSWCheckboxDirections.COLUMN\"\n      [gap]=\"context.gap || '20px'\"\n    >\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <fsw-checkbox\n            [class]=\"element?.customClasses\"\n            [label]=\"getRenderTemplateOfItem(item).label || null\"\n            [data]=\"item.value\"\n            [description]=\"getRenderTemplateOfItem(item).description || null\"\n            [size]=\"getRenderTemplateOfItem(item).size || FSWCheckboxSizes.M\"\n            [renderStyle]=\"getRenderTemplateOfItem(item).renderStyle || FSWCheckboxStyles.BLOCK\"\n          ></fsw-checkbox>\n        </ng-container>\n      </ng-container>\n    </fsw-checkbox-group>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "component", type: FSWCheckboxGroupComponent, selector: "fsw-checkbox-group" }, { kind: "component", type: FSWCheckboxComponent, selector: "fsw-checkbox" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-checkbox-group', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-checkbox-group\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [direction]=\"context.direction || FSWCheckboxDirections.COLUMN\"\n      [gap]=\"context.gap || '20px'\"\n    >\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <fsw-checkbox\n            [class]=\"element?.customClasses\"\n            [label]=\"getRenderTemplateOfItem(item).label || null\"\n            [data]=\"item.value\"\n            [description]=\"getRenderTemplateOfItem(item).description || null\"\n            [size]=\"getRenderTemplateOfItem(item).size || FSWCheckboxSizes.M\"\n            [renderStyle]=\"getRenderTemplateOfItem(item).renderStyle || FSWCheckboxStyles.BLOCK\"\n          ></fsw-checkbox>\n        </ng-container>\n      </ng-container>\n    </fsw-checkbox-group>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderInputComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWFieldSizes = FSWFieldSizes;
        this.MAX_LENGTH = 100000000000;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get forceNumberContext() {
        return (this.config?.context || {});
    }
    get forceAreaContext() {
        return (this.config?.context || {});
    }
    get forcePasswordContext() {
        return (this.config?.context || {});
    }
    get forceTextContext() {
        return (this.config?.context || {});
    }
    get maskConfig() {
        return {
            ...initialConfig,
            ...(this.forceTextContext.mask?.config || {}),
        };
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderInputComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderInputComponent, selector: "fsw-dynamic-builder-input", providers: [provideNgxMask()], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.inputType === 'password' && forcePasswordContext.showToggle\">\n      <ng-template fswFieldHeaderSuffix [kind]=\"'password'\"></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\">\n      <ng-template fswFieldInputPrefix>\n        <ng-container\n          *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n        ></ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-template #defaultPrefix>\n      <ng-container *ngIf=\"context.prefix\">\n        <ng-template fswFieldInputPrefix>{{ context.prefix }}</ng-template>\n      </ng-container>\n    </ng-template>\n    <ng-container *ngIf=\"context.inputType !== 'area'\">\n      <ng-container *ngIf=\"!!forceTextContext?.mask; else defaultInput\">\n        <input\n          fswInput\n          [type]=\"context.inputType\"\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputMin]=\"forceNumberContext.min || null\"\n          [fswInputMax]=\"forceNumberContext.max || null\"\n          [mask]=\"$any(forceTextContext.mask?.expression)\"\n          [suffix]=\"$any(maskConfig.suffix)\"\n          [prefix]=\"$any(maskConfig.prefix)\"\n          [thousandSeparator]=\"$any(maskConfig.thousandSeparator)\"\n          [decimalMarker]=\"$any(maskConfig.decimalMarker)\"\n          [clearIfNotMatch]=\"$any(maskConfig.clearIfNotMatch)\"\n          [showTemplate]=\"$any(maskConfig.showTemplate)\"\n          [showMaskTyped]=\"$any(maskConfig.showMaskTyped)\"\n          [placeHolderCharacter]=\"$any(maskConfig.placeHolderCharacter)\"\n          [shownMaskExpression]=\"$any(maskConfig.shownMaskExpression)\"\n          [specialCharacters]=\"$any(maskConfig.specialCharacters)\"\n          [dropSpecialCharacters]=\"$any(maskConfig.dropSpecialCharacters)\"\n          [hiddenInput]=\"$any(maskConfig.hiddenInput)\"\n          [validation]=\"$any(maskConfig.validation)\"\n          [separatorLimit]=\"$any(maskConfig.separatorLimit)\"\n          [apm]=\"$any(maskConfig.apm)\"\n          [allowNegativeNumbers]=\"$any(maskConfig.allowNegativeNumbers)\"\n          [leadZeroDateTime]=\"$any(maskConfig.leadZeroDateTime)\"\n          [leadZero]=\"$any(maskConfig.leadZero)\"\n          [triggerOnMaskChange]=\"$any(maskConfig.triggerOnMaskChange)\"\n          [keepCharacterPositions]=\"$any(maskConfig.keepCharacterPositions)\"\n          [inputTransformFn]=\"$any(maskConfig.inputTransformFn)\"\n          [outputTransformFn]=\"$any(maskConfig.outputTransformFn)\"\n          (maskFilled)=\"maskConfig.maskFilled?.emit($event)\"\n          [patterns]=\"$any(maskConfig.patterns)\"\n        />\n      </ng-container>\n      <ng-template #defaultInput>\n        <input\n          fswInput\n          [type]=\"context.inputType\"\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputMin]=\"forceNumberContext.min || null\"\n          [fswInputMax]=\"forceNumberContext.max || null\"\n        />\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.inputType === 'area'\">\n      <ng-container *ngIf=\"!!forceTextContext?.mask; else defaultArea\">\n        <textarea\n          fswInput\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [class]=\"element?.customClasses\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [rows]=\"forceAreaContext.rows || 4\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [mask]=\"$any(forceTextContext.mask?.expression)\"\n          [suffix]=\"$any(maskConfig.suffix)\"\n          [prefix]=\"$any(maskConfig.prefix)\"\n          [thousandSeparator]=\"$any(maskConfig.thousandSeparator)\"\n          [decimalMarker]=\"$any(maskConfig.decimalMarker)\"\n          [clearIfNotMatch]=\"$any(maskConfig.clearIfNotMatch)\"\n          [showTemplate]=\"$any(maskConfig.showTemplate)\"\n          [showMaskTyped]=\"$any(maskConfig.showMaskTyped)\"\n          [placeHolderCharacter]=\"$any(maskConfig.placeHolderCharacter)\"\n          [shownMaskExpression]=\"$any(maskConfig.shownMaskExpression)\"\n          [specialCharacters]=\"$any(maskConfig.specialCharacters)\"\n          [dropSpecialCharacters]=\"$any(maskConfig.dropSpecialCharacters)\"\n          [hiddenInput]=\"$any(maskConfig.hiddenInput)\"\n          [validation]=\"$any(maskConfig.validation)\"\n          [separatorLimit]=\"$any(maskConfig.separatorLimit)\"\n          [apm]=\"$any(maskConfig.apm)\"\n          [allowNegativeNumbers]=\"$any(maskConfig.allowNegativeNumbers)\"\n          [leadZeroDateTime]=\"$any(maskConfig.leadZeroDateTime)\"\n          [leadZero]=\"$any(maskConfig.leadZero)\"\n          [triggerOnMaskChange]=\"$any(maskConfig.triggerOnMaskChange)\"\n          [keepCharacterPositions]=\"$any(maskConfig.keepCharacterPositions)\"\n          [inputTransformFn]=\"$any(maskConfig.inputTransformFn)\"\n          [outputTransformFn]=\"$any(maskConfig.outputTransformFn)\"\n          (maskFilled)=\"maskConfig.maskFilled?.emit($event)\"\n          [patterns]=\"$any(maskConfig.patterns)\"\n        ></textarea>\n      </ng-container>\n      <ng-template #defaultArea>\n        <textarea\n          fswInput\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [class]=\"element?.customClasses\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [rows]=\"forceAreaContext.rows || 4\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputPattern]=\"context.pattern || null\"\n        ></textarea>\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.suffix | fswDynamicBuilderTemplate as ref; else defaultSuffix\">\n      <ng-template fswFieldInputSuffix>\n        <ng-container\n          *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.suffix }\"\n        ></ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-template #defaultSuffix>\n      <ng-container *ngIf=\"context.suffix\">\n        <ng-template fswFieldInputSuffix>{{ context.suffix }}</ng-template>\n      </ng-container>\n    </ng-template>\n    <ng-container *ngIf=\"context.showCount\">\n      <ng-template fswFieldFooterSuffix [kind]=\"'counter'\"></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldInputPrefixDirective, selector: "ng-template[fswFieldInputPrefix]" }, { kind: "directive", type: FSWFieldInputSuffixDirective, selector: "ng-template[fswFieldInputSuffix]" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldFooterSuffixDirective, selector: "ng-template[fswFieldFooterSuffix]", inputs: ["kind"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldHeaderSuffixDirective, selector: "ng-template[fswFieldHeaderSuffix]", inputs: ["kind"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "directive", type: FSWInputDirective, selector: "input[fswInput], textarea[fswInput]" }, { kind: "directive", type: FSWInputPatternDirective, selector: "input[fswInputPattern], textarea[fswInputPattern]", inputs: ["fswInputPattern"] }, { kind: "directive", type: FSWInputMinDirective, selector: "input[fswInputMin]", inputs: ["fswInputMin"] }, { kind: "directive", type: FSWInputMaxDirective, selector: "input[fswInputMax]", inputs: ["fswInputMax"] }, { kind: "directive", type: FSWInputMinLengthDirective, selector: "input[fswInputMinLength], textarea[fswInputMinLength]", inputs: ["fswInputMinLength"] }, { kind: "directive", type: FSWInputMaxLengthDirective, selector: "input[fswInputMaxLength], textarea[fswInputMaxLength]", inputs: ["fswInputMaxLength"] }, { kind: "directive", type: i17.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWHasErrorPipe, name: "fswHasError" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-input', changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideNgxMask()], template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.inputType === 'password' && forcePasswordContext.showToggle\">\n      <ng-template fswFieldHeaderSuffix [kind]=\"'password'\"></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\">\n      <ng-template fswFieldInputPrefix>\n        <ng-container\n          *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n        ></ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-template #defaultPrefix>\n      <ng-container *ngIf=\"context.prefix\">\n        <ng-template fswFieldInputPrefix>{{ context.prefix }}</ng-template>\n      </ng-container>\n    </ng-template>\n    <ng-container *ngIf=\"context.inputType !== 'area'\">\n      <ng-container *ngIf=\"!!forceTextContext?.mask; else defaultInput\">\n        <input\n          fswInput\n          [type]=\"context.inputType\"\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputMin]=\"forceNumberContext.min || null\"\n          [fswInputMax]=\"forceNumberContext.max || null\"\n          [mask]=\"$any(forceTextContext.mask?.expression)\"\n          [suffix]=\"$any(maskConfig.suffix)\"\n          [prefix]=\"$any(maskConfig.prefix)\"\n          [thousandSeparator]=\"$any(maskConfig.thousandSeparator)\"\n          [decimalMarker]=\"$any(maskConfig.decimalMarker)\"\n          [clearIfNotMatch]=\"$any(maskConfig.clearIfNotMatch)\"\n          [showTemplate]=\"$any(maskConfig.showTemplate)\"\n          [showMaskTyped]=\"$any(maskConfig.showMaskTyped)\"\n          [placeHolderCharacter]=\"$any(maskConfig.placeHolderCharacter)\"\n          [shownMaskExpression]=\"$any(maskConfig.shownMaskExpression)\"\n          [specialCharacters]=\"$any(maskConfig.specialCharacters)\"\n          [dropSpecialCharacters]=\"$any(maskConfig.dropSpecialCharacters)\"\n          [hiddenInput]=\"$any(maskConfig.hiddenInput)\"\n          [validation]=\"$any(maskConfig.validation)\"\n          [separatorLimit]=\"$any(maskConfig.separatorLimit)\"\n          [apm]=\"$any(maskConfig.apm)\"\n          [allowNegativeNumbers]=\"$any(maskConfig.allowNegativeNumbers)\"\n          [leadZeroDateTime]=\"$any(maskConfig.leadZeroDateTime)\"\n          [leadZero]=\"$any(maskConfig.leadZero)\"\n          [triggerOnMaskChange]=\"$any(maskConfig.triggerOnMaskChange)\"\n          [keepCharacterPositions]=\"$any(maskConfig.keepCharacterPositions)\"\n          [inputTransformFn]=\"$any(maskConfig.inputTransformFn)\"\n          [outputTransformFn]=\"$any(maskConfig.outputTransformFn)\"\n          (maskFilled)=\"maskConfig.maskFilled?.emit($event)\"\n          [patterns]=\"$any(maskConfig.patterns)\"\n        />\n      </ng-container>\n      <ng-template #defaultInput>\n        <input\n          fswInput\n          [type]=\"context.inputType\"\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputMin]=\"forceNumberContext.min || null\"\n          [fswInputMax]=\"forceNumberContext.max || null\"\n        />\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.inputType === 'area'\">\n      <ng-container *ngIf=\"!!forceTextContext?.mask; else defaultArea\">\n        <textarea\n          fswInput\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [class]=\"element?.customClasses\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [rows]=\"forceAreaContext.rows || 4\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputPattern]=\"context.pattern || null\"\n          [mask]=\"$any(forceTextContext.mask?.expression)\"\n          [suffix]=\"$any(maskConfig.suffix)\"\n          [prefix]=\"$any(maskConfig.prefix)\"\n          [thousandSeparator]=\"$any(maskConfig.thousandSeparator)\"\n          [decimalMarker]=\"$any(maskConfig.decimalMarker)\"\n          [clearIfNotMatch]=\"$any(maskConfig.clearIfNotMatch)\"\n          [showTemplate]=\"$any(maskConfig.showTemplate)\"\n          [showMaskTyped]=\"$any(maskConfig.showMaskTyped)\"\n          [placeHolderCharacter]=\"$any(maskConfig.placeHolderCharacter)\"\n          [shownMaskExpression]=\"$any(maskConfig.shownMaskExpression)\"\n          [specialCharacters]=\"$any(maskConfig.specialCharacters)\"\n          [dropSpecialCharacters]=\"$any(maskConfig.dropSpecialCharacters)\"\n          [hiddenInput]=\"$any(maskConfig.hiddenInput)\"\n          [validation]=\"$any(maskConfig.validation)\"\n          [separatorLimit]=\"$any(maskConfig.separatorLimit)\"\n          [apm]=\"$any(maskConfig.apm)\"\n          [allowNegativeNumbers]=\"$any(maskConfig.allowNegativeNumbers)\"\n          [leadZeroDateTime]=\"$any(maskConfig.leadZeroDateTime)\"\n          [leadZero]=\"$any(maskConfig.leadZero)\"\n          [triggerOnMaskChange]=\"$any(maskConfig.triggerOnMaskChange)\"\n          [keepCharacterPositions]=\"$any(maskConfig.keepCharacterPositions)\"\n          [inputTransformFn]=\"$any(maskConfig.inputTransformFn)\"\n          [outputTransformFn]=\"$any(maskConfig.outputTransformFn)\"\n          (maskFilled)=\"maskConfig.maskFilled?.emit($event)\"\n          [patterns]=\"$any(maskConfig.patterns)\"\n        ></textarea>\n      </ng-container>\n      <ng-template #defaultArea>\n        <textarea\n          fswInput\n          [placeholder]=\"context.placeHolder || ''\"\n          [id]=\"element?.id\"\n          [name]=\"element?.name\"\n          [class]=\"element?.customClasses\"\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [readOnly]=\"!!context.isReadonly\"\n          [rows]=\"forceAreaContext.rows || 4\"\n          [fswInputMinLength]=\"context.minLength || null\"\n          [fswInputMaxLength]=\"context.maxLength || null\"\n          [fswInputPattern]=\"context.pattern || null\"\n        ></textarea>\n      </ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.suffix | fswDynamicBuilderTemplate as ref; else defaultSuffix\">\n      <ng-template fswFieldInputSuffix>\n        <ng-container\n          *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.suffix }\"\n        ></ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-template #defaultSuffix>\n      <ng-container *ngIf=\"context.suffix\">\n        <ng-template fswFieldInputSuffix>{{ context.suffix }}</ng-template>\n      </ng-container>\n    </ng-template>\n    <ng-container *ngIf=\"context.showCount\">\n      <ng-template fswFieldFooterSuffix [kind]=\"'counter'\"></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderRadioGroupComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWRadioSizes = FSWRadioSizes;
        this.FSWRadioStyles = FSWRadioStyles;
        this.FSWRadioDirections = FSWRadioDirections;
        this.FSWFieldSizes = FSWFieldSizes;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    getRenderTemplateOfItem(item) {
        return (item.renderTemplate || {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderRadioGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderRadioGroupComponent, selector: "fsw-dynamic-builder-radio-group", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-radio-group\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [direction]=\"context.direction || FSWRadioDirections.COLUMN\"\n      [gap]=\"context.gap || '20px'\"\n    >\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <fsw-radio\n            [class]=\"element?.customClasses\"\n            [label]=\"getRenderTemplateOfItem(item).label || null\"\n            [description]=\"getRenderTemplateOfItem(item).description || null\"\n            [size]=\"getRenderTemplateOfItem(item).size || FSWRadioSizes.M\"\n            [renderStyle]=\"getRenderTemplateOfItem(item).renderStyle || FSWRadioStyles.BLOCK\"\n            [showCheckedIcon]=\"!!getRenderTemplateOfItem(item).showCheckedIcon\"\n            [value]=\"item.value\"\n            [hasError]=\"\n              !!context.showError && control.invalid && (control.dirty || control.touched)\n            \"\n            [disabled]=\"!!control.disabled\"\n            [readOnly]=\"(forceReadonly$ | async) || false\"\n          ></fsw-radio>\n        </ng-container>\n      </ng-container>\n    </fsw-radio-group>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "component", type: FSWRadioComponent, selector: "fsw-radio" }, { kind: "component", type: FSWRadioGroupComponent, selector: "fsw-radio-group" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-radio-group', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-radio-group\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [direction]=\"context.direction || FSWRadioDirections.COLUMN\"\n      [gap]=\"context.gap || '20px'\"\n    >\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <fsw-radio\n            [class]=\"element?.customClasses\"\n            [label]=\"getRenderTemplateOfItem(item).label || null\"\n            [description]=\"getRenderTemplateOfItem(item).description || null\"\n            [size]=\"getRenderTemplateOfItem(item).size || FSWRadioSizes.M\"\n            [renderStyle]=\"getRenderTemplateOfItem(item).renderStyle || FSWRadioStyles.BLOCK\"\n            [showCheckedIcon]=\"!!getRenderTemplateOfItem(item).showCheckedIcon\"\n            [value]=\"item.value\"\n            [hasError]=\"\n              !!context.showError && control.invalid && (control.dirty || control.touched)\n            \"\n            [disabled]=\"!!control.disabled\"\n            [readOnly]=\"(forceReadonly$ | async) || false\"\n          ></fsw-radio>\n        </ng-container>\n      </ng-container>\n    </fsw-radio-group>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderSelectComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWFieldSizes = FSWFieldSizes;
        this.FSWSelectItemKind = FSWSelectItemKind;
        this.FSWSelectItemTextSize = FSWSelectItemTextSize;
        this.FSWSelectItemIcon = FSWSelectItemIcon;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get closeOnSelected() {
        return this.context.closeOnSelected != null ? this.context.closeOnSelected : true;
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderSelectComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderSelectComponent, selector: "fsw-dynamic-builder-select", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-select\n      [formControl]=\"control\"\n      [hasError]=\"control | fswHasError\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [closeOnSelected]=\"closeOnSelected\"\n      [placeHolder]=\"context.placeHolder || ''\"\n      [isMultiple]=\"!!context.isMultiple\"\n      [renderTemplate]=\"context.renderTemplate || null\"\n      [maxHeight]=\"context.maxHeight || 'auto'\"\n      [searchPlaceHolder]=\"context.searchPlaceHolder || ''\"\n      [containerClasses]=\"context.containerClasses || ''\"\n      [itemClasses]=\"context.itemClasses || ''\"\n      [allowedClear]=\"context.allowedClear || true\"\n    >\n      <ng-container *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\">\n        <ng-template fswSelectPrefix>\n          <ng-container\n            *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n          ></ng-container>\n        </ng-template>\n      </ng-container>\n      <ng-template #defaultPrefix>\n        <ng-container *ngIf=\"context.prefix\">\n          <ng-template fswSelectPrefix>{{ context.prefix }}</ng-template>\n        </ng-container>\n      </ng-template>\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <ng-template\n            fswSelectItem\n            let-selected\n            [kind]=\"item.kind || FSWSelectItemKind.DEFAULT\"\n            [text]=\"item.text || ''\"\n            [isDisabled]=\"!!item.isDisabled\"\n            [textSize]=\"item.textSize || FSWSelectItemTextSize.M\"\n            [showCheckIcon]=\"!!item.showCheckIcon\"\n            [value]=\"item.value\"\n            [icon]=\"item.icon || FSWSelectItemIcon.NONE\"\n          >\n            <ng-container *ngIf=\"item.templateRef\">\n              <ng-container\n                *ngTemplateOutlet=\"item.templateRef; context: { $implicit: selected }\"\n              ></ng-container>\n            </ng-container>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n    </fsw-select>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "component", type: FSWSelectComponent, selector: "fsw-select" }, { kind: "directive", type: FSWSelectPrefixDirective, selector: "ng-template[fswSelectPrefix]" }, { kind: "directive", type: FSWSelectItemDirective, selector: "ng-template[fswSelectItem]", inputs: ["kind", "text", "isDisabled", "textSize", "showCheckIcon", "icon", "value"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWHasErrorPipe, name: "fswHasError" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-select', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-select\n      [formControl]=\"control\"\n      [hasError]=\"control | fswHasError\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n      [closeOnSelected]=\"closeOnSelected\"\n      [placeHolder]=\"context.placeHolder || ''\"\n      [isMultiple]=\"!!context.isMultiple\"\n      [renderTemplate]=\"context.renderTemplate || null\"\n      [maxHeight]=\"context.maxHeight || 'auto'\"\n      [searchPlaceHolder]=\"context.searchPlaceHolder || ''\"\n      [containerClasses]=\"context.containerClasses || ''\"\n      [itemClasses]=\"context.itemClasses || ''\"\n      [allowedClear]=\"context.allowedClear || true\"\n    >\n      <ng-container *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\">\n        <ng-template fswSelectPrefix>\n          <ng-container\n            *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n          ></ng-container>\n        </ng-template>\n      </ng-container>\n      <ng-template #defaultPrefix>\n        <ng-container *ngIf=\"context.prefix\">\n          <ng-template fswSelectPrefix>{{ context.prefix }}</ng-template>\n        </ng-container>\n      </ng-template>\n      <ng-container *ngIf=\"context.items || context.loadItemsAsync\">\n        <ng-container\n          *ngFor=\"\n            let item of context.loadItemsAsync\n              ? (context.loadItemsAsync(control.parent) | async) || []\n              : context.items || [];\n            let i = index\n          \"\n        >\n          <ng-template\n            fswSelectItem\n            let-selected\n            [kind]=\"item.kind || FSWSelectItemKind.DEFAULT\"\n            [text]=\"item.text || ''\"\n            [isDisabled]=\"!!item.isDisabled\"\n            [textSize]=\"item.textSize || FSWSelectItemTextSize.M\"\n            [showCheckIcon]=\"!!item.showCheckIcon\"\n            [value]=\"item.value\"\n            [icon]=\"item.icon || FSWSelectItemIcon.NONE\"\n          >\n            <ng-container *ngIf=\"item.templateRef\">\n              <ng-container\n                *ngTemplateOutlet=\"item.templateRef; context: { $implicit: selected }\"\n              ></ng-container>\n            </ng-container>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n    </fsw-select>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderSwitchComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWSwitchSizes = FSWSwitchSizes;
        this.FSWFieldSizes = FSWFieldSizes;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get renderTemplate() {
        return this.context.renderTemplate || {};
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderSwitchComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderSwitchComponent, selector: "fsw-dynamic-builder-switch", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-switch\n      [class]=\"element?.customClasses\"\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [label]=\"renderTemplate.label || null\"\n      [size]=\"renderTemplate.size || FSWSwitchSizes.M\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n    ></fsw-switch>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "component", type: FSWSwitchComponent, selector: "fsw-switch" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-switch', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <fsw-switch\n      [class]=\"element?.customClasses\"\n      [formControl]=\"control\"\n      [hasError]=\"!!context.showError && control.invalid && (control.dirty || control.touched)\"\n      [label]=\"renderTemplate.label || null\"\n      [size]=\"renderTemplate.size || FSWSwitchSizes.M\"\n      [readOnly]=\"(forceReadonly$ | async) || false\"\n    ></fsw-switch>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderTemplateComponent extends FSWDynamicBuilderControlBase {
    get context() {
        return (this.config?.context || {});
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplateComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTemplateComponent, selector: "fsw-dynamic-builder-template", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <ng-container *ngIf=\"context.templateKey | fswDynamicBuilderTemplate as ref\">\n    <ng-container\n      *ngTemplateOutlet=\"\n        ref.templateRef;\n        context: {\n          config,\n          control,\n          element,\n          index,\n          dictionaries,\n          isLoading$,\n          isReadonly$: forceReadonly$\n        }\n      \"\n    ></ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-template', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <ng-container *ngIf=\"context.templateKey | fswDynamicBuilderTemplate as ref\">\n    <ng-container\n      *ngTemplateOutlet=\"\n        ref.templateRef;\n        context: {\n          config,\n          control,\n          element,\n          index,\n          dictionaries,\n          isLoading$,\n          isReadonly$: forceReadonly$\n        }\n      \"\n    ></ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderDateTimePickerComponent extends FSWDynamicBuilderControlBase {
    constructor() {
        super(...arguments);
        this.FSWFieldSizes = FSWFieldSizes;
    }
    get context() {
        return (this.config?.context || {});
    }
    get readonlyTemplateType() {
        return this.context.readonlyTemplate ? typeof this.context.readonlyTemplate : null;
    }
    get forceDateContext() {
        return (this.config?.context || {});
    }
    get closeOnSelected() {
        return this.context.closeOnSelected != null ? this.context.closeOnSelected : false;
    }
    get forceReadonly$() {
        if (Object.prototype.hasOwnProperty.call(this.context, 'isReadonly')) {
            return of(!!this.context.isReadonly);
        }
        return this.isReadonly$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderDateTimePickerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderDateTimePickerComponent, selector: "fsw-dynamic-builder-date-time-picker", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-container [ngSwitch]=\"context.dateTimePickerType\">\n      <ng-container *ngSwitchDefault>\n        <fsw-date-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [dayLabels]=\"forceDateContext.dayLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-date-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'month'\">\n        <fsw-month-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-month-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'year'\">\n        <fsw-year-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-year-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'time'\">\n        <fsw-time-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-time-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'range'\">\n        <fsw-range-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [dayLabels]=\"forceDateContext.dayLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-range-picker>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: FSWFieldComponent, selector: "fsw-field" }, { kind: "directive", type: FSWFieldFooterPrefixDirective, selector: "ng-template[fswFieldFooterPrefix]", inputs: ["kind", "helperText"] }, { kind: "directive", type: FSWFieldHeaderPrefixDirective, selector: "ng-template[fswFieldHeaderPrefix]", inputs: ["kind", "label", "required"] }, { kind: "directive", type: FSWFieldReadonlyDirective, selector: "ng-template[fswFieldReadonly]" }, { kind: "directive", type: FSWDateTimePickerPrefixDirective, selector: "ng-template[fswDateTimePickerPrefix]" }, { kind: "component", type: FSWTimePickerComponent, selector: "fsw-time-picker" }, { kind: "component", type: FSWYearPickerComponent, selector: "fsw-year-picker" }, { kind: "component", type: FSWDatePickerComponent, selector: "fsw-date-picker" }, { kind: "component", type: FSWMonthPickerComponent, selector: "fsw-month-picker" }, { kind: "component", type: FSWRangePickerComponent, selector: "fsw-range-picker" }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWHasErrorPipe, name: "fswHasError" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderDateTimePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-date-time-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <fsw-field\n    [showError]=\"!!context.showError && control.invalid\"\n    [errorText]=\"context.errorText || null\"\n    [disabled]=\"!!control.disabled\"\n    [readOnly]=\"(forceReadonly$ | async) || false\"\n    [size]=\"context.size || FSWFieldSizes.M\"\n    [fullWidth]=\"!!context.fullWidth\"\n    [flexWidth]=\"!!context.flexWidth\"\n  >\n    <ng-container *ngIf=\"context.label\">\n      <ng-template\n        fswFieldHeaderPrefix\n        [label]=\"context.label\"\n        [required]=\"context.isRequired\"\n      ></ng-template>\n    </ng-container>\n    <ng-container *ngIf=\"readonlyTemplateType\">\n      <ng-template fswFieldReadonly>\n        <ng-container [ngSwitch]=\"readonlyTemplateType\">\n          <ng-container *ngSwitchCase=\"'string'\">\n            <ng-container *ngIf=\"$any(context.readonlyTemplate) | fswDynamicBuilderTemplate as ref\">\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: control.value }\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n          <ng-container *ngSwitchDefault>\n            {{ $any(context.readonlyTemplate)(control.value) }}\n          </ng-container>\n        </ng-container>\n      </ng-template>\n    </ng-container>\n    <ng-container [ngSwitch]=\"context.dateTimePickerType\">\n      <ng-container *ngSwitchDefault>\n        <fsw-date-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [dayLabels]=\"forceDateContext.dayLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-date-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'month'\">\n        <fsw-month-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-month-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'year'\">\n        <fsw-year-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-year-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'time'\">\n        <fsw-time-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-time-picker>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"'range'\">\n        <fsw-range-picker\n          [formControl]=\"control\"\n          [hasError]=\"control | fswHasError\"\n          [placeHolder]=\"context.placeHolder || ''\"\n          [min]=\"context.min || null\"\n          [max]=\"context.max || null\"\n          [isReadonly]=\"!!context.isReadonly\"\n          [isDisabled]=\"!!control.disabled\"\n          [locale]=\"context.locale\"\n          [format]=\"context.format\"\n          [years]=\"forceDateContext.years || null\"\n          [monthLabels]=\"forceDateContext.monthLabels || null\"\n          [dayLabels]=\"forceDateContext.dayLabels || null\"\n          [closeOnSelected]=\"closeOnSelected\"\n        >\n          <ng-container\n            *ngIf=\"context.prefix | fswDynamicBuilderTemplate as ref; else defaultPrefix\"\n          >\n            <ng-template fswDateTimePickerPrefix>\n              <ng-container\n                *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: context.prefix }\"\n              ></ng-container>\n            </ng-template>\n          </ng-container>\n          <ng-template #defaultPrefix>\n            <ng-container *ngIf=\"context.prefix\">\n              <ng-template fswDateTimePickerPrefix>{{ context.prefix }}</ng-template>\n            </ng-container>\n          </ng-template>\n        </fsw-range-picker>\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"context.helperText\">\n      <ng-template fswFieldFooterPrefix [helperText]=\"context.helperText || null\"></ng-template>\n    </ng-container>\n  </fsw-field>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderItemDirective {
    constructor(_service, _viewContainerRef, _builderComponent) {
        this._service = _service;
        this._viewContainerRef = _viewContainerRef;
        this._builderComponent = _builderComponent;
        this.item = null;
        this.dictionaries = null;
        this.index = null;
        this.parent = null;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        if (!this.item) {
            return;
        }
        const component = this._service.query(this.item, this.dictionaries);
        if (!component) {
            const template = this._service.getTemplate(this.item.name || '', this._builderComponent.groupId);
            if (template) {
                this._renderTemplate(template);
            }
            return;
        }
        this._renderComponent(component);
    }
    getControl() {
        if (!this.parent) {
            throw new Error('This component need to be inside ControlContainer');
        }
        if (this.parent instanceof UntypedFormArray) {
            return this.index != null ? this.parent.controls[this.index] : null;
        }
        else if (this.parent instanceof UntypedFormGroup) {
            return this.parent.get(this.item.key);
        }
        return null;
    }
    _renderComponent(component) {
        const ref = this._viewContainerRef.createComponent(component);
        const instance = ref.instance;
        instance.dictionaries = this.dictionaries;
        instance.index = this.index;
        assignData(instance, this.item);
        const control = this.getControl();
        assignControl(instance, this.item, control);
        ref.changeDetectorRef.detectChanges();
    }
    _renderTemplate(template) {
        const context = {
            dictionaries: this.dictionaries,
            index: this.index,
            parent: this.parent,
        };
        assignData(context, this.item);
        this._viewContainerRef.createEmbeddedView(template.templateRef, context);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderItemDirective, deps: [{ token: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN }, { token: i0.ViewContainerRef }, { token: FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderItemDirective, selector: "[fswDynamicBuilderItem]", inputs: { item: ["fswDynamicBuilderItem", "item"], dictionaries: "dictionaries", index: "index", parent: "parent" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDynamicBuilderItem]',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_SERVICE_TOKEN]
                }] }, { type: i0.ViewContainerRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN]
                }] }]; }, propDecorators: { item: [{
                type: Input,
                args: ['fswDynamicBuilderItem']
            }], dictionaries: [{
                type: Input
            }], index: [{
                type: Input
            }], parent: [{
                type: Input
            }] } });

class FSWDynamicBuilderContainerDirective {
    constructor(_service, _viewContainerRef, _parent, _builderComponent) {
        this._service = _service;
        this._viewContainerRef = _viewContainerRef;
        this._parent = _parent;
        this._builderComponent = _builderComponent;
        this.container = null;
        this.index = null;
        this.dictionaries = null;
    }
    ngOnChanges() {
        this._viewContainerRef.clear();
        if (!this.container) {
            return;
        }
        const component = this._service.queryContainer(this.container.name || FSWDynamicBuilderDefaultNames.CONTAINER, this.dictionaries);
        if (!component) {
            const template = this._service.getTemplate(this.container.name || '', this._builderComponent.groupId);
            if (template) {
                this._renderTemplate(template);
            }
            return;
        }
        this._renderComponent(component);
    }
    _renderTemplate(template) {
        const context = {
            dictionaries: this.dictionaries,
            parent: this._parent,
            index: this.index,
        };
        assignData(context, this.container);
        this._viewContainerRef.createEmbeddedView(template.templateRef, context);
    }
    _renderComponent(component) {
        const ref = this._viewContainerRef.createComponent(component);
        const instance = ref.instance;
        instance.dictionaries = this.dictionaries;
        instance.index = this.index;
        assignData(instance, this.container);
        ref.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerDirective, deps: [{ token: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN }, { token: i0.ViewContainerRef }, { token: i2$1.ControlContainer }, { token: FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderContainerDirective, selector: "[fswDynamicBuilderContainer]", inputs: { container: ["fswDynamicBuilderContainer", "container"], index: "index", dictionaries: "dictionaries" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDynamicBuilderContainer]',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_SERVICE_TOKEN]
                }] }, { type: i0.ViewContainerRef }, { type: i2$1.ControlContainer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN]
                }] }]; }, propDecorators: { container: [{
                type: Input,
                args: ['fswDynamicBuilderContainer']
            }], index: [{
                type: Input
            }], dictionaries: [{
                type: Input
            }] } });

class FSWDynamicBuilderArrayComponent extends FSWDynamicBuilderArrayBase {
    get renderBy() {
        return this.config?.renderBy || 'default';
    }
    get defaultConfig() {
        return this.config;
    }
    get containerConfig() {
        return this.config;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderArrayComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderArrayComponent, selector: "fsw-dynamic-builder-array", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <section [class]=\"element?.customClasses || 'fsw-dynamic-builder-array'\">\n    <ng-container [ngSwitch]=\"renderBy\">\n      <ng-container *ngSwitchCase=\"'container'\">\n        <ng-container *ngFor=\"let group of control.controls\">\n          <form [formGroup]=\"group | fswForceGroup\">\n            <ng-container *ngIf=\"containerConfig.containers as containers\">\n              <ng-container *ngFor=\"let container of containers; let i = index\">\n                <ng-container\n                  [fswDynamicBuilderContainer]=\"container\"\n                  [index]=\"i\"\n                  [dictionaries]=\"dictionaries\"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </form>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <ng-container *ngFor=\"let item of control.controls; let i = index\">\n          <ng-container *ngIf=\"defaultConfig.item as item\">\n            <ng-container\n              [fswDynamicBuilderItem]=\"item\"\n              [parent]=\"control\"\n              [index]=\"i\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </section>\n</ng-container>\n", styles: [":host{display:contents}:host form{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: FSWDynamicBuilderItemDirective, selector: "[fswDynamicBuilderItem]", inputs: ["fswDynamicBuilderItem", "dictionaries", "index", "parent"] }, { kind: "directive", type: FSWDynamicBuilderContainerDirective, selector: "[fswDynamicBuilderContainer]", inputs: ["fswDynamicBuilderContainer", "index", "dictionaries"] }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderArrayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-array', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <section [class]=\"element?.customClasses || 'fsw-dynamic-builder-array'\">\n    <ng-container [ngSwitch]=\"renderBy\">\n      <ng-container *ngSwitchCase=\"'container'\">\n        <ng-container *ngFor=\"let group of control.controls\">\n          <form [formGroup]=\"group | fswForceGroup\">\n            <ng-container *ngIf=\"containerConfig.containers as containers\">\n              <ng-container *ngFor=\"let container of containers; let i = index\">\n                <ng-container\n                  [fswDynamicBuilderContainer]=\"container\"\n                  [index]=\"i\"\n                  [dictionaries]=\"dictionaries\"\n                ></ng-container>\n              </ng-container>\n            </ng-container>\n          </form>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <ng-container *ngFor=\"let item of control.controls; let i = index\">\n          <ng-container *ngIf=\"defaultConfig.item as item\">\n            <ng-container\n              [fswDynamicBuilderItem]=\"item\"\n              [parent]=\"control\"\n              [index]=\"i\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </section>\n</ng-container>\n", styles: [":host{display:contents}:host form{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderGroupComponent extends FSWDynamicBuilderGroupBase {
    get renderBy() {
        return this.config?.renderBy || 'default';
    }
    get defaultConfig() {
        return this.config;
    }
    get containerConfig() {
        return this.config;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderGroupComponent, selector: "fsw-dynamic-builder-group", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <section [class]=\"element?.customClasses || 'fsw-dynamic-builder-group'\">\n    <form [formGroup]=\"control\">\n      <ng-container [ngSwitch]=\"renderBy\">\n        <ng-container *ngSwitchCase=\"'container'\">\n          <ng-container *ngIf=\"containerConfig.containers as containers\">\n            <ng-container *ngFor=\"let container of containers; let i = index\">\n              <ng-container\n                [fswDynamicBuilderContainer]=\"container\"\n                [index]=\"index\"\n                [dictionaries]=\"dictionaries\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <ng-container *ngIf=\"defaultConfig.fields as fields\">\n            <ng-container *ngFor=\"let field of fields; let i = index\">\n              <ng-container\n                [fswDynamicBuilderItem]=\"field\"\n                [index]=\"index\"\n                [parent]=\"control\"\n                [dictionaries]=\"dictionaries\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </form>\n  </section>\n</ng-container>\n", styles: [":host{display:contents}:host form{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: FSWDynamicBuilderItemDirective, selector: "[fswDynamicBuilderItem]", inputs: ["fswDynamicBuilderItem", "dictionaries", "index", "parent"] }, { kind: "directive", type: FSWDynamicBuilderContainerDirective, selector: "[fswDynamicBuilderContainer]", inputs: ["fswDynamicBuilderContainer", "index", "dictionaries"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-group', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <section [class]=\"element?.customClasses || 'fsw-dynamic-builder-group'\">\n    <form [formGroup]=\"control\">\n      <ng-container [ngSwitch]=\"renderBy\">\n        <ng-container *ngSwitchCase=\"'container'\">\n          <ng-container *ngIf=\"containerConfig.containers as containers\">\n            <ng-container *ngFor=\"let container of containers; let i = index\">\n              <ng-container\n                [fswDynamicBuilderContainer]=\"container\"\n                [index]=\"index\"\n                [dictionaries]=\"dictionaries\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngSwitchDefault>\n          <ng-container *ngIf=\"defaultConfig.fields as fields\">\n            <ng-container *ngFor=\"let field of fields; let i = index\">\n              <ng-container\n                [fswDynamicBuilderItem]=\"field\"\n                [index]=\"index\"\n                [parent]=\"control\"\n                [dictionaries]=\"dictionaries\"\n              ></ng-container>\n            </ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </form>\n  </section>\n</ng-container>\n", styles: [":host{display:contents}:host form{display:contents}\n"] }]
        }] });

let FSWDynamicBuilderControlDirective = class FSWDynamicBuilderControlDirective extends FSWDynamicBuilderControlBase {
    constructor(_parent, _viewContainerRef) {
        super();
        this._parent = _parent;
        this._viewContainerRef = _viewContainerRef;
        this.map = {
            [FSWDynamicBuilderControlTypes.CHECKBOX]: FSWDynamicBuilderCheckboxComponent,
            [FSWDynamicBuilderControlTypes.CHECKBOX_GROUP]: FSWDynamicBuilderCheckboxGroupComponent,
            [FSWDynamicBuilderControlTypes.INPUT]: FSWDynamicBuilderInputComponent,
            [FSWDynamicBuilderControlTypes.RADIO_GROUP]: FSWDynamicBuilderRadioGroupComponent,
            [FSWDynamicBuilderControlTypes.SELECT]: FSWDynamicBuilderSelectComponent,
            [FSWDynamicBuilderControlTypes.SWITCH]: FSWDynamicBuilderSwitchComponent,
            [FSWDynamicBuilderControlTypes.DATE_TIME_PICKER]: FSWDynamicBuilderDateTimePickerComponent,
            [FSWDynamicBuilderControlTypes.TEMPLATE]: FSWDynamicBuilderTemplateComponent,
        };
    }
    ngOnChanges() {
        this._render();
    }
    ngAfterViewInit() {
        this._render();
    }
    _render() {
        this._clear();
        if (!this.config) {
            return;
        }
        if (this.config.context?.isHidden) {
            return;
        }
        const component = this.map[this.config.type];
        if (!component) {
            return;
        }
        const customRender = this.config.context?.customRender;
        if (customRender?.length && this._parent.control instanceof UntypedFormGroup) {
            this._resolveCustomRender(customRender, component);
            return;
        }
        this._renderComponent(component);
    }
    _resolveCustomRender(customRender, component) {
        const formGroup = this._parent.control;
        const streams = customRender.map(({ fields, checkingConditionCallback }) => {
            const controls = fields.filter((field) => !!getControlFromGroup(formGroup, field.key) ||
                !!getDynamicBuilderHiddenControls(formGroup)[field.key]);
            return combineLatest(controls.map(({ key, correctWhenValueIs }) => {
                const control = getControlFromGroup(formGroup, key) || getDynamicBuilderHiddenControls(formGroup)[key];
                return control.valueChanges
                    .pipe(startWith(control.value), distinctUntilChanged())
                    .pipe(map((value) => correctWhenValueIs(value, this.config)));
            })).pipe(map((conditions) => conditions.every((condition) => condition)), tap((finalCondition) => {
                checkingConditionCallback({
                    formGroup,
                    clearView: () => this._clear(true),
                    renderView: () => this._renderComponent(component, true),
                    controlConfig: this.config,
                }, finalCondition);
            }));
        });
        merge(...streams)
            .pipe(followDestroy(this))
            .subscribe();
    }
    _clear(clearControl = false) {
        this._viewContainerRef.clear();
        if (clearControl && this.control) {
            const key = getDynamicBuilderAbsoluteKey(this.control).split('.').pop();
            this.control.setParent(null);
            this._parent.control.removeControl(key, { emitEvent: false });
        }
    }
    _renderComponent(component, assignControl = false) {
        this._clear(assignControl);
        if (assignControl && this.control) {
            const key = getDynamicBuilderAbsoluteKey(this.control).split('.').pop();
            this.control.setParent(this._parent.control);
            this._parent.control.addControl(key, this.control, {
                emitEvent: false,
            });
            getDynamicBuilderReadonly(this.control).next(getDynamicBuilderReadonly(this._parent.control).value);
        }
        const ref = this._viewContainerRef.createComponent(component);
        const instance = ref.instance;
        instance.control = this.control;
        instance.config = this.config;
        instance.index = this.index;
        instance.dictionaries = this.dictionaries;
        instance.element = this.element;
        ref.changeDetectorRef.detectChanges();
        if (this.config?.context?.afterCreated && this.control) {
            this.config.context.afterCreated(this.control, this._parent.control);
        }
        return ref;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlDirective, deps: [{ token: i2$1.ControlContainer }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderControlDirective, selector: "[fswDynamicBuilderControl]", inputs: { map: "map" }, usesInheritance: true, usesOnChanges: true, ngImport: i0 }); }
};
FSWDynamicBuilderControlDirective = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [ControlContainer,
        ViewContainerRef])
], FSWDynamicBuilderControlDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDynamicBuilderControl]',
                }]
        }], ctorParameters: function () { return [{ type: i2$1.ControlContainer }, { type: i0.ViewContainerRef }]; }, propDecorators: { map: [{
                type: Input
            }] } });

class FSWDynamicBuilderControlComponent extends FSWDynamicBuilderControlBase {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderControlComponent, selector: "fsw-dynamic-builder-control", host: { properties: { "id": "element?.id", "class": "element?.customClasses" } }, usesInheritance: true, ngImport: i0, template: "<ng-container\n  fswDynamicBuilderControl\n  [element]=\"element\"\n  [config]=\"config\"\n  [index]=\"index\"\n  [control]=\"control\"\n  [dictionaries]=\"dictionaries\"\n></ng-container>\n", dependencies: [{ kind: "directive", type: FSWDynamicBuilderControlDirective, selector: "[fswDynamicBuilderControl]", inputs: ["map"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-control', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[id]': 'element?.id',
                        '[class]': 'element?.customClasses',
                    }, template: "<ng-container\n  fswDynamicBuilderControl\n  [element]=\"element\"\n  [config]=\"config\"\n  [index]=\"index\"\n  [control]=\"control\"\n  [dictionaries]=\"dictionaries\"\n></ng-container>\n" }]
        }] });

class FSWDynamicBuilderContainerComponent extends FSWDynamicBuilderContainerBase {
    constructor(parent) {
        super();
        this.parent = parent;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerComponent, deps: [{ token: i2$1.ControlContainer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderContainerComponent, selector: "fsw-dynamic-builder-container", usesInheritance: true, ngImport: i0, template: "<section [class]=\"element?.customClasses || 'fsw-dynamic-builder-container'\">\n  <ng-container *ngIf=\"config?.fields as fields\">\n    <ng-container *ngFor=\"let field of fields; let i = index\">\n      <ng-container\n        [fswDynamicBuilderItem]=\"field\"\n        [index]=\"index\"\n        [parent]=\"parent.control\"\n        [dictionaries]=\"dictionaries\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"config?.containers as containers\">\n    <ng-container *ngFor=\"let container of containers; let i = index\">\n      <ng-container\n        [fswDynamicBuilderContainer]=\"container\"\n        [index]=\"index\"\n        [dictionaries]=\"dictionaries\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n</section>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: FSWDynamicBuilderItemDirective, selector: "[fswDynamicBuilderItem]", inputs: ["fswDynamicBuilderItem", "dictionaries", "index", "parent"] }, { kind: "directive", type: FSWDynamicBuilderContainerDirective, selector: "[fswDynamicBuilderContainer]", inputs: ["fswDynamicBuilderContainer", "index", "dictionaries"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<section [class]=\"element?.customClasses || 'fsw-dynamic-builder-container'\">\n  <ng-container *ngIf=\"config?.fields as fields\">\n    <ng-container *ngFor=\"let field of fields; let i = index\">\n      <ng-container\n        [fswDynamicBuilderItem]=\"field\"\n        [index]=\"index\"\n        [parent]=\"parent.control\"\n        [dictionaries]=\"dictionaries\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"config?.containers as containers\">\n    <ng-container *ngFor=\"let container of containers; let i = index\">\n      <ng-container\n        [fswDynamicBuilderContainer]=\"container\"\n        [index]=\"index\"\n        [dictionaries]=\"dictionaries\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n</section>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$1.ControlContainer }]; } });

class FSWDynamicBuilderTableColumnComponent {
    get label() {
        return this.config?.label || null;
    }
    get template() {
        return this.config?.template || null;
    }
    get columnType() {
        return this.config?.columnType || 'default';
    }
    get renderBy() {
        return this.config?.renderBy || 'default';
    }
    get defaultConfig() {
        return this.config;
    }
    get containerConfig() {
        return this.config;
    }
    constructor(parent) {
        this.parent = parent;
        this.config = null;
        this.dictionaries = null;
        this.rowIndex = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableColumnComponent, deps: [{ token: i2$1.ControlContainer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableColumnComponent, selector: "fsw-dynamic-builder-table-column", inputs: { config: "config", dictionaries: "dictionaries", rowIndex: "rowIndex" }, ngImport: i0, template: "<ng-container [ngSwitch]=\"columnType\">\n  <ng-container *ngSwitchCase=\"'control'\">\n    <ng-container [ngSwitch]=\"renderBy\">\n      <ng-container *ngSwitchCase=\"'container'\">\n        <ng-container *ngIf=\"containerConfig.containers as containers\">\n          <ng-container *ngFor=\"let container of containers; let i = index\">\n            <ng-container\n              [fswDynamicBuilderContainer]=\"container\"\n              [index]=\"rowIndex\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <ng-container *ngIf=\"defaultConfig.fields as fields\">\n          <ng-container *ngFor=\"let field of fields; let i = index\">\n            <ng-container\n              [fswDynamicBuilderItem]=\"field\"\n              [index]=\"rowIndex\"\n              [parent]=\"parent.control\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"'template'\">\n    <ng-container *ngIf=\"$any(template) | fswDynamicBuilderTemplate as ref\">\n      <ng-container\n        *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: config, index: rowIndex }\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchDefault>\n    <span [id]=\"config?.id\"\n      >{{ label }}\n      <strong *ngIf=\"config?.requireClasses\" [ngClass]=\"config?.requireClasses\">*</strong></span\n    >\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: FSWDynamicBuilderItemDirective, selector: "[fswDynamicBuilderItem]", inputs: ["fswDynamicBuilderItem", "dictionaries", "index", "parent"] }, { kind: "directive", type: FSWDynamicBuilderContainerDirective, selector: "[fswDynamicBuilderContainer]", inputs: ["fswDynamicBuilderContainer", "index", "dictionaries"] }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-column', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container [ngSwitch]=\"columnType\">\n  <ng-container *ngSwitchCase=\"'control'\">\n    <ng-container [ngSwitch]=\"renderBy\">\n      <ng-container *ngSwitchCase=\"'container'\">\n        <ng-container *ngIf=\"containerConfig.containers as containers\">\n          <ng-container *ngFor=\"let container of containers; let i = index\">\n            <ng-container\n              [fswDynamicBuilderContainer]=\"container\"\n              [index]=\"rowIndex\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngSwitchDefault>\n        <ng-container *ngIf=\"defaultConfig.fields as fields\">\n          <ng-container *ngFor=\"let field of fields; let i = index\">\n            <ng-container\n              [fswDynamicBuilderItem]=\"field\"\n              [index]=\"rowIndex\"\n              [parent]=\"parent.control\"\n              [dictionaries]=\"dictionaries\"\n            ></ng-container>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchCase=\"'template'\">\n    <ng-container *ngIf=\"$any(template) | fswDynamicBuilderTemplate as ref\">\n      <ng-container\n        *ngTemplateOutlet=\"ref.templateRef; context: { $implicit: config, index: rowIndex }\"\n      ></ng-container>\n    </ng-container>\n  </ng-container>\n  <ng-container *ngSwitchDefault>\n    <span [id]=\"config?.id\"\n      >{{ label }}\n      <strong *ngIf=\"config?.requireClasses\" [ngClass]=\"config?.requireClasses\">*</strong></span\n    >\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], ctorParameters: function () { return [{ type: i2$1.ControlContainer }]; }, propDecorators: { config: [{
                type: Input
            }], dictionaries: [{
                type: Input
            }], rowIndex: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableTdComponent {
    constructor() {
        this.config = null;
        this.rowIndex = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTdComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableTdComponent, selector: "fsw-dynamic-builder-table-td", inputs: { config: "config", rowIndex: "rowIndex" }, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n  <td\n    [width]=\"config['width']\"\n    [colSpan]=\"config['colSpan'] || 1\"\n    [rowSpan]=\"config['rowSpan'] || 1\"\n    [id]=\"config['id']\"\n    [class]=\"config['customClasses']\"\n  >\n    <fsw-dynamic-builder-table-column\n      [config]=\"config\"\n      [rowIndex]=\"rowIndex\"\n    ></fsw-dynamic-builder-table-column>\n  </td>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWDynamicBuilderTableColumnComponent, selector: "fsw-dynamic-builder-table-column", inputs: ["config", "dictionaries", "rowIndex"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTdComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-td', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n  <td\n    [width]=\"config['width']\"\n    [colSpan]=\"config['colSpan'] || 1\"\n    [rowSpan]=\"config['rowSpan'] || 1\"\n    [id]=\"config['id']\"\n    [class]=\"config['customClasses']\"\n  >\n    <fsw-dynamic-builder-table-column\n      [config]=\"config\"\n      [rowIndex]=\"rowIndex\"\n    ></fsw-dynamic-builder-table-column>\n  </td>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { config: [{
                type: Input
            }], rowIndex: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableTbodyComponent {
    constructor() {
        this.config = null;
        this.control = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTbodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableTbodyComponent, selector: "fsw-dynamic-builder-table-tbody", inputs: { config: "config", control: "control" }, ngImport: i0, template: "<ng-container *ngIf=\"config && control\">\n  <ng-container *ngFor=\"let row of config; let index = index\">\n    <ng-container *ngIf=\"row.key; else nonKeyTemplate\">\n      <ng-container *ngIf=\"control.get(row.key) as group\">\n        <tr [formGroup]=\"group | fswForceGroup\" [id]=\"row['id']\" [class]=\"row['customClasses']\">\n          <ng-container *ngFor=\"let column of row['columns']\">\n            <fsw-dynamic-builder-table-td\n              [config]=\"column\"\n              [rowIndex]=\"index\"\n            ></fsw-dynamic-builder-table-td>\n          </ng-container>\n        </tr>\n      </ng-container>\n    </ng-container>\n    <ng-template #nonKeyTemplate>\n      <tr [id]=\"row['id']\" [class]=\"row['customClasses']\">\n        <ng-container *ngFor=\"let column of row['columns']\">\n          <fsw-dynamic-builder-table-td\n            [config]=\"column\"\n            [rowIndex]=\"index\"\n          ></fsw-dynamic-builder-table-td>\n        </ng-container>\n      </tr>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWDynamicBuilderTableTdComponent, selector: "fsw-dynamic-builder-table-td", inputs: ["config", "rowIndex"] }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTbodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-tbody', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config && control\">\n  <ng-container *ngFor=\"let row of config; let index = index\">\n    <ng-container *ngIf=\"row.key; else nonKeyTemplate\">\n      <ng-container *ngIf=\"control.get(row.key) as group\">\n        <tr [formGroup]=\"group | fswForceGroup\" [id]=\"row['id']\" [class]=\"row['customClasses']\">\n          <ng-container *ngFor=\"let column of row['columns']\">\n            <fsw-dynamic-builder-table-td\n              [config]=\"column\"\n              [rowIndex]=\"index\"\n            ></fsw-dynamic-builder-table-td>\n          </ng-container>\n        </tr>\n      </ng-container>\n    </ng-container>\n    <ng-template #nonKeyTemplate>\n      <tr [id]=\"row['id']\" [class]=\"row['customClasses']\">\n        <ng-container *ngFor=\"let column of row['columns']\">\n          <fsw-dynamic-builder-table-td\n            [config]=\"column\"\n            [rowIndex]=\"index\"\n          ></fsw-dynamic-builder-table-td>\n        </ng-container>\n      </tr>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { config: [{
                type: Input
            }], control: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableItemComponent {
    constructor() {
        this.config = null;
        this.dictionaries = null;
        this.rowIndex = null;
        this.control = null;
    }
    get headerConfig() {
        return this.config?.header || null;
    }
    get bodyConfig() {
        return this.config?.body || null;
    }
    get bodyConfigLoop() {
        return this.bodyConfig;
    }
    get bodyConfigManual() {
        return this.bodyConfig;
    }
    get footerConfig() {
        return this.config?.footer || null;
    }
    get loopArray$() {
        const array = getControlFromGroup(this.control, this.bodyConfigLoop.key);
        return array.valueChanges.pipe(startWith(array.value));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableItemComponent, selector: "fsw-dynamic-builder-table-item", inputs: { config: "config", dictionaries: "dictionaries", rowIndex: "rowIndex", control: "control" }, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <ng-container *ngIf=\"headerConfig\">\n    <fsw-dynamic-builder-table-tbody\n      [config]=\"headerConfig\"\n      [control]=\"control\"\n    ></fsw-dynamic-builder-table-tbody>\n  </ng-container>\n  <ng-container *ngIf=\"bodyConfig\">\n    <ng-container *ngIf=\"bodyConfig.isLoop; else bodyManualTemplate\">\n      <ng-container *ngIf=\"control.get(bodyConfigLoop.key) as array\">\n        <ng-container *ngIf=\"loopArray$ | async as loopArray\">\n          <ng-container *ngIf=\"loopArray?.length; else emptyLoopTemplate\">\n            <ng-container *ngFor=\"let group of (array | fswForceArray).controls; let index = index\">\n              <tr\n                [formGroup]=\"group | fswForceGroup\"\n                [id]=\"bodyConfigLoop.data['id']\"\n                [class]=\"bodyConfigLoop.data['customClasses']\"\n              >\n                <ng-container *ngFor=\"let column of bodyConfigLoop.data['columns']\">\n                  <fsw-dynamic-builder-table-td\n                    [config]=\"column\"\n                    [rowIndex]=\"index\"\n                  ></fsw-dynamic-builder-table-td>\n                </ng-container>\n              </tr>\n            </ng-container>\n          </ng-container>\n          <ng-template #emptyLoopTemplate>\n            <ng-container *ngIf=\"bodyConfig.empty as empty\">\n              <ng-container *ngIf=\"empty.emptyTemplateKey | fswDynamicBuilderTemplate as ref\">\n                <tr>\n                  <td [colSpan]=\"empty.emptyTemplateColSpan\">\n                    <ng-container *ngTemplateOutlet=\"ref.templateRef\"></ng-container>\n                  </td>\n                </tr>\n              </ng-container>\n            </ng-container>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-template #bodyManualTemplate>\n      <fsw-dynamic-builder-table-tbody\n        [config]=\"bodyConfigManual.data\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-tbody>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"footerConfig\">\n    <fsw-dynamic-builder-table-tbody\n      [config]=\"footerConfig\"\n      [control]=\"control\"\n    ></fsw-dynamic-builder-table-tbody>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWDynamicBuilderTableTbodyComponent, selector: "fsw-dynamic-builder-table-tbody", inputs: ["config", "control"] }, { kind: "component", type: FSWDynamicBuilderTableTdComponent, selector: "fsw-dynamic-builder-table-td", inputs: ["config", "rowIndex"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }, { kind: "pipe", type: FSWForceArrayPipe, name: "fswForceArray" }, { kind: "pipe", type: FSWDynamicBuilderTemplatePipe, name: "fswDynamicBuilderTemplate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <ng-container *ngIf=\"headerConfig\">\n    <fsw-dynamic-builder-table-tbody\n      [config]=\"headerConfig\"\n      [control]=\"control\"\n    ></fsw-dynamic-builder-table-tbody>\n  </ng-container>\n  <ng-container *ngIf=\"bodyConfig\">\n    <ng-container *ngIf=\"bodyConfig.isLoop; else bodyManualTemplate\">\n      <ng-container *ngIf=\"control.get(bodyConfigLoop.key) as array\">\n        <ng-container *ngIf=\"loopArray$ | async as loopArray\">\n          <ng-container *ngIf=\"loopArray?.length; else emptyLoopTemplate\">\n            <ng-container *ngFor=\"let group of (array | fswForceArray).controls; let index = index\">\n              <tr\n                [formGroup]=\"group | fswForceGroup\"\n                [id]=\"bodyConfigLoop.data['id']\"\n                [class]=\"bodyConfigLoop.data['customClasses']\"\n              >\n                <ng-container *ngFor=\"let column of bodyConfigLoop.data['columns']\">\n                  <fsw-dynamic-builder-table-td\n                    [config]=\"column\"\n                    [rowIndex]=\"index\"\n                  ></fsw-dynamic-builder-table-td>\n                </ng-container>\n              </tr>\n            </ng-container>\n          </ng-container>\n          <ng-template #emptyLoopTemplate>\n            <ng-container *ngIf=\"bodyConfig.empty as empty\">\n              <ng-container *ngIf=\"empty.emptyTemplateKey | fswDynamicBuilderTemplate as ref\">\n                <tr>\n                  <td [colSpan]=\"empty.emptyTemplateColSpan\">\n                    <ng-container *ngTemplateOutlet=\"ref.templateRef\"></ng-container>\n                  </td>\n                </tr>\n              </ng-container>\n            </ng-container>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n    <ng-template #bodyManualTemplate>\n      <fsw-dynamic-builder-table-tbody\n        [config]=\"bodyConfigManual.data\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-tbody>\n    </ng-template>\n  </ng-container>\n  <ng-container *ngIf=\"footerConfig\">\n    <fsw-dynamic-builder-table-tbody\n      [config]=\"footerConfig\"\n      [control]=\"control\"\n    ></fsw-dynamic-builder-table-tbody>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { config: [{
                type: Input
            }], dictionaries: [{
                type: Input
            }], rowIndex: [{
                type: Input
            }], control: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableThComponent {
    constructor() {
        this.config = null;
        this.rowIndex = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableThComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableThComponent, selector: "fsw-dynamic-builder-table-th", inputs: { config: "config", rowIndex: "rowIndex" }, ngImport: i0, template: "<ng-container *ngIf=\"config\">\n  <th\n    [width]=\"config['width']\"\n    [colSpan]=\"config['colSpan'] || 1\"\n    [rowSpan]=\"config['rowSpan'] || 1\"\n    [id]=\"config['id']\"\n    [class]=\"config['customClasses']\"\n  >\n    <fsw-dynamic-builder-table-column\n      [config]=\"config\"\n      [rowIndex]=\"rowIndex\"\n    ></fsw-dynamic-builder-table-column>\n  </th>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: FSWDynamicBuilderTableColumnComponent, selector: "fsw-dynamic-builder-table-column", inputs: ["config", "dictionaries", "rowIndex"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableThComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-th', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config\">\n  <th\n    [width]=\"config['width']\"\n    [colSpan]=\"config['colSpan'] || 1\"\n    [rowSpan]=\"config['rowSpan'] || 1\"\n    [id]=\"config['id']\"\n    [class]=\"config['customClasses']\"\n  >\n    <fsw-dynamic-builder-table-column\n      [config]=\"config\"\n      [rowIndex]=\"rowIndex\"\n    ></fsw-dynamic-builder-table-column>\n  </th>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { config: [{
                type: Input
            }], rowIndex: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableTheadComponent {
    constructor() {
        this.config = null;
        this.control = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTheadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableTheadComponent, selector: "fsw-dynamic-builder-table-thead", inputs: { config: "config", control: "control" }, ngImport: i0, template: "<ng-container *ngIf=\"config && control\">\n  <ng-container *ngFor=\"let row of config; let index = index\">\n    <ng-container *ngIf=\"row.key; else nonKeyTemplate\">\n      <ng-container *ngIf=\"control.get(row.key) as group\">\n        <tr [formGroup]=\"group | fswForceGroup\" [id]=\"row['id']\" [class]=\"row['customClasses']\">\n          <ng-container *ngFor=\"let column of row['columns']\">\n            <fsw-dynamic-builder-table-th\n              [config]=\"column\"\n              [rowIndex]=\"index\"\n            ></fsw-dynamic-builder-table-th>\n          </ng-container>\n        </tr>\n      </ng-container>\n    </ng-container>\n    <ng-template #nonKeyTemplate>\n      <tr [id]=\"row['id']\" [class]=\"row['customClasses']\">\n        <ng-container *ngFor=\"let column of row['columns']\">\n          <fsw-dynamic-builder-table-th\n            [config]=\"column\"\n            [rowIndex]=\"index\"\n          ></fsw-dynamic-builder-table-th>\n        </ng-container>\n      </tr>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWDynamicBuilderTableThComponent, selector: "fsw-dynamic-builder-table-th", inputs: ["config", "rowIndex"] }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableTheadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table-thead', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"config && control\">\n  <ng-container *ngFor=\"let row of config; let index = index\">\n    <ng-container *ngIf=\"row.key; else nonKeyTemplate\">\n      <ng-container *ngIf=\"control.get(row.key) as group\">\n        <tr [formGroup]=\"group | fswForceGroup\" [id]=\"row['id']\" [class]=\"row['customClasses']\">\n          <ng-container *ngFor=\"let column of row['columns']\">\n            <fsw-dynamic-builder-table-th\n              [config]=\"column\"\n              [rowIndex]=\"index\"\n            ></fsw-dynamic-builder-table-th>\n          </ng-container>\n        </tr>\n      </ng-container>\n    </ng-container>\n    <ng-template #nonKeyTemplate>\n      <tr [id]=\"row['id']\" [class]=\"row['customClasses']\">\n        <ng-container *ngFor=\"let column of row['columns']\">\n          <fsw-dynamic-builder-table-th\n            [config]=\"column\"\n            [rowIndex]=\"index\"\n          ></fsw-dynamic-builder-table-th>\n        </ng-container>\n      </tr>\n    </ng-template>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }], propDecorators: { config: [{
                type: Input
            }], control: [{
                type: Input
            }] } });

class FSWDynamicBuilderTableComponent extends FSWDynamicBuilderTableBase {
    get headerConfig() {
        return this.config?.header || null;
    }
    get items() {
        return this.config?.items || null;
    }
    get footerConfig() {
        return this.config?.footer || null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTableComponent, selector: "fsw-dynamic-builder-table", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"control\">\n  <table [id]=\"element?.id\" [class]=\"element?.customClasses\" [formGroup]=\"control\">\n    <thead *ngIf=\"headerConfig\">\n      <fsw-dynamic-builder-table-thead\n        [config]=\"headerConfig\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-thead>\n    </thead>\n    <tbody *ngIf=\"items?.length\">\n      <ng-container *ngFor=\"let item of items; let i = index\">\n        <ng-container *ngIf=\"item.key ? control.get(item.key) : control as itemControl\">\n          <fsw-dynamic-builder-table-item\n            [config]=\"item\"\n            [dictionaries]=\"dictionaries\"\n            [rowIndex]=\"i\"\n            [control]=\"itemControl | fswForceGroup\"\n          ></fsw-dynamic-builder-table-item>\n        </ng-container>\n      </ng-container>\n    </tbody>\n    <tfoot *ngIf=\"footerConfig\">\n      <fsw-dynamic-builder-table-tbody\n        [config]=\"footerConfig\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-tbody>\n    </tfoot>\n  </table>\n</ng-container>\n", styles: [":host{display:contents}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: FSWDynamicBuilderTableItemComponent, selector: "fsw-dynamic-builder-table-item", inputs: ["config", "dictionaries", "rowIndex", "control"] }, { kind: "component", type: FSWDynamicBuilderTableTbodyComponent, selector: "fsw-dynamic-builder-table-tbody", inputs: ["config", "control"] }, { kind: "component", type: FSWDynamicBuilderTableTheadComponent, selector: "fsw-dynamic-builder-table-thead", inputs: ["config", "control"] }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"control\">\n  <table [id]=\"element?.id\" [class]=\"element?.customClasses\" [formGroup]=\"control\">\n    <thead *ngIf=\"headerConfig\">\n      <fsw-dynamic-builder-table-thead\n        [config]=\"headerConfig\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-thead>\n    </thead>\n    <tbody *ngIf=\"items?.length\">\n      <ng-container *ngFor=\"let item of items; let i = index\">\n        <ng-container *ngIf=\"item.key ? control.get(item.key) : control as itemControl\">\n          <fsw-dynamic-builder-table-item\n            [config]=\"item\"\n            [dictionaries]=\"dictionaries\"\n            [rowIndex]=\"i\"\n            [control]=\"itemControl | fswForceGroup\"\n          ></fsw-dynamic-builder-table-item>\n        </ng-container>\n      </ng-container>\n    </tbody>\n    <tfoot *ngIf=\"footerConfig\">\n      <fsw-dynamic-builder-table-tbody\n        [config]=\"footerConfig\"\n        [control]=\"control\"\n      ></fsw-dynamic-builder-table-tbody>\n    </tfoot>\n  </table>\n</ng-container>\n", styles: [":host{display:contents}\n"] }]
        }] });

class FSWDynamicBuilderTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
        this.key = randomId();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderTemplateDirective, selector: "[fswDynamicBuilderTemplate]", inputs: { key: "key" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswDynamicBuilderTemplate]',
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { key: [{
                type: Input
            }] } });

class FSWDynamicBuilderService {
    constructor(mapControl, mapGroup, mapArray, mapTable, mapContainer) {
        this.mapControl = mapControl;
        this.mapGroup = mapGroup;
        this.mapArray = mapArray;
        this.mapTable = mapTable;
        this.mapContainer = mapContainer;
        this._templateMap = new Map();
    }
    queryControl(name, dictionaries = null) {
        const item = dictionaries?.find((d) => d.name === name && d.dictionaryType === FSWDynamicBuilderFormTypes.CONTROL);
        if (item) {
            return item.component;
        }
        const component = this.mapControl?.get(name);
        if (component) {
            return component;
        }
        if (name === FSWDynamicBuilderDefaultNames.CONTROL) {
            return FSWDynamicBuilderControlComponent;
        }
        return null;
    }
    queryGroup(name, dictionaries = null) {
        const item = dictionaries?.find((d) => d.name === name && d.dictionaryType === FSWDynamicBuilderFormTypes.GROUP);
        if (item) {
            return item.component;
        }
        const component = this.mapGroup?.get(name);
        if (component) {
            return component;
        }
        if (name === FSWDynamicBuilderDefaultNames.GROUP) {
            return FSWDynamicBuilderGroupComponent;
        }
        return null;
    }
    queryArray(name, dictionaries = null) {
        const item = dictionaries?.find((d) => d.name === name && d.dictionaryType === FSWDynamicBuilderFormTypes.ARRAY);
        if (item) {
            return item.component;
        }
        const component = this.mapArray?.get(name);
        if (component) {
            return component;
        }
        if (name === FSWDynamicBuilderDefaultNames.ARRAY) {
            return FSWDynamicBuilderArrayComponent;
        }
        return null;
    }
    queryTable(name, dictionaries = null) {
        const item = dictionaries?.find((d) => d.name === name && d.dictionaryType === FSWDynamicBuilderFormTypes.TABLE);
        if (item) {
            return item.component;
        }
        const component = this.mapTable?.get(name);
        if (component) {
            return component;
        }
        if (name === FSWDynamicBuilderDefaultNames.TABLE) {
            return FSWDynamicBuilderTableComponent;
        }
        return null;
    }
    queryContainer(name, dictionaries = null) {
        const item = dictionaries?.find((d) => d.name === name && d.dictionaryType === FSWDynamicBuilderFormTypes.CONTAINER);
        if (item) {
            return item.component;
        }
        const component = this.mapContainer?.get(name);
        if (component) {
            return component;
        }
        if (name === FSWDynamicBuilderDefaultNames.CONTAINER) {
            return FSWDynamicBuilderContainerComponent;
        }
        return null;
    }
    query(item, dictionaries = null) {
        switch (item.formType) {
            case FSWDynamicBuilderFormTypes.GROUP:
                return this.queryGroup(item.name || FSWDynamicBuilderDefaultNames.GROUP, dictionaries);
            case FSWDynamicBuilderFormTypes.ARRAY:
                return this.queryArray(item.name || FSWDynamicBuilderDefaultNames.ARRAY, dictionaries);
            case FSWDynamicBuilderFormTypes.TABLE:
                return this.queryTable(item.name || FSWDynamicBuilderDefaultNames.TABLE, dictionaries);
            default:
                return this.queryControl(item.name || FSWDynamicBuilderDefaultNames.CONTROL, dictionaries);
        }
    }
    getTemplate(key, group) {
        const value = this._templateMap.get(group);
        return value?.find((template) => template.key == key) || null;
    }
    setTemplates(templates, group) {
        this._templateMap.set(group, templates);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderService, deps: [{ token: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN, optional: true }, { token: FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN, optional: true }, { token: FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN, optional: true }, { token: FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN, optional: true }, { token: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN]
                }] }]; } });

class FSWDynamicBuilderComponent {
    set templates(value) {
        this._service.setTemplates(value.toArray(), this._groupId);
    }
    get groupId() {
        return this._groupId;
    }
    constructor(parent, _service) {
        this.parent = parent;
        this._service = _service;
        this.builder = null;
        this.dictionaries = null;
        this.FSWDynamicBuilderRenderTypes = FSWDynamicBuilderFormTypes;
        this._groupId = randomId();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderComponent, deps: [{ token: i2$1.ControlContainer, optional: true }, { token: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FSWDynamicBuilderComponent, selector: "fsw-dynamic-builder", inputs: { builder: "builder", dictionaries: "dictionaries" }, providers: [
            {
                provide: FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN,
                useExisting: FSWDynamicBuilderComponent,
            },
        ], queries: [{ propertyName: "templates", predicate: FSWDynamicBuilderTemplateDirective }], ngImport: i0, template: "<section class=\"fsw-dynamic-builder\" *ngIf=\"builder && builder.config\">\n  <ng-container [ngSwitch]=\"builder.config.formType\">\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.ARRAY\">\n      <fsw-dynamic-builder-array\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceArray\"\n        [config]=\"builder.arrayConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-array>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.TABLE\">\n      <fsw-dynamic-builder-table\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceGroup\"\n        [config]=\"builder.tableConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-table>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.GROUP\">\n      <fsw-dynamic-builder-group\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceGroup\"\n        [config]=\"builder.groupConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-group>\n    </ng-container>\n  </ng-container>\n</section>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: FSWDynamicBuilderArrayComponent, selector: "fsw-dynamic-builder-array" }, { kind: "component", type: FSWDynamicBuilderGroupComponent, selector: "fsw-dynamic-builder-group" }, { kind: "component", type: FSWDynamicBuilderTableComponent, selector: "fsw-dynamic-builder-table" }, { kind: "pipe", type: FSWForceGroupPipe, name: "fswForceGroup" }, { kind: "pipe", type: FSWForceArrayPipe, name: "fswForceArray" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fsw-dynamic-builder', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        {
                            provide: FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN,
                            useExisting: FSWDynamicBuilderComponent,
                        },
                    ], template: "<section class=\"fsw-dynamic-builder\" *ngIf=\"builder && builder.config\">\n  <ng-container [ngSwitch]=\"builder.config.formType\">\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.ARRAY\">\n      <fsw-dynamic-builder-array\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceArray\"\n        [config]=\"builder.arrayConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-array>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.TABLE\">\n      <fsw-dynamic-builder-table\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceGroup\"\n        [config]=\"builder.tableConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-table>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"FSWDynamicBuilderRenderTypes.GROUP\">\n      <fsw-dynamic-builder-group\n        [dictionaries]=\"dictionaries\"\n        [control]=\"builder.config.form | fswForceGroup\"\n        [config]=\"builder.groupConfig\"\n        [element]=\"builder.element\"\n      ></fsw-dynamic-builder-group>\n    </ng-container>\n  </ng-container>\n</section>\n" }]
        }], ctorParameters: function () { return [{ type: i2$1.ControlContainer, decorators: [{
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_DYNAMIC_BUILDER_SERVICE_TOKEN]
                }] }]; }, propDecorators: { builder: [{
                type: Input
            }], dictionaries: [{
                type: Input
            }], templates: [{
                type: ContentChildren,
                args: [FSWDynamicBuilderTemplateDirective]
            }] } });

const CONTROLS = [
    FSWDynamicBuilderCheckboxGroupComponent,
    FSWDynamicBuilderInputComponent,
    FSWDynamicBuilderRadioGroupComponent,
    FSWDynamicBuilderSelectComponent,
    FSWDynamicBuilderSwitchComponent,
    FSWDynamicBuilderCheckboxComponent,
    FSWDynamicBuilderDateTimePickerComponent,
    FSWDynamicBuilderTemplateComponent,
];
const DIRECTIVES = [
    FSWDynamicBuilderControlDirective,
    FSWDynamicBuilderTemplateDirective,
    FSWDynamicBuilderItemDirective,
    FSWDynamicBuilderContainerDirective,
];
const COMPONENTS = [
    FSWDynamicBuilderArrayComponent,
    FSWDynamicBuilderControlComponent,
    FSWDynamicBuilderGroupComponent,
    FSWDynamicBuilderContainerComponent,
    FSWDynamicBuilderTableComponent,
    FSWDynamicBuilderTableColumnComponent,
    FSWDynamicBuilderTableItemComponent,
    FSWDynamicBuilderTableTbodyComponent,
    FSWDynamicBuilderTableTdComponent,
    FSWDynamicBuilderTableTheadComponent,
    FSWDynamicBuilderTableThComponent,
];
const PIPES = [FSWDynamicBuilderTemplatePipe];
class FSWDynamicBuilderModule {
    static forRoot(dictionaries = []) {
        const { mapArray, mapControl, mapGroup, mapContainer, mapTable } = this.resolveMap(dictionaries);
        return {
            ngModule: FSWDynamicBuilderModule,
            providers: [
                {
                    provide: FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN,
                    useValue: mapArray,
                },
                {
                    provide: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN,
                    useValue: mapControl,
                },
                {
                    provide: FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN,
                    useValue: mapGroup,
                },
                {
                    provide: FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN,
                    useValue: mapTable,
                },
                {
                    provide: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN,
                    useValue: mapContainer,
                },
            ],
        };
    }
    static forFeature(dictionaries = []) {
        const { mapArray, mapControl, mapGroup, mapContainer, mapTable, emptyControl, emptyGroup, emptyContainer, emptyArray, emptyTable, } = this.resolveMap(dictionaries);
        const providers = [];
        !emptyControl &&
            providers.push({
                provide: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN,
                useValue: mapControl,
            });
        !emptyContainer &&
            providers.push({
                provide: FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN,
                useValue: mapContainer,
            });
        !emptyGroup &&
            providers.push({
                provide: FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN,
                useValue: mapGroup,
            });
        !emptyArray &&
            providers.push({
                provide: FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN,
                useValue: mapArray,
            });
        !emptyTable &&
            providers.push({
                provide: FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN,
                useValue: mapTable,
            });
        return {
            ngModule: FSWDynamicBuilderModule,
            providers,
        };
    }
    static resolveMap(dictionaries = []) {
        const mapArray = new Map();
        const mapControl = new Map();
        const mapTable = new Map();
        const mapGroup = new Map();
        const mapContainer = new Map();
        for (let i = 0; i < dictionaries.length; i++) {
            const dictionary = dictionaries[i];
            switch (dictionary.dictionaryType) {
                case FSWDynamicBuilderFormTypes.ARRAY:
                    mapArray.set(dictionary.name, dictionary.component);
                    break;
                case FSWDynamicBuilderFormTypes.CONTAINER:
                    mapContainer.set(dictionary.name, dictionary.component);
                    break;
                case FSWDynamicBuilderFormTypes.CONTROL:
                    mapControl.set(dictionary.name, dictionary.component);
                    break;
                case FSWDynamicBuilderFormTypes.TABLE:
                    mapTable.set(dictionary.name, dictionary.component);
                    break;
                case FSWDynamicBuilderFormTypes.GROUP:
                    mapGroup.set(dictionary.name, dictionary.component);
                    break;
                default:
                    break;
            }
        }
        return {
            mapArray,
            mapControl,
            mapGroup,
            mapContainer,
            mapTable,
            emptyControl: mapControl.size === 0,
            emptyArray: mapArray.size === 0,
            emptyGroup: mapGroup.size === 0,
            emptyContainer: mapContainer.size === 0,
            emptyTable: mapTable.size === 0,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderModule, declarations: [FSWDynamicBuilderCheckboxGroupComponent,
            FSWDynamicBuilderInputComponent,
            FSWDynamicBuilderRadioGroupComponent,
            FSWDynamicBuilderSelectComponent,
            FSWDynamicBuilderSwitchComponent,
            FSWDynamicBuilderCheckboxComponent,
            FSWDynamicBuilderDateTimePickerComponent,
            FSWDynamicBuilderTemplateComponent, FSWDynamicBuilderControlDirective,
            FSWDynamicBuilderTemplateDirective,
            FSWDynamicBuilderItemDirective,
            FSWDynamicBuilderContainerDirective, FSWDynamicBuilderArrayComponent,
            FSWDynamicBuilderControlComponent,
            FSWDynamicBuilderGroupComponent,
            FSWDynamicBuilderContainerComponent,
            FSWDynamicBuilderTableComponent,
            FSWDynamicBuilderTableColumnComponent,
            FSWDynamicBuilderTableItemComponent,
            FSWDynamicBuilderTableTbodyComponent,
            FSWDynamicBuilderTableTdComponent,
            FSWDynamicBuilderTableTheadComponent,
            FSWDynamicBuilderTableThComponent, FSWDynamicBuilderTemplatePipe, FSWDynamicBuilderComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWCheckboxModule,
            FSWInputModule,
            FSWIconModule,
            FSWCheckboxModule,
            FSWSelectModule,
            FSWSwitchModule,
            FSWDateTimePickerModule,
            FSWRadioModule,
            ForceGroupPipeModule,
            ForceArrayPipeModule,
            FSWValueChangesPipeModule,
            FSWHasErrorPipeModule,
            NgxMaskDirective], exports: [FSWDynamicBuilderCheckboxGroupComponent,
            FSWDynamicBuilderInputComponent,
            FSWDynamicBuilderRadioGroupComponent,
            FSWDynamicBuilderSelectComponent,
            FSWDynamicBuilderSwitchComponent,
            FSWDynamicBuilderCheckboxComponent,
            FSWDynamicBuilderDateTimePickerComponent,
            FSWDynamicBuilderTemplateComponent, FSWDynamicBuilderControlDirective,
            FSWDynamicBuilderTemplateDirective,
            FSWDynamicBuilderItemDirective,
            FSWDynamicBuilderContainerDirective, FSWDynamicBuilderArrayComponent,
            FSWDynamicBuilderControlComponent,
            FSWDynamicBuilderGroupComponent,
            FSWDynamicBuilderContainerComponent,
            FSWDynamicBuilderTableComponent,
            FSWDynamicBuilderTableColumnComponent,
            FSWDynamicBuilderTableItemComponent,
            FSWDynamicBuilderTableTbodyComponent,
            FSWDynamicBuilderTableTdComponent,
            FSWDynamicBuilderTableTheadComponent,
            FSWDynamicBuilderTableThComponent, FSWDynamicBuilderTemplatePipe, FSWDynamicBuilderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderModule, providers: [
            {
                provide: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN,
                useClass: FSWDynamicBuilderService,
            },
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FSWFieldModule,
            FSWCheckboxModule,
            FSWInputModule,
            FSWIconModule,
            FSWCheckboxModule,
            FSWSelectModule,
            FSWSwitchModule,
            FSWDateTimePickerModule,
            FSWRadioModule,
            ForceGroupPipeModule,
            ForceArrayPipeModule,
            FSWValueChangesPipeModule,
            FSWHasErrorPipeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWDynamicBuilderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CONTROLS, DIRECTIVES, COMPONENTS, PIPES, FSWDynamicBuilderComponent],
                    exports: [CONTROLS, DIRECTIVES, COMPONENTS, PIPES, FSWDynamicBuilderComponent],
                    providers: [
                        {
                            provide: FSW_DYNAMIC_BUILDER_SERVICE_TOKEN,
                            useClass: FSWDynamicBuilderService,
                        },
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FSWFieldModule,
                        FSWCheckboxModule,
                        FSWInputModule,
                        FSWIconModule,
                        FSWCheckboxModule,
                        FSWSelectModule,
                        FSWSwitchModule,
                        FSWDateTimePickerModule,
                        FSWRadioModule,
                        ForceGroupPipeModule,
                        ForceArrayPipeModule,
                        FSWValueChangesPipeModule,
                        FSWHasErrorPipeModule,
                        NgxMaskDirective,
                    ],
                }]
        }] });

class NumberRunningDirective {
    constructor(_elementRef, _ngZone) {
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        this.value = 0;
        this._startTimestamp = null;
        this._decimalPipe = new DecimalPipe('en-IN');
        this.step = (timestamp) => {
            if (!this._startTimestamp)
                this._startTimestamp = timestamp;
            const progress = Math.min((timestamp - this._startTimestamp) / 1500, 1);
            this._elementRef.nativeElement.innerHTML = this._decimalPipe.transform(Math.floor(progress * this.value), '.2');
            if (progress < 1) {
                window.requestAnimationFrame(this.step);
            }
        };
    }
    ngOnChanges() {
        this._ngZone.runOutsideAngular(() => {
            this.animate();
        });
    }
    animate() {
        window.requestAnimationFrame(this.step);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: NumberRunningDirective, selector: "[fswNumberRunning]", inputs: { value: ["fswNumberRunning", "value"] }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fswNumberRunning]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { value: [{
                type: Input,
                args: ['fswNumberRunning']
            }] } });

class NumberRunningModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, declarations: [NumberRunningDirective], exports: [NumberRunningDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberRunningModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NumberRunningDirective],
                    exports: [NumberRunningDirective],
                }]
        }] });

const FSW_TRANSLATE_FEATURE_CONFIG_TOKEN = new InjectionToken('FSW_TRANSLATE_FEATURE_CONFIG_TOKEN');

const FSW_TRANSLATE_LISTENER_TOKEN = new InjectionToken('FSW_TRANSLATE_LISTENER_TOKEN');

const FSW_TRANSLATE_PATH_TOKEN = new InjectionToken('FSW_TRANSLATE_PATH_TOKEN');

const FSW_TRANSLATE_SERVICE_TOKEN = new InjectionToken('FSW_TRANSLATE_SERVICE_TOKEN');

const FSW_TRANSLATE_DATA_TOKEN = new InjectionToken('FSW_TRANSLATE_DATA_TOKEN');

const FSW_TRANSLATE_SCOPE_TOKEN = new InjectionToken('FSW_TRANSLATE_SCOPE_TOKEN');

const fswTranslateScope = (scope) => ({
    provide: FSW_TRANSLATE_SCOPE_TOKEN,
    useValue: scope,
});

class FSWTranslateService {
    constructor(_listener$, _path, _data$, _featureConfigs) {
        this._listener$ = _listener$;
        this._path = _path;
        this._data$ = _data$;
        this._featureConfigs = _featureConfigs;
        this._internalData = null;
        this.listener$ = this._setupListener$();
        this._autoUpdateData();
    }
    select$(pattern, scope) {
        if (scope) {
            return this._getFeatureListener$(scope).pipe(map((data) => this._select(pattern, data)));
        }
        return this._data$.pipe(map((data) => this._select(pattern, data)));
    }
    selectMultiple$(array, scope) {
        if (scope) {
            return this._getFeatureListener$(scope).pipe(map((data) => this._selectMultiple(array, data)));
        }
        return this._data$.pipe(map((data) => this._selectMultiple(array, data)));
    }
    switchTranslateKey(key) {
        this.listener$.next(key);
    }
    select(pattern, scope) {
        if (scope) {
            return this._select(pattern, this._getFeatureData(scope));
        }
        return this._select(pattern, this._internalData || {});
    }
    selectMultiple(array, scope) {
        if (scope) {
            return this._selectMultiple(array, this._getFeatureData(scope));
        }
        return this._selectMultiple(array, this._internalData || {});
    }
    _selectMultiple(array, data) {
        return array.reduce((value, item) => {
            return {
                [item.key]: this._select(item.pattern, data),
                ...value,
            };
        }, {});
    }
    _select(pattern, data = {}) {
        if (!data || !Object.keys(data).length) {
            return pattern;
        }
        const resolvedPattern = pattern.trim().replace(' ', '');
        if (resolvedPattern.includes('.')) {
            const keys = resolvedPattern.split('.').filter((key) => !!key);
            let value = data[keys[0]];
            for (let i = 1; i < keys.length; i++) {
                const key = keys[i];
                if (value == null || typeof value === 'string') {
                    throw new Error(`Not found this translation key <<${key}>>`);
                }
                else {
                    value = value[key];
                }
            }
            return (value ?? pattern);
        }
        else {
            return (data[resolvedPattern] ?? pattern);
        }
    }
    _setupListener$() {
        if (this._listener$) {
            return this._listener$;
        }
        console.warn("Current application doesn't setup config for root");
        return new BehaviorSubject('');
    }
    _getFeatureListener$(scope) {
        const config = this._getConfigByScope(scope);
        return this.listener$.pipe(map((translateKey) => {
            translateKey = translateKey || config.defaultKey;
            return config.data[translateKey];
        }));
    }
    _getFeatureData(scope) {
        const config = this._getConfigByScope(scope);
        const translateKey = this.listener$.value || config.defaultKey;
        return config.data[translateKey];
    }
    _getConfigByScope(scope) {
        const config = this._featureConfigs?.find((item) => item.scope === scope);
        if (!config) {
            throw new Error(`Can't find scope ${scope} in current configuration`);
        }
        return config;
    }
    _autoUpdateData() {
        if (!this._data$) {
            return;
        }
        this._data$.pipe(tap((data) => (this._internalData = data))).subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateService, deps: [{ token: FSW_TRANSLATE_LISTENER_TOKEN, optional: true }, { token: FSW_TRANSLATE_PATH_TOKEN, optional: true }, { token: FSW_TRANSLATE_DATA_TOKEN, optional: true }, { token: FSW_TRANSLATE_FEATURE_CONFIG_TOKEN, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.BehaviorSubject, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_TRANSLATE_LISTENER_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_TRANSLATE_PATH_TOKEN]
                }] }, { type: i1$2.Observable, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [FSW_TRANSLATE_DATA_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_FEATURE_CONFIG_TOKEN]
                }, {
                    type: Optional
                }] }]; } });

let FSWTranslatePipe = class FSWTranslatePipe {
    constructor(_translateService, _scope, _cdr) {
        this._translateService = _translateService;
        this._scope = _scope;
        this._cdr = _cdr;
        this._latestValue = '';
        this._triggered = false;
        this._pattern$ = new BehaviorSubject('');
        this._params$ = new BehaviorSubject({});
    }
    transform(pattern, params = {}) {
        if (!pattern)
            return '';
        this._pattern$.next(pattern);
        this._params$.next(params);
        this.subscribe();
        return this._latestValue;
    }
    subscribe() {
        if (this._triggered)
            return;
        this._triggered = true;
        const obs$ = combineLatest([this._pattern$.asObservable(), this._params$.asObservable()]).pipe(switchMap(([pattern, params]) => {
            const { scope, data } = params;
            const mappingData = Object.assign({}, data || {});
            return this._translateService.select$(pattern, scope || this._scope).pipe(tap((value) => {
                this._latestValue = typeof value === 'string' ? value : pattern;
                Object.keys(mappingData).forEach((key) => {
                    this._latestValue = this._latestValue.split(`{{${key}}}`).join(mappingData[key]);
                });
                this._cdr.markForCheck();
            }), catchError((err) => {
                this._latestValue = pattern;
                return throwError(() => err);
            }));
        }));
        obs$.subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslatePipe, deps: [{ token: FSW_TRANSLATE_SERVICE_TOKEN }, { token: FSW_TRANSLATE_SCOPE_TOKEN, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslatePipe, name: "fswTranslate", pure: false }); }
};
FSWTranslatePipe = __decorate([
    autoDestroy(),
    __metadata("design:paramtypes", [Object, String, ChangeDetectorRef])
], FSWTranslatePipe);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'fswTranslate',
                    pure: false,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SERVICE_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FSW_TRANSLATE_SCOPE_TOKEN]
                }, {
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }]; } });

class FSWTranslateModule {
    static forApplication(config) {
        return {
            ngModule: FSWTranslateModule,
            providers: [
                {
                    provide: FSW_TRANSLATE_PATH_TOKEN,
                    useValue: config.absolutePath,
                },
                {
                    provide: FSW_TRANSLATE_LISTENER_TOKEN,
                    useValue: new BehaviorSubject(config.defaultKey),
                },
                {
                    provide: FSW_TRANSLATE_DATA_TOKEN,
                    useFactory: (httpClient, listener$, path) => {
                        return listener$
                            .asObservable()
                            .pipe(concatMap((translateKey) => httpClient.get(`${path}/${translateKey}.json`)));
                    },
                    deps: [HttpClient, FSW_TRANSLATE_LISTENER_TOKEN, FSW_TRANSLATE_PATH_TOKEN],
                },
            ],
        };
    }
    static forFeature(config) {
        const isIndividual = !isArray(config);
        return {
            ngModule: FSWTranslateModule,
            providers: [
                ...(isIndividual
                    ? [
                        {
                            provide: FSW_TRANSLATE_FEATURE_CONFIG_TOKEN,
                            useValue: config,
                            multi: true,
                        },
                    ]
                    : config.map((item) => ({
                        provide: FSW_TRANSLATE_FEATURE_CONFIG_TOKEN,
                        useValue: item,
                        multi: true,
                    }))),
                {
                    provide: FSW_TRANSLATE_SERVICE_TOKEN,
                    useClass: FSWTranslateService,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateModule, declarations: [FSWTranslatePipe], exports: [FSWTranslatePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateModule, providers: [
            {
                provide: FSW_TRANSLATE_SERVICE_TOKEN,
                useClass: FSWTranslateService,
            },
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FSWTranslateModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        {
                            provide: FSW_TRANSLATE_SERVICE_TOKEN,
                            useClass: FSWTranslateService,
                        },
                    ],
                    declarations: [FSWTranslatePipe],
                    exports: [FSWTranslatePipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionGroupComponent, FSWAccordionAppearances, FSWAccordionBase, FSWAccordionComponent, FSWAccordionDirections, FSWAccordionIcons, FSWAccordionModule, FSWAlertBodyDirective, FSWAlertComponent, FSWAlertFooterDirective, FSWAlertHorizontalPositions, FSWAlertHostComponent, FSWAlertModule, FSWAlertService, FSWAlertSizes, FSWAlertStatusPipePipe, FSWAlertStatuses, FSWAlertVerticalPositions, FSWApplicationService, FSWApplicationServiceModule, FSWBadgeBase, FSWBadgeColors, FSWBadgeComponent, FSWBadgeDirective, FSWBadgeModule, FSWBreadcrumbComponent, FSWBreadcrumbModule, FSWButtonAppearances, FSWButtonBase, FSWButtonComponent, FSWButtonDirective, FSWButtonIconSizePipe, FSWButtonModule, FSWButtonSizes, FSWCardComponent, FSWCardDirections, FSWCardImageSizes, FSWCardModule, FSWCheckboxBase, FSWCheckboxComponent, FSWCheckboxDescriptionDirective, FSWCheckboxDirections, FSWCheckboxGroupBase, FSWCheckboxGroupComponent, FSWCheckboxLabelDirective, FSWCheckboxModule, FSWCheckboxSizes, FSWCheckboxStyles, FSWComboPickerBaseModel, FSWControlBase, FSWControlTypes, FSWDatePickerBase, FSWDatePickerComponent, FSWDateTimePickerActiveDayPipe, FSWDateTimePickerActiveDirective, FSWDateTimePickerActiveHourPipe, FSWDateTimePickerActiveMinutePipe, FSWDateTimePickerActiveMonthPipe, FSWDateTimePickerActiveRangePipe, FSWDateTimePickerActiveYearPipe, FSWDateTimePickerBase, FSWDateTimePickerBoxDirective, FSWDateTimePickerControllerComponent, FSWDateTimePickerDayBoxComponent, FSWDateTimePickerLabelDirective, FSWDateTimePickerModule, FSWDateTimePickerMonthBoxComponent, FSWDateTimePickerPrefixDirective, FSWDateTimePickerSuffixDirective, FSWDateTimePickerTargetBase, FSWDateTimePickerTargetComponent, FSWDateTimePickerTimeBoxComponent, FSWDateTimePickerYearBoxComponent, FSWDayPickerBase, FSWDropdownDirective, FSWDropdownEvents, FSWDropdownModule, FSWDynamicBuilder, FSWDynamicBuilderArrayBase, FSWDynamicBuilderArrayComponent, FSWDynamicBuilderCheckboxComponent, FSWDynamicBuilderCheckboxGroupComponent, FSWDynamicBuilderComponent, FSWDynamicBuilderContainerBase, FSWDynamicBuilderContainerComponent, FSWDynamicBuilderContainerDirective, FSWDynamicBuilderControlBase, FSWDynamicBuilderControlComponent, FSWDynamicBuilderControlDirective, FSWDynamicBuilderControlTypes, FSWDynamicBuilderDateTimePickerComponent, FSWDynamicBuilderDefaultBase, FSWDynamicBuilderDefaultNames, FSWDynamicBuilderFormBase, FSWDynamicBuilderFormTypes, FSWDynamicBuilderGroupBase, FSWDynamicBuilderGroupComponent, FSWDynamicBuilderHiddenFields, FSWDynamicBuilderInputComponent, FSWDynamicBuilderItemDirective, FSWDynamicBuilderModule, FSWDynamicBuilderRadioGroupComponent, FSWDynamicBuilderRootTypes, FSWDynamicBuilderSelectComponent, FSWDynamicBuilderService, FSWDynamicBuilderSwitchComponent, FSWDynamicBuilderTableBase, FSWDynamicBuilderTableColumnComponent, FSWDynamicBuilderTableComponent, FSWDynamicBuilderTableItemComponent, FSWDynamicBuilderTableTbodyComponent, FSWDynamicBuilderTableTdComponent, FSWDynamicBuilderTableThComponent, FSWDynamicBuilderTableTheadComponent, FSWDynamicBuilderTemplateComponent, FSWDynamicBuilderTemplateDirective, FSWDynamicBuilderTemplatePipe, FSWFieldBase, FSWFieldComponent, FSWFieldFooterPrefixDirective, FSWFieldFooterPrefixKind, FSWFieldFooterSuffixDirective, FSWFieldFooterSuffixKind, FSWFieldHeaderPrefixDirective, FSWFieldHeaderPrefixKind, FSWFieldHeaderSuffixDirective, FSWFieldHeaderSuffixKind, FSWFieldInputPrefixDirective, FSWFieldInputSuffixDirective, FSWFieldModule, FSWFieldPasswordControlComponent, FSWFieldReadonlyDirective, FSWFieldSizes, FSWForceArrayPipe, FSWForceControlPipe, FSWForceGroupPipe, FSWHasErrorPipe, FSWHasErrorPipeModule, FSWIconCommons, FSWIconCountries, FSWIconDirective, FSWIconFinancingProducts, FSWIconFolders, FSWIconModule, FSWIconSocials, FSWIconStatuses, FSWIndicatorComponent, FSWIndicatorDirections, FSWIndicatorModule, FSWIndicatorStatuses, FSWInputBase, FSWInputDirective, FSWInputMaxDirective, FSWInputMaxLengthDirective, FSWInputMinDirective, FSWInputMinLengthDirective, FSWInputModule, FSWInputPatternDirective, FSWLinkBase, FSWLinkColors, FSWLinkDirective, FSWLinkModule, FSWModalBodyDirective, FSWModalButtonDirections, FSWModalButtonStyles, FSWModalComponent, FSWModalFooterDirective, FSWModalModule, FSWModalSizes, FSWMonthPickerBase, FSWMonthPickerComponent, FSWPaginationComponent, FSWPaginationModule, FSWPanelComponent, FSWPanelHeaderSuffixDirective, FSWPanelModule, FSWRadioBase, FSWRadioComponent, FSWRadioDescriptionDirective, FSWRadioDirections, FSWRadioGroupBase, FSWRadioGroupComponent, FSWRadioLabelDirective, FSWRadioModule, FSWRadioSizes, FSWRadioStyles, FSWRangePickerBase, FSWRangePickerComponent, FSWSelectBase, FSWSelectComponent, FSWSelectContainerComponent, FSWSelectItemComponent, FSWSelectItemDirective, FSWSelectItemIcon, FSWSelectItemKind, FSWSelectItemTextSize, FSWSelectModule, FSWSelectPrefixDirective, FSWSwitchBase, FSWSwitchComponent, FSWSwitchLabelDirective, FSWSwitchModule, FSWSwitchSizes, FSWTabsBackgroundStyles, FSWTabsBase, FSWTabsComponent, FSWTabsDirective, FSWTabsGroupBase, FSWTabsGroupComponent, FSWTabsModule, FSWTabsSizes, FSWTabsStatuses, FSWTabsStyles, FSWTagsBase, FSWTagsColors, FSWTagsComponent, FSWTagsDirective, FSWTagsModule, FSWTagsSizes, FSWTagsStyles, FSWTimePickerBase, FSWTimePickerComponent, FSWTooltipBase, FSWTooltipComponent, FSWTooltipDirective, FSWTooltipModule, FSWTooltipSizes, FSWTranslateModule, FSWTranslatePipe, FSWTranslateService, FSWValueChangesPipe, FSWValueChangesPipeModule, FSWYearPickerBase, FSWYearPickerComponent, FSW_ALERT_CONFIG_TOKEN, FSW_ALERT_SERVICE_TOKEN, FSW_APPLICATION_SERVICE_TOKEN, FSW_CHECKBOX_ACCESSOR, FSW_CHECKBOX_GROUP_ACCESSOR, FSW_CHECKBOX_GROUP_TOKEN, FSW_DATE_PICKER_ACCESSOR, FSW_DATE_PICKER_DAY_BOX_ACCESSOR, FSW_DATE_PICKER_MONTH_BOX_ACCESSOR, FSW_DATE_PICKER_TIME_BOX_ACCESSOR, FSW_DATE_PICKER_YEAR_BOX_ACCESSOR, FSW_DYNAMIC_BUILDER_COMPONENT_TOKEN, FSW_DYNAMIC_BUILDER_DICTIONARY_ARRAY_TOKEN, FSW_DYNAMIC_BUILDER_DICTIONARY_CONTAINER_TOKEN, FSW_DYNAMIC_BUILDER_DICTIONARY_CONTROL_TOKEN, FSW_DYNAMIC_BUILDER_DICTIONARY_GROUP_TOKEN, FSW_DYNAMIC_BUILDER_DICTIONARY_TABLE_TOKEN, FSW_DYNAMIC_BUILDER_SERVICE_TOKEN, FSW_MONTH_PICKER_ACCESSOR, FSW_RADIO_GROUP_ACCESSOR, FSW_RADIO_GROUP_TOKEN, FSW_RANGE_PICKER_ACCESSOR, FSW_SELECT_ACCESSOR, FSW_SWITCH_ACCESSOR, FSW_TABS_GROUP_TOKEN, FSW_TIME_PICKER_ACCESSOR, FSW_TRANSLATE_DATA_TOKEN, FSW_TRANSLATE_FEATURE_CONFIG_TOKEN, FSW_TRANSLATE_LISTENER_TOKEN, FSW_TRANSLATE_PATH_TOKEN, FSW_TRANSLATE_SCOPE_TOKEN, FSW_TRANSLATE_SERVICE_TOKEN, FSW_YEAR_PICKER_ACCESSOR, ForceArrayPipeModule, ForceControlPipeModule, ForceGroupPipeModule, NumberRunningDirective, NumberRunningModule, assignControl, assignData, autoDestroy, createFormArray, createFormControl, createFormGroup, createFormGroupByContainers, createFormGroupByFields, createFormTable, createFormTableBodyLoop, createFormTableItem, createFormTableRow, defineArrayLoading, defineArrayReadonly, defineControlLoading, defineControlReadonly, defineDynamicBuilderAbsoluteKey, defineDynamicBuilderLoading, defineDynamicBuilderReadonly, defineDynamicBuilderSetLoading, defineDynamicBuilderSetReadonly, defineGroupLoading, defineGroupReadonly, defineHiddenProp, fadeIn, followDestroy, fswTranslateScope, getContainerFields, getControlFromArray, getControlFromGroup, getControlFromGroupByGroupPath, getDynamicBuilderAbsoluteKey, getDynamicBuilderAbsoluteKeyWithPrefix, getDynamicBuilderHiddenControls, getDynamicBuilderLoading, getDynamicBuilderReadonly, getDynamicBuilderSetLoading, getDynamicBuilderSetReadonly, getHiddenPropValue, notification, randomId, removeAllControlsOfFormGroup, removeDynamicBuilderHiddenControls, removeExistedControlOfFormGroup, setDynamicBuilderHiddenControls, setupFormArray, setupFormGroup, setupFormTable, setupFormTableBody, setupFormTableBodyLoop, setupFormTableFooter, setupFormTableHeader, setupFormTableItem, setupFormTableRow, slideIn, timeReset, transformItemToControl };
